/*!
 * vue-low-code v0.4.46
 * (c) Klaus Schaefers
 * Released under the BSD-2-Clause License.
 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Vue = require('vue');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);

    this.logLevel = 0;
  }

  _createClass(Logger, [{
    key: "setLogLevel",
    value: function setLogLevel(l) {
      this.logLevel = l;
    }
  }, {
    key: "warn",
    value: function warn(msg, obj) {
      if (obj !== undefined) {
        console.warn(msg, obj);
      } else {
        console.warn(msg);
      }
    }
  }, {
    key: "error",
    value: function error(msg, obj) {
      if (obj !== undefined) {
        console.error(msg, obj);
      } else {
        console.error(msg);
      }
    }
  }, {
    key: "log",
    value: function log(level, msg, obj) {
      var obj2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

      if (level < this.logLevel) {
        if (obj !== undefined) {
          console.debug(msg, obj, obj2);
        } else {
          console.debug(msg);
        }
      }
    }
  }]);

  return Logger;
}();

var Logger$1 = new Logger();

function getFileName(name) {
  return name.replace(/\s/g, '_');
}
function hasChildren(widget) {
  return widget.children && widget.children.length > 0;
}
function isScreen(e) {
  return e.type === 'Screen';
}
/**
 * Advanced widgets cannot have children, e.g. stacked rings
 */

function canHaveChildren(element) {
  if (element.props && element.props.customComponent) {
    return false;
  }

  if (isContainerElement(element) || isInputElement(element)) {
    return true;
  }

  return false;
}
function isInputElement(element) {
  var type = element.type;
  return type === 'TextBox' || type === 'TextArea' || type === 'Password';
}
function isContainerElement(element) {
  var type = element.type;
  return type === 'Box' || type === 'Button' || type === 'Image' || type === 'ChildrenToggle' || type === 'Repeater';
}
/**
 * Check if the child can be nested in a parent
 * @param {} child The child to be nested
 * @param {*} parent The parent to receiveo
 */

function canBeChild(child, parent) {
  /**
   * Costum widgets cannot have children
   */
  if (parent.props && parent.props.customComponent) {
    return false;
  }
  /**
   * Box likes element can always have children
   */


  if (isContainerElement(parent)) {
    return true;
  }
  /**
   * Input elements can have labels embedded. This is needed to attach the label later
   */


  if (isInputElement(parent) && child.type === 'Label') {
    return true;
  }

  return false;
}
/**
 * Determine if the grid is collection
 * of stacked rows
 */

function isRowGrid(widget) {
  var hasOverlaps = false;

  if (widget) {
    var nodes = widget.children;
    nodes.forEach(function (a) {
      nodes.forEach(function (b) {
        if (a.id !== b.id) {
          if (isOverLappingY(a, b)) {
            hasOverlaps = true;
          }
        }
      });
    });
  }

  return !hasOverlaps;
}
function isOverLappingY(pos, box) {
  return !isTop(pos, box) && !isBottom(pos, box);
}
function isTop(from, to) {
  return from.y >= to.y + to.h;
}
function isBottom(from, to) {
  return from.y + from.h <= to.y;
}
function isFixedHorizontal(e) {
  return e.props && e.props.resize && e.props.resize.fixedHorizontal;
}
function isFixedVertical(e) {
  if (e.type === 'Box' || e.type === 'Button' || e.type === 'Label' || e.type === 'Container' || e.type === 'Repeater' || e.children && e.children.length > 0) {
    return e.props && e.props.resize && e.props.resize.fixedVertical;
  }

  return true;
}
function isPinnedLeft(e) {
  return e.props && e.props.resize && e.props.resize.left;
}
function isPinnedRight(e) {
  return e.props && e.props.resize && e.props.resize.right;
}
function isPinnedUp(e) {
  return e.props && e.props.resize && e.props.resize.up;
}
function isPinnedDown(e) {
  return e.props && e.props.resize && e.props.resize.down;
}
function isFullWidth(e) {
  return e.props && e.props.resize && e.props.resize.fullWidth;
}
function isAtBottom(element, model) {
  var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

  if (element && model.screenSize) {
    var dif = getDistanceFromScreenBottom(element, model);
    return dif < threshold;
  }

  return false;
}
function getDistanceFromScreenBottom(element, model) {
  if (element && model.screenSize) {
    var dif = model.screenSize.h - (element.y + element.h);
    return dif;
  }

  return 0;
}
function isWrappedContainer(e) {
  return e.style.wrap;
}
function isRowContainer(e) {
  return e.isRow;
}
function isGridContainer(e) {
  return e.style.grid;
}
function isDesignSystemRoot(e) {
  return e.isDesignSystemRoot;
}
function hasWrappedParent(e) {
  if (e.parent) {
    return e.parent.style.wrap;
  }

  return false;
}
function hasComponentScreenParent(e) {
  return e.hasComponentScreenParent;
}
function hasGrid(e) {
  return e.grid;
}
function isRepeaterAuto(e) {
  if (e.type === 'Repeater' && e.props.layout == 'grid' && e.props.auto === true) {
    return true;
  }

  return false;
}
function isRepeaterGrid(e) {
  if (e.type === 'Repeater' && e.props.layout === 'grid') {
    return true;
  }

  return false;
}
function isBlock(e) {
  return e && e.style && e.style.display === 'block';
}
function isCentered(e) {
  if (e.parent) {
    var dif = e.parent.w - (2 * e.x + e.w); // We have a minimum threshold of 3px

    return Math.abs(dif) < Math.max(3, e.parent.w * 0.003);
  }

  return false;
}
function hasParentRepeaterGrid(e) {
  if (e.parent) {
    return isRepeaterGrid(e.parent);
  }

  return false;
}
function getClickLine(element) {
  if (element.lines) {
    return element.lines.find(function (l) {
      return l.event === 'click';
    });
  }

  return null;
}
function allChildrenAreFixedHorizontal(children) {
  var fixedChildren = children.filter(function (f) {
    return f.props && f.props.resize && f.props.resize.fixedHorizontal;
  });
  return fixedChildren.length === children.length;
}
function isOverlay(screen) {
  return screen.style && screen.style.overlay;
}
function isComponentSet(e) {
  return e.figmaType === 'COMPONENT_SET';
}
function isChildrenToggle(e) {
  return e.type === 'ChildrenToggle' || e.smartContainerType === 'ChildrenToggle';
}
function hasOverlayBackground(screen) {
  return screen.style && screen.style.hasBackground;
}
function hasMinMaxWdith(screen) {
  return screen.style && (screen.style.minWidth || screen.style.maxWidth);
}
function fixAutos(style, widget) {
  if (style.fontSize === 'Auto') {
    style.fontSize = widget.h;
  }

  return style;
}
/**
 * FIX for old models without z-value
 */

function fixMissingZValue(box) {
  if (box.z === null || box.z === undefined) {
    box.z = 0;
  }
}
/**
 * Get children
 */


function getOrderedWidgets(widgets) {
  var result = [];

  for (var id in widgets) {
    var widget = widgets[id];

    if (widget) {
      fixMissingZValue(widget);
      result.push(widget);
    }
  }

  sortWidgetList(result);
  return result;
}
/**
 * This method is super important for the correct rendering!
 *
 * We sort by:
 *
 *  1) style.fixed: fixed elements will be renderd last, therefore they come
 *  as the last elements in the list
 *
 * 	2) inherited : inherited values come first. They shall be rendered below the
 *  widget of the new screen
 *
 *  3) z : High z values come later
 *
 *  4) id: if the z value is the same, sort by id, which means the order the widgets have been
 *  added to the screen.
 */

function sortWidgetList(result) {
  /**
   * Inline function to determine if a widget is fixed.
   * we have to check if style exists, because the Toolbar.onToolWidgetLayer()
   * call the method without styles.
   */
  var isFixed = function isFixed(w) {
    if (w.style && w.style.fixed) {
      return true;
    }

    return false;
  };

  result.sort(function (a, b) {
    var aFix = isFixed(a);
    var bFix = isFixed(b);
    /**
     * 1) Sort by fixed. If both are fixed or not fixed,
     * continue sorting by inherited.
     */

    if (aFix == bFix) {
      /**
       * If both a inherited or not inherited,
       * continue sorting by z & id
       */
      if (a.inherited && b.inherited || !a.inherited && !b.inherited) {
        /**
         * 4) if the have the same z, sot by id
         */
        if (a.z == b.z && a.id && b.id) {
          return a.id.localeCompare(b.id);
        }
        /**
         * 3) Sort by z. Attention, Chrome
         * needs -1, 0, 1 or one. > does not work
         */


        return a.z - b.z;
      }

      if (a.inherited) {
        return -1;
      }

      return 1;
    }

    if (aFix) {
      return 1;
    }

    return -1;
  });
}
function isContainedInBox(obj, parent) {
  if (parent) {
    if (obj.x >= parent.x && obj.x + obj.w <= parent.w + parent.x && obj.y >= parent.y && obj.y + obj.h <= parent.y + parent.h) {
      return true;
    }
  }

  return false;
}
function getBoundingBoxByIds(ids, model) {
  var children = ids.map(function (id) {
    if (model.widgets && model.widgets[id]) {
      return model.widgets[id];
    } else {
      Logger$1.log(1, 'ExportUtil.getBoundingBoxByIds() > No child with id', id);
    }

    return null;
  }).filter(function (child) {
    return child !== null;
  });
  return getBoundingBoxByBoxes(children);
}
function getBoundingBoxByBoxes(boxes) {
  var result = {
    x: 100000000,
    y: 100000000,
    w: 0,
    h: 0,
    z: 100000000,
    props: {
      resize: {}
    }
  };

  for (var i = 0; i < boxes.length; i++) {
    var box = boxes[i];
    result.x = Math.min(result.x, box.x);
    result.y = Math.min(result.y, box.y);
    result.w = Math.max(result.w, box.x + box.w);
    result.h = Math.max(result.h, box.y + box.h);
    result.z = Math.max(result.z, box.z);

    if (isFixedHorizontal(box)) {
      result.props.resize.fixedHorizontal = true;
    }

    if (isFixedVertical(box)) {
      result.props.resize.fixedVertical = true;
    }
  }

  result.h -= result.y;
  result.w -= result.x;
  return result;
}
function createInheritedModel(model) {
  /**
   * Build lookup map for overwrites
   */
  var overwritenWidgets = {};

  for (var screenID in model.screens) {
    var screen = model.screens[screenID];
    overwritenWidgets[screenID] = {};

    for (var i = 0; i < screen.children.length; i++) {
      var widgetID = screen.children[i];
      var widget = model.widgets[widgetID];

      if (widget && widget.parentWidget) {
        overwritenWidgets[screenID][widget.parentWidget] = widgetID;
      }
    }
  }

  var inModel = clone(model);
  inModel.inherited = true;
  /**
   * add container widgets
   */

  createContaineredModel(inModel);
  /**
   * add widgets from parent (master) screens
   */

  for (var _screenID in inModel.screens) {
    /**
     * *ATTENTION* We read from the org model, otherwise we have
     * issues in the loop as we change the screen.
     */
    var _screen = model.screens[_screenID];

    if (_screen.parents && _screen.parents.length > 0) {
      /**
       * add widgets from parent screens
       */
      for (var _i = 0; _i < _screen.parents.length; _i++) {
        var parentID = _screen.parents[_i];

        if (parentID != _screenID) {
          if (model.screens[parentID]) {
            /**
             * *ATTENTION* We read from the org model, otherwise we have
             * issues in the loop as we change the screen!
             */
            var parentScreen = model.screens[parentID];
            var difX = parentScreen.x - _screen.x;
            var difY = parentScreen.y - _screen.y;
            var parentChildren = parentScreen.children;

            for (var j = 0; j < parentChildren.length; j++) {
              var parentWidgetID = parentChildren[j];
              /**
               * *ATTENTION* We read from the org model, otherwise we have
               * issues in the loop as we change the screen!
               */

              var parentWidget = model.widgets[parentWidgetID];

              if (parentWidget) {
                var overwritenWidgetID = overwritenWidgets[_screenID][parentWidgetID];

                if (!overwritenWidgetID) {
                  var copy = clone(parentWidget);
                  /**
                   * Super important the ID mapping!!
                   */

                  copy.id = parentWidget.id + "@" + _screenID;
                  copy.inherited = parentWidget.id;
                  copy.inheritedScreen = _screenID;
                  copy.inheritedOrder = _i + 1;
                  /**
                   * Now lets also put it at the right position!
                   */

                  copy.x -= difX;
                  copy.y -= difY;
                  /**
                   * We write the new widget to the inherited model!
                   *
                   */

                  inModel.widgets[copy.id] = copy;

                  inModel.screens[_screenID].children.push(copy.id);
                  /**
                   * Also add a to the inherited copies
                   * so we can to live updates in canvas
                   */


                  var parentCopy = inModel.widgets[parentWidget.id];

                  if (!parentCopy.copies) {
                    parentCopy.copies = [];
                  }

                  parentCopy.copies.push(copy.id);
                } else {
                  var overwritenWidget = inModel.widgets[overwritenWidgetID];

                  if (overwritenWidget) {
                    overwritenWidget.props = mixin(clone(parentWidget.props), overwritenWidget.props, true);
                    overwritenWidget.style = mixin(clone(parentWidget.style), overwritenWidget.style, true);

                    if (overwritenWidget.hover) {
                      overwritenWidget.hover = mixin(clone(parentWidget.hover), overwritenWidget.hover, true);
                    }

                    if (overwritenWidget.error) {
                      overwritenWidget.error = mixin(clone(parentWidget.error), overwritenWidget.error, true);
                    }
                    /**
                     * Also add a reference to the *INHERITED* copies
                     * so we can to live updates in canvas
                     */


                    var _parentCopy = inModel.widgets[parentWidget.id];

                    if (!_parentCopy.inheritedCopies) {
                      _parentCopy.inheritedCopies = [];
                    }

                    _parentCopy.inheritedCopies.push(overwritenWidget.id);
                    /**
                     * Also inherited positions
                     */


                    if (overwritenWidget.parentWidgetPos) {
                      overwritenWidget.x = parentWidget.x - difX;
                      overwritenWidget.y = parentWidget.y - difY;
                      overwritenWidget.w = parentWidget.w;
                      overwritenWidget.h = parentWidget.h;
                    }

                    overwritenWidget._inheried = true;
                  } else {
                    console.error("createInheritedModel() > No overwriten widget in model");
                  }
                }
              } else {
                console.warn("createInheritedModel() > no parent screen child with id > " + parentID + ">" + parentWidget);
              }
            }

            createInheritedGroups(inModel.screens[_screenID], parentScreen, model, inModel);
          } else {
            console.warn("createInheritedModel() > Deteced Self inheritance...", _screen);
          }
        } else {
          console.warn("createInheritedModel() > no parent screen with id > " + parentID);
        }
      }
    }
  }

  return inModel;
}

function createInheritedGroups(inScreen, parentScreen, model, inModel) {
  Logger$1.log(4, 'ExportUtil.createInheritedGroups()');
  var parentGroups = getAllGroupsForScreen(parentScreen, model);
  var widgetParentMapping = {};
  inScreen.children.forEach(function (widgetID) {
    var inheritedWidget = inModel.widgets[widgetID];

    if (inheritedWidget) {
      widgetParentMapping[inheritedWidget.inherited] = widgetID;
    } else {
      console.warn('createInheritedGroups() Could not find widget', widgetID);
    }
  });
  parentGroups.forEach(function (group) {
    var newGroup = {
      name: group.name + "_" + inScreen.name,
      id: group.id + "@" + inScreen.id,
      inherited: group.id,
      inheritedScreen: parentScreen.id,
      props: clone(group.props),
      style: clone(group.style),
      children: []
    };
    group.children.forEach(function (widgetID) {
      var inheritedID = widgetParentMapping[widgetID];

      if (inheritedID) {
        newGroup.children.push(inheritedID);
      } else {
        console.warn('createInheritedGroups() Could not find parent widhet', widgetID);
      }
    });

    if (inModel.groups) {
      inModel.groups[newGroup.id] = newGroup;
    }
  });
}

function createContaineredModel(inModel) {
  for (var screenID in inModel.screens) {
    var screen = inModel.screens[screenID];

    for (var i = 0; i < screen.children.length; i++) {
      var widgetID = screen.children[i];
      var widget = inModel.widgets[widgetID];

      if (widget) {
        if (widget.isContainer) {
          var children = getContainedChildWidgets(widget, inModel);
          widget.children = children.map(function (w) {
            return w.id;
          });
        }
      }
    }
  }
}

function getContainedChildWidgets(container, model) {
  var result = [];
  /*
   * Loop over sorted list
   */

  var sortedWidgets = getOrderedWidgets(model.widgets);
  var found = false;

  for (var i = 0; i < sortedWidgets.length; i++) {
    var widget = sortedWidgets[i];

    if (container.id != widget.id) {
      if (found && isContainedInBox(widget, container)) {
        widget.container = container.id;
        result.push(widget);
      }
    } else {
      found = true;
    }
  }

  return result;
}
function mixin(a, b, keepTrack) {
  if (a && b) {
    b = clone(b);

    if (keepTrack) {
      b._mixed = {};
    }

    for (var k in a) {
      if (b[k] === undefined || b[k] === null) {
        b[k] = a[k];

        if (keepTrack) {
          b._mixed[k] = true;
        }
      }
    }
  }

  return b;
}
function clone(obj) {
  if (!obj) {
    return null;
  }

  var _s = JSON.stringify(obj);

  return JSON.parse(_s);
}
function getLines(widget, model) {
  var result = [];

  if (widget.inherited && model.widgets[widget.inherited]) {
    widget = model.widgets[widget.inherited];
  }

  var widgetID = widget.id;
  var lines = getFromLines(widget, model);

  if (lines && lines.length > 0) {
    return lines;
  }

  var group = getParentGroup(widgetID, model);

  if (group) {
    var groupLine = getFromLines(group, model);

    if (groupLine && groupLine.length > 0) {
      return groupLine;
    }
  }
  /**
   * Since 2.1.3 we use might have sub groups.
   */


  var topGroup = getTopParentGroup(widgetID, model);

  if (topGroup) {
    var _groupLine = getFromLines(topGroup, model);

    if (_groupLine && _groupLine.length > 0) {
      return _groupLine;
    }
  }

  return result;
}
function getTopParentGroup(id, model) {
  var group = getParentGroup(id, model);

  if (group) {
    while (group) {
      var parent = getParentGroup(group.id, model);

      if (parent) {
        group = parent;
      } else {
        /**
         * In contrast the the Layout copz of this, we do not add
         * all children... not sure it this is needed
         */
        return group;
      }
    }
  }

  return null;
}
function getParentGroup(widgetID, model) {
  if (model.groups) {
    for (var id in model.groups) {
      var group = model.groups[id];
      var i = group.children.indexOf(widgetID);

      if (i > -1) {
        return group;
      }
      /**
       * Since 2.13 we have subgroups and check this too
       */


      if (group.groups) {
        var _i2 = group.groups.indexOf(widgetID);

        if (_i2 > -1) {
          return group;
        }
      }
    }
  }

  return null;
}
function getGroup(widgetID, model) {
  if (model.groups) {
    for (var id in model.groups) {
      var group = model.groups[id];
      var i = group.children.indexOf(widgetID);

      if (i > -1) {
        return group;
      }
    }
  }
}
function getAllGroupChildren(group, model) {
  if (!group.children) {
    return [];
  }

  var result = group.children.slice(0);
  /**
   * Check all sub groups
   */

  if (group.groups) {
    group.groups.forEach(function (subId) {
      var sub = model.groups[subId];

      if (sub) {
        var children = getAllGroupChildren(sub, model);
        result = result.concat(children);
      } else {
        console.warn('getAllGroupChildren() No sub group', subId);
      }
    });
  }

  return result;
}
function getAllGroupsForScreen(screen, model) {
  var result = {};
  screen.children.forEach(function (widgetID) {
    var group = getGroup(widgetID, model);

    if (group) {
      result[group.id] = group;
    }
  });
  return Object.values(result);
}

function getFromLines(box, model) {
  var result = [];

  for (var id in model.lines) {
    var line = model.lines[id];

    if (line.from == box.id) {
      result.push(line);
    }
  }

  return result;
}

function getBoxById(id, model) {
  if (model.screens[id]) {
    return model.screens[id];
  }

  if (model.widgets[id]) {
    return model.widgets[id];
  }
}

function getElementsAsRows(nodes) {
  var rows = [];
  var row;
  var lastRowId = null;
  nodes.forEach(function (n) {
    var rowId = n.row ? n.row : '-1';

    if (rowId != lastRowId) {
      row = [];
      rows.push(row);
    }

    row.push(n);
    lastRowId = rowId;
  });
  return rows;
}
function setCSSClassNames(parent, screenName) {
  var name = parent.name;
  name = name.replace(/\./g, "_");

  if (name.match(/^\d/)) {
    name = "q" + name;
  }

  var cssSelector = ".".concat(name.replace(/\s+/g, "_"));
  parent.cssClass = "".concat(name.replace(/\s+/g, "_"));

  if (parent.parent) {
    cssSelector = ".".concat(screenName.replace(/\s+/g, "_"), " ").concat(cssSelector);
  } else {
    cssSelector = ".qux-screen".concat(cssSelector);
  }

  parent.cssSelector = cssSelector;

  if (parent && parent.children) {
    parent.children.forEach(function (c) {
      setCSSClassNames(c, screenName);
    });
  }

  if (parent && parent.fixedChildren) {
    parent.fixedChildren.forEach(function (c) {
      setCSSClassNames(c, screenName);
    });
  }
}

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);
  }

  _createClass(Config, [{
    key: "getDefault",
    value: function getDefault() {
      return {
        debug: {
          logLevel: 0
        },
        designletPrefix: '',
        css: {
          grid: true,
          justifyContentInWrapper: false,
          pinnedLeft: false,
          pinnedRight: false,
          fixedHorizontal: false,
          attachLabels: true
        },
        router: {
          key: "screenName",
          prefix: ""
        },
        databinding: {
          default: ""
        },
        imageFolder: "/img",
        components: {},
        responsive: {
          mobile: {
            min: 0,
            max: 400
          },
          tablet: {
            min: 401,
            max: 1200
          },
          desktop: {
            min: 1201,
            max: 1000000
          }
        },
        addDefaultDatabinding: true
      };
    }
  }, {
    key: "merge",
    value: function merge(config, overwrites) {
      if (overwrites.addDefaultDatabinding !== undefined) {
        config.addDefaultDatabinding = overwrites.addDefaultDatabinding;
      }

      if (overwrites.css) {
        config.css = mixin(config.css, overwrites.css);
      }

      if (overwrites.router) {
        config.router = mixin(config.router, overwrites.router);
      }

      if (overwrites.databinding) {
        config.databinding = mixin(config.databinding, overwrites.databinding);
      }

      if (overwrites.components) {
        config.components = overwrites.components;
      }

      if (overwrites.imageFolder) {
        config.imageFolder = overwrites.imageFolder;
      }

      if (overwrites.debug) {
        config.debug = mixin(config.debug, overwrites.debug);
      }

      if (overwrites.designletPrefix) {
        config.designletPrefix = overwrites.designletPrefix;
      }

      return config;
    }
  }]);

  return Config;
}();

var Config$1 = new Config();

function addGridToElements(parent) {
  var grid = computeGrid(parent);

  if (grid) {
    parent.grid = grid;

    if (parent.children && parent.children.length > 0) {
      parent.children.forEach(function (e) {
        e.gridColumnStart = 0;
        e.gridColumnEnd = grid.columns.length;
        e.gridRowStart = 0;
        e.gridRowEnd = grid.rows.length;
        grid.columns.forEach(function (c, i) {
          /**
           * FIXME: if we want to use grdiCleanUp we
           * have to use start and end
           */
          if (c.v === e.x) {
            e.gridColumnStart = i;
          } else if (c.v === e.x + e.w) {
            e.gridColumnEnd = i;
          }
        });
        grid.rows.forEach(function (r, i) {
          if (r.v === e.y) {
            e.gridRowStart = i;
          }

          if (r.v === e.y + e.h) {
            e.gridRowEnd = i;
          }
        });
      });
    }
  }

  if (parent.children && parent.children.length > 0) {
    parent.children.forEach(function (c) {
      addGridToElements(c);
    });
  }

  return parent;
}
function computeGrid(parent) {
  var fixSmallColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (parent.children && parent.children.length > 0) {
    var rows = {};
    var columns = {};
    /**
     * Collect all the relevant lines. First the parent
     * then all the children
     */

    addGridColumns(columns, 0, parent, true);
    addGridColumns(columns, parent.w, parent, false);
    addGridRow(rows, 0, parent, true);
    addGridRow(rows, parent.h, parent, false);
    parent.children.forEach(function (c) {
      addGridColumns(columns, c.x, c, true);
      addGridColumns(columns, c.x + c.w, c, false);
      addGridRow(rows, c.y, c, true);
      addGridRow(rows, c.y + c.h, c, false);
    });
    /**
     * Set the width and convert objects to arrays
     */

    columns = setGridColumnWidth(columns, parent);
    rows = setGridRowHeight(rows, parent);

    if (fixSmallColumns) {
      /**
       * To make htis work, we need to fix the addGridToElements() to not match values,
       * but go over the start and end thingies.
       */
      columns = computeReducedColumns(columns);
    }
    /**
     * determine fixed columns and rows
     */


    setFixedGirdRowsAndColumns(parent, columns, rows);
    return {
      rows: rows,
      columns: columns
    };
  }

  return null;
}
function computeReducedColumns(columns) {
  var temp = [];
  var last = null;

  for (var c = 0; c < columns.length; c++) {
    var col = columns[c];

    if (last && col.v - last.v < 2) {
      /**
      * This does not work
      */
      var start = last.start.concat(col.start);
      var end = last.end.concat(col.end);
      last.start = start;
      last.end = end;
    } else {
      temp.push(col);
      last = col;
    }
  }

  return temp;
}
function setFixedGirdRowsAndColumns(parent, columns, rows) {
  /**
   * Set fixed. For each child check if the
   * 1) We have fixed Vertical or Horizontal
   * 2) If pinned. e.g. if pinned right, all
   *    columns < e.v must be fixed
   */
  parent.children.forEach(function (e) {
    if (isFixedHorizontal(e)) {
      columns.forEach(function (column) {
        if (column.v >= e.x && column.v < e.x + e.w) {
          column.fixed = true;
        }
      });
    }

    if (isPinnedLeft(e)) {
      // FIXME: Just fix the closest
      var before = columns.filter(function (column) {
        return column.v < e.x;
      });

      if (before.length > 0) {
        before[before.length - 1].fixed = true;
      } //columns.forEach(column => {
      //    if (column.v < e.x) {
      //        column.fixed = true
      //    }
      //})

    }

    if (isPinnedRight(e)) {
      var after = columns.filter(function (column) {
        return column.v >= e.x + e.w;
      });

      if (after.length > 0) {
        after[0].fixed = true;
      } //columns.forEach(column => {
      //    if (column.v >= e.x + e.w) {
      //        column.fixed = true
      //    }
      //})

    }

    if (isFixedVertical(e)) {
      rows.forEach(function (row) {
        if (row.v >= e.y && row.v < e.y + e.h) {
          row.fixed = true;
        }
      });
    }

    if (isPinnedUp(e)) {
      rows.forEach(function (row) {
        if (row.v < e.y) {
          row.fixed = true;
        }
      });
    }

    if (isPinnedDown(e)) {
      rows.forEach(function (row) {
        if (row.v >= e.y + e.h) {
          row.fixed = true;
        }
      });
    }
  });
}
function setGridColumnWidth(columns, parent) {
  columns = Object.values(columns).sort(function (a, b) {
    return a.v - b.v;
  });
  columns.forEach(function (column, i) {
    if (columns[i + 1]) {
      column.l = columns[i + 1].v - column.v;
    } else {
      column.l = parent.w - column.v;
    }
  });
  return columns.filter(function (c) {
    return c.l > 0;
  });
}
function setGridRowHeight(rows, parent) {
  rows = Object.values(rows).sort(function (a, b) {
    return a.v - b.v;
  });
  rows.forEach(function (row, i) {
    if (rows[i + 1]) {
      row.l = rows[i + 1].v - row.v;
    } else {
      row.l = parent.h - row.v;
    }
  });
  return rows.filter(function (r) {
    return r.l > 0;
  });
}
function addGridColumns(columns, x, e, start) {
  if (!columns[x]) {
    columns[x] = {
      v: x,
      start: [],
      end: [],
      fixed: false,
      hasMinMax: false
    };
  }

  if (start) {
    columns[x].start.push(e);
  } else {
    columns[x].end.push(e);
  }
  /**
   * If we have a min max, we will
   * later try to use max-content. This will
   * only work for the longest element.
   * Check CSSPosition.getGridColumnTracks()
   */


  if (hasMinMaxWdith(e)) {
    columns[x].hasMinMax = true;
  }
}
function addGridRow(rows, y, e, start) {
  if (!rows[y]) {
    rows[y] = {
      v: y,
      start: [],
      end: [],
      fixed: false
    };
  }

  if (start) {
    rows[y].start.push(e);
  } else {
    rows[y].end.push(e);
  }
}

var rowContainerID = 0;
var cloneID = 0;
/**
 * Inlines some quant-ux stuff
 */

var supportedWidgetTypes = ["Button", "Box", "Label", "Container", "Icon", "Image", "CheckBox", "RadioBox", "RadioBox2", "HotSpot", "TextBox", "Password", "TextArea", "Repeater", "RadioGroup", "CheckBoxGroup", "ToggleButton", "Switch", "DropDown", "MobileDropDown", "Stepper", "HSlider", "Date", "DateDropDown", "SegmentButton", "Rating", "IconToggle", "LabeledIconToggle", "TypeAheadTextBox", "Table", "Paging", "BarChart", "PieChart", "MultiRingChart", "RingChart", "Vector", "Timeline", "Upload", "ChildrenToggle", "Camera", "UploadPreview"];
var textProperties = ["color", "textDecoration", "textAlign", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight"];
function transform(model, config) {
  Logger$1.log(3, "Falt2Tree.transform () > enter", config);
  var result = {
    id: model.id,
    name: model.name,
    templates: model.templates ? Object.values(model.templates) : [],
    warnings: [],
    screens: []
  };
  var nodesWithLabelAttachment = config.css && config.css.attachLabels === true ? ["TextBox", "Password", "TextArea", "Box", "Button"] : ["TextBox", "Password", "TextArea"];
  var hasRows = config.css && config.css.grid !== true;

  var _loop = function _loop(screenID) {
    var screen = model.screens[screenID];
    /**
     * First we build a hierachical parent child relation.
     */

    screen = transformScreenToTree(screen, model);
    /**
     * Add rows and grid if needed
     */

    screen = layoutTree(screen, hasRows);
    /**
     * Now we put the fixed stuff in the fixedChildren list
     */

    screen = setFixedChildren(screen, model);
    /**
     * Now we need to layout the shit again, because we have removed the fixed elements.
     * FIXME: Make the layoutTree method faster taht it also works with the fixedChildren
     */

    if (screen.fixedChildren && screen.fixedChildren.length > 0) {
      Logger$1.log(1, "Falt2Tree.transform() > fixed elements require double layout");
      screen = layoutTree(screen, model);
    }
    /**
     * set screen pos to 0,0
     */


    screen.children.forEach(function (c) {
      c.parent = screen;
    });
    screen.x = 0;
    screen.y = 0;
    attachSingleLabelsInScreen(model, screen, nodesWithLabelAttachment);
    setWidgetTypes(screen);
    setCSSClassNames$1(screen, screen.name);
    result.screens.push(screen);
  };

  for (var screenID in model.screens) {
    _loop(screenID);
  }

  return result;
}

function layoutTree(screen, hasRows) {
  Logger$1.log('Flat2Tree.layoutTree() > ', hasRows);
  screen = addRows(screen);
  screen = addRowContainer(screen, hasRows);
  screen = setOrderAndRelativePositions(screen, false);
  fixParents(screen);
  screen = addGrid(screen);
  return screen;
}

function setWidgetTypes(parent) {
  parent.qtype = getWidgetType(parent);

  if (parent.children) {
    parent.children.forEach(function (c) {
      setWidgetTypes(c);
    });
  }

  if (parent.fixedChildren) {
    parent.fixedChildren.forEach(function (c) {
      setWidgetTypes(c);
    });
  }

  if (parent.templates) {
    parent.templates.forEach(function (c) {
      setWidgetTypes(c);
    });
  }
}

function setCSSClassNames$1(parent, screenName) {
  return setCSSClassNames(parent, screenName);
}

function getWidgetType(element) {
  /**
   * We check here different component overrides
   */
  if (element.props.customComponent) {
    Logger$1.log(-1, "Falt2Tree.getWidgetType() > Use customComponent", element);
    return element.props.customComponent;
  }

  if (element.type === "ComponentSet") {
    return "qComponentSet";
  }

  if (element.children && element.children.length > 0) {
    if (element.type === "Repeater") {
      return "qRepeater";
    }

    if (element.type === "ChildrenToggle") {
      return "qChildrenToggle";
    }

    return "qContainer";
  } else {
    if (supportedWidgetTypes.indexOf(element.type) >= 0) {
      return "q".concat(element.type);
    }

    Logger$1.warn("Falt2Tree.getWidgetType() > Not supported widget type: " + element.type);
    return "qBox";
  }
}

function fixParents(parent) {
  if (parent.children) {
    parent.children.forEach(function (c) {
      c.parent = parent;
      fixParents(c);
    });
  }
}

function addGrid(screen) {
  addGridToElements(screen);
  return screen;
}

function setOrderAndRelativePositions(parent, relative) {
  Logger$1.log(5, "Falt2Tree.setOrderAndRelativePositons() > enter", parent.name);
  var nodes = parent.children;
  /**
   * We have three kind of containers. Wrapped, Rows and Grid as Default. For each we have
   * to compute the and align the children differently
   */

  if (isWrappedContainer(parent)) {
    setOrderInWrapper(parent, nodes);
  } else if (isRowContainer(parent)) {
    // isRow is only true for row containers
    setOrderInRow(parent, nodes, relative);
  } else {
    // FIXME: We should not have this any more,. becasue we do not use flex!
    setOrderInColumn(parent, nodes, relative);
  }

  nodes.forEach(function (n) {
    if (n.children && n.children.length > 0) {
      setOrderAndRelativePositions(n, relative);
    }
  });
  return parent;
}
/**
 * In a column, elements are rendered top to down
 */


function setOrderInColumn(parent, nodes, relative) {
  Logger$1.log(5, "Falt2Tree.setOrderInColumn() > Column", parent.name);
  nodes.sort(function (a, b) {
    return a.y - b.y;
  });
  var last = 0;
  nodes.forEach(function (n, i) {
    var y = n.y - last;
    last = n.y + n.h;

    if (relative) {
      n.y = y;
      n.r = i;
    } else {
      n.top = y;
    }
  });
}
/**
	* In a row the elements are rendered form left to right.
	*/


function setOrderInRow(parent, nodes, relative) {
  Logger$1.warn("Falt2Tree.setOrderInRow() > DEPRECTAED", parent.name);
  nodes.sort(function (a, b) {
    return a.x - b.x;
  });
  var last = 0;
  /**
   * We calculate now as x the position the the child before,
   * but we also save the absolute position
   */

  nodes.forEach(function (n, i) {
    var x = n.x - last;
    last = n.x + n.w;
    n.absX = n.x;
    /**
     * FIXME: add also right
     */

    if (relative) {
      n.x = x;
      n.c = i;
    } else {
      n.left = x;
      n.c = i;
    } // console.debug('absX', n.name, n.x, n.absX)

  });
  /**
   * Update responsive propeties in rows
   */

  if (parent.props && parent.props.resize) {
    var lastNode = null;
    nodes.forEach(function (node, i) {
      mergeResponsiveInParent(parent, node, i, nodes.length);
      node.canGrow = true;
      /**
       * Make right fixed, left fixed
       */

      if (lastNode && isPinnedRight(lastNode)) {
        Logger$1.log(5, "Falt2Tree.setOrderAndRelativePositons() > fix rightPinned :" + lastNode.name, node.name);
        node.props.resize.left = true;
        node.canGrow = false;
      }

      lastNode = node;
    });
  }
}
/**
* Sort by bz row and column. After wards set just paddings and mardings
*/


function setOrderInWrapper(parent, nodes) {
  Logger$1.log(3, "Falt2Tree.setOrderInWrapper() > Wrapper Container", parent.name);
  nodes.sort(function (a, b) {
    if (isOverLappingY(a, b)) {
      return a.x - b.x;
    }

    return a.y - b.y;
  });

  if (parent.isGroup) {
    /*
    	* If the parent is group, the offet will be 0! So we calculate instead
    	* the didtance between the first and second row and first and second column.
    	* This is offcourse just guess.
    	*/
    var offsetBottom = 10;
    var offSetRight = 10;
    var rows = getElementsAsRows(nodes);

    if (rows[0] && rows[0].length > 1 && rows[1]) {
      var firstRowChild1 = rows[0][0];
      var firstRowChild2 = rows[0][1];
      var secondRowChild2 = rows[1][0];
      offSetRight = firstRowChild2.x - (firstRowChild1.x + firstRowChild1.w);
      offsetBottom = secondRowChild2.y - (firstRowChild1.y + firstRowChild1.h);
    } else {
      Logger$1.log(-1, "Falt2Tree.setOrderAndRelativePositons() > cannot guess offsets for Wrapper Container", parent.name);
    }

    parent.style.paddingTop = 0;
    parent.style.paddingBottom = 0;
    parent.style.paddingLeft = 0;
    parent.style.paddingRight = 0;
    nodes.forEach(function (n) {
      n.wrapOffSetBottom = offsetBottom;
      n.wrapOffSetRight = offSetRight;
      n.wrapOffSetY = 0;
      n.wrapOffSetX = 0;
    });
  } else {
    /**
     * We take as the position, the offset of the first element
     * Then we add half as padding and the rest a masgin for
     * the children
     */
    var firstNode = nodes[0];
    var offSetX = Math.round(firstNode.x / 2);
    var offSetY = Math.round(firstNode.y / 2);
    parent.style.paddingTop = offSetY;
    parent.style.paddingBottom = offSetY;
    parent.style.paddingLeft = offSetX;
    parent.style.paddingRight = offSetX;
    nodes.forEach(function (n) {
      n.wrapOffSetY = offSetY;
      n.wrapOffSetX = offSetX;
    });
  }
}

function mergeResponsiveInParent(container, c, index, childrenCount) {
  if (container.props.resize) {
    if (index === 0) {
      Logger$1.log(5, "Falt2Tree.mergeResponsiveInParent() > left: " + container.name, isPinnedLeft(c));
      container.props.resize.left = isPinnedLeft(c);
    }

    if (index === childrenCount - 1) {
      Logger$1.log(5, "Falt2Tree.mergeResponsiveInParent() > right: " + container.name, isPinnedRight(c));
      container.props.resize.right = isPinnedRight(c);
    }
  }
}

function attachSingleLabelsInScreen(model, screen) {
  var allowedTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  Logger$1.log(3, "Falt2Tree.attachSingleLabelsInScreen()", allowedTypes);
  screen.children.forEach(function (child) {
    attachSingleLabelsInNodes(model, child, allowedTypes);
  });
  return screen;
}

function attachSingleLabelsInNodes(model, node, allowedTypes) {
  /**
   * If we have a box that has NO label props and contains
   * only one child of type label, we merge this in.
   */
  var type = node.type;

  if (!node.props.label && node.children.length === 1 && (allowedTypes === null || allowedTypes.indexOf(type) >= 0)) {
    var child = node.children[0];
    /**
     * TODO: We should check here if teh re is a link. What to do with the link?
     * Copy to aprent if it is different?
     */

    var lines = getLines(child, model);

    if (child.type === "Label" && lines.length === 0) {
      Logger$1.log(2, "Falt2Tree.attachSingleLabelsInNodes()", node);
      node.props.label = child.props.label;
      node.children = [];
      /**
       * For none input types set to Box
       */

      if (!isInputElement(node)) {
        node.type = "Box";
        node.qtype = "qBox";
      }

      textProperties.forEach(function (key) {
        if (child.style[key]) {
          node.style[key] = child.style[key];
        }
      });
      node.style.paddingTop = child.y;
      node.style.paddingBottom = node.h - child.h - child.y;
      node.style.paddingLeft = child.x;
      node.style.paddingRight = node.w - child.w - child.x;
      node.style = fixAutos(node.style, child);

      if (child.props.databinding) {
        node.props.databinding = child.props.databinding;
      } // remove grid??

    } else {
      /**
       * TODO: We have two conditions that can fail and require us to go deeper.
       * Therefore we need to call this recursive code again. We could have a better check,
       * to make teh code more beautifull
       */
      node.children.forEach(function (child) {
        attachSingleLabelsInNodes(model, child, allowedTypes);
      });
    }
  } else {
    node.children.forEach(function (child) {
      attachSingleLabelsInNodes(model, child, allowedTypes);
    });
  }
}

function addRowContainer(parent, hasRows) {
  var nodes = parent.children;
  var newChildren = [];
  var rows = {};
  nodes.forEach(function (a) {
    if (a.row) {
      if (!rows[a.row]) {
        rows[a.row] = [];
      }

      rows[a.row].push(a);
    } else {
      newChildren.push(a);
    }
  });
  /**
   * For each row create a container and reposition the children.
   *
   * For wrappend and grid containers, we do not do this .
   *
   * FIXME: For groups we should not need to add a now row?
   *
   */

  if (!isWrappedContainer(parent) && !isGridContainer(parent) && hasRows) {
    var _loop2 = function _loop2(row) {
      var children = rows[row];
      var container = createRowCntr(parent, children);
      /**
       * Position the children in the container
       */

      children.forEach(function (c) {
        c.x = c.x - container.x, c.y = c.y - container.y, c.parent = container;
      });
      newChildren.push(container);
    };

    for (var row in rows) {
      _loop2(row);
    }

    parent.children = newChildren;
  } else {
    /**
     * Is this needed?
     */
    if (parent.type !== "Screen") {
      Logger$1.log(4, "Falt2Tree.addRowContainer() > ignore wrapper ", parent.name);
      parent.isWrap = true;
      parent.isRow = false;
      parent.isColumn = false;
    }
  }
  /**
   * Go down recursive
   */


  nodes.forEach(function (a) {
    if (a.children && a.children.length > 0) {
      addRowContainer(a);
    }
  });
  return parent;
}

function createRowCntr(parent, children) {
  var boundingBox = getBoundingBoxByBoxes(children);
  var rowCntr = {
    id: "r" + rowContainerID++,
    name: "Row ".concat(rowContainerID),
    children: children,
    isRow: true,
    x: boundingBox.x,
    y: boundingBox.y,
    h: boundingBox.h,
    w: boundingBox.w,
    type: "row",
    parent: parent,
    style: {},
    props: {
      resize: {
        right: false,
        up: false,
        left: false,
        down: false,

        /**
         * check of all children are fixed width. Then we set this one too.
         */
        fixedHorizontal: allChildrenAreFixedHorizontal(children),
        fixedVertical: false
      }
    }
  };
  return rowCntr;
}
/**
 * Sets the row IDS to each child
 */


function addRows(parent) {
  var nodes = parent.children;
  nodes.sort(function (a, b) {
    return a.y - b.y;
  }); // let rows = []

  var rowIDs = 1;
  nodes.forEach(function (a) {
    nodes.forEach(function (b) {
      if (a.id !== b.id) {
        if (isOverLappingY(a, b)) {
          /**
           * If we have now row, create a new id for a
           */
          if (!a.row) {
            a.row = rowIDs++;
          }
          /**
           * If b has no row, we put it in the same row as
           * a
           */


          if (!b.row) {
            b.row = a.row;
          } else {
            var oldId = b.row;
            var newId = a.row;
            /**
             * if b has already a row, we merge row a & b
             */

            nodes.forEach(function (c) {
              if (c.row === oldId) {
                c.row = newId;
              }
            });
          }
        }
      }
      /**
       * no step down recursive
       */


      if (a.children && a.children.length > 0) {
        addRows(a);
      }
    });
  });
  return parent;
}
/**
 * Transforms and screen into a hiearchical presentation. return the root node.
 */


function transformScreenToTree(screen, model) {
  var result = clone$1(screen);
  delete result.children;
  delete result.has;
  result.children = [];
  result.fixedChildren = [];
  /**
   * Get widget in render order. This is important to derive the
   * parent child relations.
   */

  var widgets = getOrderedWidgets(getWidgets(screen, model));
  /**
   *  now build child parent relations
   */

  var parentWidgets = [];
  var elementsById = {};
  widgets.forEach(function (widget) {
    // console.debug('buildTree', widget.name, '    in ', parentWidgets.map(p => p.name).join(', '))
    var element = clone$1(widget);
    element._x = widget.x;
    element._y = widget.y;
    element.children = [];
    var group = getGroup(widget.id, model);
    element.group = group;
    /**
     * Check if the widget has a parent (= is contained) widget.
     * If so, calculate the relative position to the parent,
     * otherwise but the element under the screen.
     */

    var parentWidget = getParentWidget(parentWidgets, element, model);

    if (parentWidget && canBeChild(element, parentWidget)) {
      //  was Util.canHaveChildren(parentWidget)
      element.x = widget.x - parentWidget.x;
      element.y = widget.y - parentWidget.y;
      element.parent = parentWidget;
      elementsById[parentWidget.id].children.push(element);
    } else {
      element.x = widget.x - screen.x;
      element.y = widget.y - screen.y;
      element.parent = null;
      result.children.push(element);
      /**
       * If we have a widget directly under the screen, and we have a negative margin, crop
       * This might happen with figma
       */

      if (element.y < 0) {
        Logger$1.log(2, "Falt2Tree.transformScreenToTree() > fix negative margin", element.name);
        element.h += element.y;
        element.y = 0;
      }
    }
    /**
     * Save the widget, so we can check in the next
     * iteation if this is a parent or not! Only use
     * widgets that can have children
     */


    if (canHaveChildren(widget)) {
      parentWidgets.unshift(widget);
    }

    elementsById[element.id] = element;
  });
  /**
   * Padding messes with the grid :(
   */

  resetPadding(result);
  return result;
}

function setFixedChildren(screen, model) {
  if (screen.children) {
    setFixedChildrenInElement(screen, screen, model);
  }

  return screen;
}

function setFixedChildrenInElement(element, screen, model) {
  var fixBottomNodes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  /**
   * Attention. Fixed elements must be set in the model as fixed. Otherwise
   * the oder in the tree method is not correct and the will be wrongly nested!
   */
  if (element.children) {
    var children = [];
    element.children.forEach(function (child) {
      if (child.style.fixed === true) {
        child.x = child._x - screen.x;
        child.y = child._y - screen.y;
        element.parent = screen;
        setAllChildrenAsNotFixed(child);

        if (fixBottomNodes) {
          setFixedBottom(child, model);
        }

        screen.fixedChildren.push(child);
      } else {
        setFixedChildrenInElement(child, screen, model);
        children.push(child);
      }
    });
    element.children = children;
  }
}

function setFixedBottom(element, model) {
  /**
   * If an element (e.g. tabbar) is fixed at the bottom.
   */
  if (isAtBottom(element, model)) {
    if (!element.props.resize) {
      element.props.resize = {
        right: false,
        up: false,
        left: false,
        down: false,
        fixedHorizontal: false,
        fixedVertical: false
      };
    }

    element.props.resize.down = true;
    Logger$1.log(2, "Falt2Tree.setFixedChildrenInElement() > pinn fixed to bottom", element.name);
  }
  /**
   * IF we have an pinned bottom
   */


  if (isPinnedDown(element)) {
    element.bottom = getDistanceFromScreenBottom(element, model);
  }
}

function setAllChildrenAsNotFixed(element) {
  if (element.children) {
    element.children.forEach(function (child) {
      child.style.fixed = false;
      setAllChildrenAsNotFixed(child);
    });
  }
}

function resetPadding(element) {
  if (element.children) {
    element.children.forEach(function (child) {
      /**
       * If we have more than one child, we have to set the padding to 0.
       * Also, we have to create an label element
       */
      var labelToAdd = null;

      if (child.children && child.children.length > 0) {
        var style = child.style;

        if (child.props.label) {
          var _style = child.style;
          var paddingLeft = _style.paddingLeft ? _style.paddingLeft : 0;
          var paddingRight = _style.paddingRight ? _style.paddingRight : 0;
          var paddingBottom = _style.paddingBottom ? _style.paddingBottom : 0;
          var paddingTop = _style.paddingTop ? _style.paddingTop : 0; // Logger.warn('Falt2Tree.resetPadding() > inline label!', child)

          labelToAdd = {
            id: child.id + "-label",
            name: child.name + "-label",
            type: "Label",
            x: _style.paddingRight,
            y: _style.paddingTop,
            w: child.w - paddingLeft - paddingRight,
            h: child.h - paddingBottom - paddingTop,
            props: clone(child.props),
            style: {
              color: _style.color,
              textAlign: _style.textAlign,
              fontFamily: _style.fontFamily,
              fontSize: _style.fontSize,
              fontStyle: _style.fontStyle,
              fontWeight: _style.fontWeight,
              letterSpacing: _style.letterSpacing,
              lineHeight: _style.lineHeight,
              verticalAlign: _style.verticalAlign
            },
            children: []
          };
        }

        style.paddingBottom = 0;
        style.paddingLeft = 0;
        style.paddingRight = 0;
        style.paddingTop = 0;
        resetPadding(child);

        if (labelToAdd) {
          /**
           * Or add to fron?
           */
          child.children.push(labelToAdd);
        }
      }
    });
  }
}
/**
 * This method will try to find the parent widget. By default,
 * the parent child relation ship is defined as the visual hierachy. This must be done, to
 * get nice nested HTML also from drawing style.
 *
 * Figma, however, might have overflows. Thus we check, if there is no visual parent,
 * also the parentID.
 */


function getParentWidget(potentialParents, element, model) {
  /**
   * First see if the widget is nested in a widget that was rendered before
   */
  for (var p = 0; p < potentialParents.length; p++) {
    var parent = potentialParents[p];

    if (isContainedInBox(element, parent)) {
      return parent;
    }
  }
  /**
   * If not, check of the parent was defined otherwise, e.g. figma.
   */


  if (element.parentId) {
    var _parent = model.widgets[element.parentId];

    if (_parent) {
      return _parent;
    }
  }
}

function getWidgets(screen, model) {
  var widgets = [];

  for (var i = 0; i < screen.children.length; i++) {
    var id = screen.children[i];
    var widget = model.widgets[id];
    widgets.push(widget);
  }

  return widgets;
}

function clone$1(obj) {
  var clone = JSON.parse(JSON.stringify(obj));
  clone._id = cloneID++;
  return clone;
}

function transform$1(app, config) {
  Logger$1.log(3, "Quant2Flat.transform () > enter", config);
  var model = clone(app);
  var isForcePinnedLeft = config.css && config.css.pinnedLeft === true;
  var isForcePinnedRight = config.css && config.css.pinnedRight === true;
  var isForceFixedHorizontal = config.css && config.css.fixedHorizontal === true;
  /**
   * Before we start, we create an inherited model!
   */

  model = createInheritedModel(model);
  /**
   * Set forced left and right pinned
   */

  model = addForcedResize(model, isForcePinnedLeft, isForcePinnedRight, isForceFixedHorizontal);
  /**
   * Set default data binding
   */

  if (config.addDefaultDatabinding) {
    model = addDefaultDataBinding(model);
  }
  /**
   * Set certain widgets horizontal fixed
   */


  model = fixHorizontal(model);
  /**
   * Make sure names are unique
   */

  model = fixNames(model);
  /**
   * Add links
   */

  model = addActions(model);
  /**
   * Make sure templates are inlined
   */

  setTemplateStyles(model);
  /**
   * Add here virtual elements for the groups
   */

  for (var screenID in model.screens) {
    var screen = model.screens[screenID];
    model = addGroupWrapper(screen, model);
  }

  return model;
}
/**
 * Set tenplates in widgets
 */

function setTemplateStyles(model) {
  if (model.templates) {
    Object.values(model.templates).forEach(function (t) {
      t.cssSelector = ".qux-template-".concat(t.name.replace(/\s+/g, "_"));
      t.cssClass = "qux-template-".concat(t.name.replace(/\s+/g, "_"));
      /**
       * TODO: Make faster with lookup map...
       */

      Object.values(model.widgets).forEach(function (widget) {
        if (widget.template === t.id) {
          if (!widget.sharedCssClasses) {
            widget.sharedCssClasses = [];
          }

          widget.sharedCssClasses.push(t.cssClass);
          /**
           * The vertical align is copied directly... This should be some how handled
           * by the css factory...
           */

          if (t.style && t.style.verticalAlign && !widget.style.verticalAlign) {
            widget.style.verticalAlign = t.style.verticalAlign;
          }
        }
      });
    });
  }
}

function addActions(model) {
  Object.values(model.widgets).forEach(function (w) {
    var lines = getLines(w, model);

    if (lines.length > 0) {
      w.lines = lines;
    }
  });
  Object.values(model.screens).forEach(function (s) {
    var lines = getLines(s, model);

    if (lines.length > 0) {
      s.lines = lines;
    }
  });
  return model;
}

function addForcedResize(model, isForcePinnedLeft, isForcePinnedRight, isForceFixedHorizontal) {
  if (isForcePinnedLeft || isForcePinnedRight || isForceFixedHorizontal) {
    Logger$1.log(2, "Quant2Flat.addForcedResize()", isForcePinnedLeft, isForcePinnedRight);
    Object.values(model.widgets).forEach(function (w) {
      if (!w.props.resize) {
        w.props.resize = {
          right: false,
          up: false,
          left: false,
          down: false,
          fixedHorizontal: false,
          fixedVertical: false
        };
      }

      if (isForcePinnedLeft) {
        w.props.resize.left = true;
      }

      if (isForceFixedHorizontal && !w.props.right) {
        w.props.resize.fixedHorizontal = true;
      }

      if (isForcePinnedRight && !w.props.fixedHorizontal) {
        w.props.resize.right = true;
      }
    });
  }

  return model;
}

function addDefaultDataBinding(model) {
  var _loop = function _loop(screenId) {
    var screen = model.screens[screenId];
    var children = screen.children;

    if (children) {
      children.forEach(function (widgetId) {
        var widget = model.widgets[widgetId];

        if (widget && widget.props) {
          if (!widget.props.databinding || Object.values(widget.props.databinding) === 0) {
            widget.props.databinding = {
              default: getDefaultDataBinding(screen, widget)
            };
            Logger$1.log(4, "Quant2Flat.addDefaultDataBinding() > ", widget.props.databinding);
          }
        }
      });
    }
  };

  for (var screenId in model.screens) {
    _loop(screenId);
  }

  return model;
}

function getDefaultDataBinding(screen, widget) {
  /**
   * RadioBoxes need some special handling. We create a binding for the group if specified
   */
  if (widget.type === "RadioBox2" && widget.props && widget.props.formGroup) {
    return escapeSpaces("".concat(screen.name, ".").concat(widget.props.formGroup));
  }

  return escapeSpaces("".concat(screen.name, ".").concat(widget.name));
}

function escapeSpaces(s) {
  return s.replace(/\s+/g, "_");
}

function fixHorizontal(model) {
  var fixed = ["Switch", "Stepper"];

  for (var widgetId in model.widgets) {
    var widget = model.widgets[widgetId];

    if (fixed.indexOf(widget.type) >= 0) {
      if (!widget.props.resize) {
        widget.props.resize = {};
      }

      widget.props.resize.fixedHorizontal = true;
    }
  }

  return model;
}

function fixNames(model) {
  var screens = Object.values(model.screens);
  screens.forEach(function (screen, j) {
    var otherScreensWithSameName = screens.filter(function (o) {
      return o.name === screen.name;
    });

    if (otherScreensWithSameName.length > 1) {
      Logger$1.log(3, "Quant2Flat.fixNames() > Fix double screen name:" + screen.name);
      screen.name += "_" + j;
    }

    var children = screen.children;

    if (children) {
      var widgets = children.map(function (widgetId) {
        return model.widgets[widgetId];
      });
      widgets.forEach(function (w, i) {
        var others = widgets.filter(function (o) {
          return o.name === w.name;
        });

        if (others.length > 1) {
          Logger$1.log(3, "Quant2Flat.fixNames() > Fix double widget name: " + w.name + " in screen " + screen.name);
          w.name += "_" + i;
        }
      });
    }
  });
  /**
   * DEPREACTED SHOULD NEVER BE CALLED: We should fix doubles names. With mastre screens
   * we could have overwites! We could rename them, but this
   * would have to be consistant in all screens!
   */

  var _loop2 = function _loop2(screenID) {
    var screen = model.screens[screenID];
    var children = screen.children;
    var names = children.map(function (c) {
      return model.widgets[c].name;
    });
    var count = {};
    names.forEach(function (n) {
      if (count[n]) {
        Logger$1.error("Quant2Flat.fixNames() > Dubplicate name of element '".concat(n, "' in screen '").concat(screen.name, "'"));
      }

      count[n] = true;
    });
  };

  for (var screenID in model.screens) {
    _loop2(screenID);
  }

  return model;
}

function addGroupWrapper(screen, model) {
  Logger$1.log(4, "Quant2Flat.addGroupWrapper() > create ", screen.name);
  var widgets = getOrderedWidgets(getWidgets$1(screen, model));
  var createdGroups = {};
  var order = [];
  widgets.forEach(function (widget) {
    var group = getGroup(widget.id, model);

    if (group) {
      createGroupCntr(group, model, createdGroups, order, screen);
    }

    order.push(widget);
  });
  /**
   * Set new z to ensure that the groups are before the
   */

  order.forEach(function (widget, i) {
    widget.z = i;
  });
  return model;
}

function createGroupCntr(group, model, createdGroups, order, screen) {
  /**
   * Create new group container only if needed
   */
  if (!createdGroups[group.id]) {
    Logger$1.log(2, "Quant2Flat.createGroupCntr() > create ", group.name);
    /**
     * 1) check if we need to create parent group. If so we go up hierachy
     */

    var parentGroup = getParentGroup(group.id, model);

    if (parentGroup) {
      createGroupCntr(parentGroup, model, createdGroups, order, screen);
    }
    /**
     * 2) Now create the group cntr
     */


    var allGroupChildren = getAllGroupChildren(group, model);
    var boundingBox = getBoundingBoxByIds(allGroupChildren, model);
    var groupCntr = {
      id: "gc".concat(group.id),
      name: group.name,
      groupId: group.id,
      isGroup: true,
      type: "Box",
      x: boundingBox.x,
      y: boundingBox.y,
      w: boundingBox.w,
      h: boundingBox.h,
      style: group.style ? group.style : {},
      props: {
        resize: group.props && group.props.resize ? group.props.resize : {
          right: false,
          up: false,
          left: false,
          down: false,
          fixedHorizontal: false,
          fixedVertical: false
        }
      }
    };
    /**
     * For inhereted groups make sure that the inherited flag
     * is set, other wise the sortWidgets methods will put
     * it behind it's children and nesting does not work!
     */

    if (group.inherited) {
      groupCntr.inherited = group.inherited;
    }
    /**
     * Add it to the model and link stuff properly
     */


    model.widgets[groupCntr.id] = groupCntr;
    screen.children.push(groupCntr.id);
    createdGroups[group.id] = groupCntr;
    /**
     * Attention, this is imporant! We add the groupCntr here.
     * After this method, the widget will be added! By doing this,
     * we ensure the right order.
     */

    order.push(groupCntr);
  }
}

function getWidgets$1(screen, model) {
  var widgets = [];

  for (var i = 0; i < screen.children.length; i++) {
    var id = screen.children[i];
    var widget = model.widgets[id];
    widgets.push(widget);
  }

  return widgets;
}

// import * as Util from "../core/ExportUtil"
/**
 * Get a sub tree. This
 */

function transform$2(tree, selectedName, config) {
  var postFix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-WrapperScreen';
  Logger$1.log(0, "Tree2Component.transform () > enter", selectedName, postFix);
  var componentTree = {
    id: tree.id,
    name: tree.name,
    templates: tree.templates,
    warnings: [],
    screens: []
  };
  var matches = findElementsByName(tree, selectedName);

  if (matches.length === 1) {
    var match = matches[0];
    /**
     * We create here a wrapping screen
     */

    var screen = {
      id: match.id + postFix,
      name: match.name + postFix,
      x: match.x,
      y: match.y,
      w: match.w,
      h: match.h,
      qType: 'qContainer',
      type: 'Screen',
      cssClass: match.cssClass + postFix,
      cssSelector: ".qux-screen.".concat(match.cssClass).concat(postFix),
      children: [match],
      fixedChildren: [],
      actions: [],
      props: {},
      style: {},
      isColumn: false,
      isRow: false,
      isWrap: false,
      isComponentScreen: true
    };
    componentTree.screens.push(screen);
    componentTree.id = match.id + '-' + componentTree.id;
    /**
     * We make a special rendering (100% height) in the CSSFactory. This
     * we force a grid, but what ever...
     */

    match.hasComponentScreenParent = true;
    /**
     * Do not forget to update the css Selectors
     */

    setCSSClassNames$1(match, match.name + postFix);
  } else if (matches.length > 1) {
    Logger$1.error('Tree2Component.transform() > ERROR: More than one component with name', selectedName);
  } else {
    Logger$1.error('Tree2Component.transform() > ERROR: No component with name', selectedName);
  }

  return componentTree;
}
function findElementsByName(tree, name) {
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (tree.screens) {
    tree.screens.forEach(function (screen) {
      findElementsByNameInScreen(screen, name, result);
    });
  }

  return result;
}
function findElementsByNameInScreen(e, name) {
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (e.children) {
    e.children.forEach(function (c) {
      if (c.name === name) {
        result.push(c);
      }

      findElementsByName(c, name, result);
    });
  }

  return result;
}

/**
 * This class transforms an absolute quant-ux model into an
 * kind of HTML model, where the elements have a real parent
 * child relation child
 */

var ModelTransformer = /*#__PURE__*/function () {
  function ModelTransformer(app) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var selected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, ModelTransformer);

    this.config = config;
    this.model = app;
    this.selected = selected;
  }

  _createClass(ModelTransformer, [{
    key: "transform",
    value: function transform$3() {
      Logger$1.log(0, 'ModelTransformer.transform()', this.selected);
      var model = this.model;
      var flatModel = transform$1(model, this.config);
      var treeModel = transform(flatModel, this.config);

      if (this.selected) {
        treeModel = transform$2(treeModel, this.selected, this.config);
      }

      return treeModel;
    }
  }]);

  return ModelTransformer;
}();

var CSSOptimizer = /*#__PURE__*/function () {
  function CSSOptimizer() {
    _classCallCheck(this, CSSOptimizer);

    /**
     *  Keep the order to collapsed Order: top-left | top-right | bottom-right | bottom-left
     */
    this.borderRadius = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"];
    /**
    * Order: top, right, bottom, left
    */

    this.borderWidth = ["borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth"];
    this.borderStyle = ['borderTopStyle', 'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle'];
    this.borderColor = ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor'];
    this.padding = ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'];
  }

  _createClass(CSSOptimizer, [{
    key: "runFlat",
    value: function runFlat(model) {
      model = clone(model);

      if (model.templates) {
        this.compressDict(model.templates);
      }

      this.compressDict(model.screens);
      this.compressDict(model.widgets);
      return model;
    }
  }, {
    key: "runTree",
    value: function runTree(model) {
      var _this = this;

      var replaceVerticalWithPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      /**
      * Generate the template styles
      */
      model.templates.forEach(function (template) {
        // template groups have no style...
        if (template.style) {
          template.style = _this.compress(template.style, template);
        }
      });
      /**
       * Generate styles for each screen. The templates styles
       * might here be reused!
       */

      model.screens.forEach(function (screen) {
        screen.style = _this.compress(screen.style, screen);
        screen.children.forEach(function (child) {
          _this.compressChildren(child, replaceVerticalWithPadding);
        });

        if (screen.fixedChildren) {
          screen.fixedChildren.forEach(function (child) {
            _this.compressChildren(child, replaceVerticalWithPadding);
          });
        }
      });
      return model;
    }
  }, {
    key: "compressChildren",
    value: function compressChildren(element, replaceVerticalWithPadding) {
      var _this2 = this;

      element.style = this.compress(element.style, element, replaceVerticalWithPadding);

      if (element.children) {
        element.children.forEach(function (child) {
          _this2.compressChildren(child, replaceVerticalWithPadding);
        });
      }
    }
  }, {
    key: "compressDict",
    value: function compressDict(dict) {
      var _this3 = this;

      Object.values(dict).forEach(function (item) {
        item.style = _this3.compress(item.style, item);
      });
    }
  }, {
    key: "compress",
    value: function compress(style, element) {
      var replaceVerticalWithPadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (replaceVerticalWithPadding) {
        style = this.removeVAlign(style, element);
      }

      this.compressAttribes(style, this.padding, 'padding', 'px', 0);
      /**
       * Compress and collapse border
       */

      this.compressAttribes(style, this.borderRadius, 'borderRadius', 'px', 0);
      var borderIsEqual = this.compressAttribes(style, this.borderColor, 'borderColor', false, 'transparent');
      var widthIsEqual = this.compressAttribes(style, this.borderWidth, 'borderWidth', 'px', 0);
      var styleIsEqual = this.compressAttribes(style, this.borderStyle, 'borderStyle', false, 'solid');
      /**
       * Merge borders of possible
       */

      if (borderIsEqual && widthIsEqual && styleIsEqual) {
        style.border = "".concat(style.borderWidth, " ").concat(style.borderStyle, " ").concat(style.borderColor);
        delete style.borderColor;
        delete style.borderWidth;
        delete style.borderStyle;
      }
      /**
       * Remove defaults for the all equal case
       */


      if (style.borderStyle === 'solid solid solid solid') {
        delete style.borderStyle;
      }

      if (style.borderStyle === 'solid') {
        delete style.borderStyle;
      } // if (style.border && style.border.indexOf('0px') === 0) {
      //    delete style.border
      //}


      if (style.padding === '0px') {
        delete style.padding;
      }

      if (style.borderRadius === '0px') {
        delete style.borderRadius;
      }

      return style;
    }
  }, {
    key: "removeVAlign",
    value: function removeVAlign(style, element) {
      if (style.verticalAlign === 'middle' && style.fontSize && style.fontSize !== 'auto') {
        Logger$1.log(3, 'CSSOptimizer.removeVAILN() > middle', element.name);
        delete style.verticalAlign;
        style.paddingTop = Math.round((element.h - style.fontSize) / 2);
        style.paddingBottom = element.h - style.fontSize - style.paddingTop;
      }

      if (style.verticalAlign === 'bottom' && style.fontSize && style.fontSize !== 'auto') {
        Logger$1.log(3, 'CSSOptimizer.removeVAILN() > bottom', element.name);
        delete style.verticalAlign;
        style.paddingTop = Math.round(element.h - style.fontSize);
        style.paddingBottom = 0;
      }

      return style;
    }
  }, {
    key: "resizeToBoxModel",
    value: function resizeToBoxModel(widget) {
      if (widget.style) {
        if (widget.style.paddingTop) {
          widget.h -= widget.style.paddingTop;
        }

        if (widget.style.paddingBottom) {
          widget.h -= widget.style.paddingBottom;
        }

        if (widget.style.paddingLeft) {
          widget.w -= widget.style.paddingLeft;
        }

        if (widget.style.paddingRight) {
          widget.w -= widget.style.paddingRight;
        }

        if (widget.style.borderTopWidth) {
          widget.h -= widget.style.borderTopWidth;
        }

        if (widget.style.borderBottomWidth) {
          widget.h -= widget.style.borderBottomWidth;
        }

        if (widget.style.borderLeftWidth) {
          widget.w -= widget.style.borderLeftWidth;
        }

        if (widget.style.borderRightWidth) {
          widget.w -= widget.style.borderRightWidth;
        }
      }

      return widget;
    }
  }, {
    key: "compressAttribes",
    value: function compressAttribes(style, keys, prop, unit, defaultValue) {
      /**
       * Check if we have all the same
       */
      var firstValue = style[keys[0]];

      if (keys.every(function (key) {
        return style[key] === firstValue;
      })) {
        if (firstValue === undefined || firstValue === null) {
          firstValue = defaultValue;
        }

        if (unit) {
          firstValue += unit;
        }

        keys.forEach(function (key) {
          /**
           * Remove but store a backup for CSSFactory to fix box height
           */
          style['_' + key] = style[key];
          delete style[key];
        });
        style[prop] = firstValue;
        return true;
      } else {
        var values = [];
        keys.forEach(function (key) {
          var value = style[key];

          if (value === undefined || value === null) {
            value = defaultValue;
          }

          if (unit) {
            value += unit;
          }

          values.push(value);
          style['_' + key] = style[key];
          delete style[key];
        });
        style[prop] = values.join(' ');
        return false;
      }
    }
  }]);

  return CSSOptimizer;
}();

function fromRgb(
/*String*/
color) {
  var m = color.toLowerCase().match(/^rgba?\(([\s\\.,0-9]+)\)/);
  return m && fromArray(m[1].split(/\s*,\s*/)); // Color
}
function fromHex(
/*String*/
color) {
  var result = {};
  var bits = color.length == 4 ? 4 : 8;
  var mask = (1 << bits) - 1;
  color = Number("0x" + color.substr(1));

  if (isNaN(color)) {
    return;
  }

  var rgb = ["b", "g", "r"];
  rgb.forEach(function (x) {
    var c = color & mask;
    color >>= bits;
    result[x] = bits == 4 ? 17 * c : c;
  });
  result.a = 1;
  return result;
}
function fromArray(
/** array */
a) {
  var result = {};
  var rgb = ["b", "g", "r"];
  rgb.forEach(function (x, i) {
    result[x] = a[i] * 1;
  });

  if (isNaN(result.a)) {
    result.a = 1;
  }

  return result;
}
function fromString(str) {
  if (str === 'transparent') {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0
    };
  } else {
    return fromRgb(str) || fromHex(str);
  }
}
function toString(color) {
  return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")");
}

var PaginCSS = /*#__PURE__*/function () {
  function PaginCSS(cssFactory) {
    _classCallCheck(this, PaginCSS);

    Logger$1.log(5, 'PaginCSS.constructor()');
    this.cssFactory = cssFactory;
  }

  _createClass(PaginCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += selector + ' .qux-paging-item {\n';
      result += "  width:".concat(style.fontSize * 2, "px;\n");
      result += "  background:".concat(style.background, ";\n");
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.textProperties);
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += '}\n\n';

      if (widget.hover) {
        var hover = widget.hover;
        result += selector + ' .qux-paging-item:hover {\n';
        result += "  background:".concat(hover.background, ";\n");
        result += this.cssFactory.getStyleByKey(hover, widget, this.cssFactory.textProperties);
        result += this.cssFactory.getStyleByKey(hover, widget, this.cssFactory.borderProperties);
        result += '}\n\n';
      }

      if (widget.active) {
        var active = widget.active;
        result += selector + ' .qux-paging-item.qux-paging-item-active {\n';
        result += "  background:".concat(active.background, ";\n");
        result += this.cssFactory.getStyleByKey(active, widget, this.cssFactory.textProperties);
        result += this.cssFactory.getStyleByKey(active, widget, this.cssFactory.borderProperties);
        result += '}\n\n';
      }

      return result;
    }
  }]);

  return PaginCSS;
}();

var TableCSS = /*#__PURE__*/function () {
  function TableCSS(cssFactory) {
    _classCallCheck(this, TableCSS);

    Logger$1.log(5, 'TableCSS.constructor()');
    this.cssFactory = cssFactory;
  }

  _createClass(TableCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      var borderStyle = this.getTableBorderStyle(widget);
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.textProperties);

      if (borderStyle === 'Out') {
        result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      }

      result += '}\n\n';
      result += selector + ' .qux-table-action,';
      result += selector + ' .qux-table-cell{\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.paddingProperties);
      result += '}\n\n';

      if (borderStyle === 'Cell') {
        result += selector + ' th,';
        result += selector + ' td{\n';
        result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
        result += '}\n\n';
      }

      if (borderStyle === 'VLines') {
        result += selector + ' th,';
        result += selector + ' td{\n';
        result += "  border-right-color:".concat(style._borderBottomColor, ";\n");
        result += "  border-right-width:".concat(style._borderBottomWidth, "px;\n");
        result += "  border-right-style:solid;\n";
        result += '}\n\n';
        result += selector + ' th:last-child,';
        result += selector + ' td:last-Child{\n';
        result += "  border:none;\n";
        result += '}\n\n';
      }

      if (borderStyle === 'HLines') {
        result += selector + ' th,';
        result += selector + ' td{\n';
        result += "  border-bottom-color:".concat(style._borderBottomColor, ";\n");
        result += "  border-bottom-width:".concat(style._borderBottomWidth, "px;\n");
        result += "  border-bottom-style:solid;\n";
        result += '}\n\n';
        result += selector + ' tr:last-child th,';
        result += selector + ' tr:last-Child td{\n';
        result += "  border:none;\n";
        result += '}\n\n';
      }

      result += selector + ' thead tr{\n';
      result += "  background:".concat(style.headerBackground, ";\n");
      result += "  color:".concat(style.headerColor, ";\n");

      if (style.headerFontStyle) {
        result += "  font-style:".concat(style.headerFontStyle, ";\n");
      }

      if (style.headerFontWeight) {
        result += "  font-weight:".concat(style.headerFontWeight, ";\n");
      }

      if (style.headerTextDecoration) {
        result += "  text-decoration:".concat(style.headerTextDecoration, ";\n");
      }

      result += '}\n\n';
      result += selector + ' tbody tr:nth-child(2){\n';
      result += "  background:".concat(style.evenRowBackground, ";\n");
      result += "  color:".concat(style.evenRowColor, ";\n");
      result += '}\n\n';
      result += selector + ' tbody tr:hover{\n';

      if (style.hoverBackground) {
        result += "  background:".concat(style.hoverBackground, ";\n");
      }

      if (style.hoverColor) {
        result += "  color:".concat(style.hoverColor, ";\n");
      }

      result += '}\n\n';

      if (widget.props.tableActions) {
        widget.props.tableActions.forEach(function (action, i) {
          result += selector + ' .qux-table-action-cntr .qux-table-action-' + i + '{\n';

          if (action.color) {
            result += "  color:".concat(action.color, ";\n");
          }

          result += '}\n\n';
        });
      }

      if (style.checkBox) {
        result += selector + ' .qux-checkbox-cntr{\n';
        var s = style.checkBoxSize ? style.checkBoxSize : style.fontSize;
        result += "  width:".concat(s, "px;\n");
        result += "  height:".concat(s, "px;\n");
        result += "  background:".concat(style.checkBoxBackground, ";\n");
        result += "  border-color:".concat(style.checkBoxBorderColor, ";\n");
        result += "  border-radius:".concat(style.checkBoxBorderRadius, "px;\n");
        result += "  border-width:".concat(style.borderWidth, "px;\n");
        result += '}\n\n';
        result += selector + ' .qux-checkbox-hook {\n';
        result += "  border-color:".concat(style.checkBoxHookColor, ";\n");
        result += '}\n\n';
      }

      var widths = this.getTableWidths(widget.props, style);
      widths.forEach(function (w, i) {
        result += selector + ' .qux-table-column-' + i + '{\n';
        result += "  width:".concat(Math.round(w * widget.w), "px;\n");
        result += '}\n\n';
      }); //widths.forEach((w,i) => {
      //  result += selector + ' td:nth-child(' + (i +1 ) + '){\n'
      //  result += `  width:${Math.round(w * widget.w)}px;\n`
      //  result += '}\n\n'
      //})

      return result;
    }
  }, {
    key: "getTableWidths",
    value: function getTableWidths(props, style) {
      var fontFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.6;
      var result = [];

      if (props.widths) {
        var widths = props.widths;
        var sum = 0;
        var padding = style._paddingLeft + style._paddingRight;

        if (style.checkBox) {
          var w = style.checkBoxSize ? style.checkBoxSize : style.fontSize;
          widths = [w + padding].concat(widths);
        }

        if (props.tableActions && props.tableActions.length > 0) {
          var text = props.tableActions.map(function (a) {
            return a.label;
          }).join();

          var _w = text.length * style.fontSize * fontFactor + padding * props.tableActions.length;

          widths = widths.concat(_w);
        }

        for (var i = 0; i < widths.length; i++) {
          sum += widths[i];
        }

        for (var _i = 0; _i < widths.length; _i++) {
          result[_i] = widths[_i] / sum;
        }
      }

      return result;
    }
  }, {
    key: "getTableBorderStyle",
    value: function getTableBorderStyle(model) {
      if (model.props.borderStyle) {
        return model.props.borderStyle;
      }

      return "Cell";
    }
  }]);

  return TableCSS;
}();

var ImageCSS = /*#__PURE__*/function () {
  function ImageCSS(cssFactory) {
    _classCallCheck(this, ImageCSS);

    Logger$1.log(5, 'ImageCSS.constructor()');
    this.cssFactory = cssFactory;
  }

  _createClass(ImageCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);

      if (widget.style.backgroundImage) {
        result += this.cssFactory.getRawStyle(widget.style, widget);
      } else {
        Logger$1.warn('ImageCSS.run()', 'No background for image > ' + widget.name);
        result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
        result += "  background-image:".concat(this.getImagePlaceHolder(widget), ";\n");
        result += "  background-size: 100% 100%;\n";
        result += "  border: 1px solid #333;\n";
      }

      result += '}\n\n';
      return result;
    }
  }, {
    key: "getImagePlaceHolder",
    value: function getImagePlaceHolder(widget) {
      var w = widget.w * 2;
      var h = widget.h * 2;
      var c = document.createElement("canvas");
      var context = c.getContext("2d");
      c.width = w;
      c.height = h;
      h += 0.5;
      w += 0.5;
      var n = 0.5;
      context.moveTo(n, n);
      context.lineTo(w, h);
      context.moveTo(w, n);
      context.lineTo(n, h);
      context.strokeStyle = "#333";
      context.strokeWidth = 2;
      context.imageSmoothingEnabled = false;
      context.stroke();
      var url = 'url(' + c.toDataURL("image/png") + ')';
      return url;
    }
  }]);

  return ImageCSS;
}();

var ScreenCSS = /*#__PURE__*/function () {
  function ScreenCSS(cssFactory) {
    _classCallCheck(this, ScreenCSS);

    Logger$1.log(5, 'ScreenCSS.constructor()');
    this.cssFactory = cssFactory;
    this.imagePrefix = cssFactory.imagePrefix;
  }

  _createClass(ScreenCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);

      if (!isOverlay(widget) || hasOverlayBackground(widget)) {
        if (style.background) {
          if (style.background.colors) {
            var background = style.background;
            var gradient = "(" + background.direction + "deg";

            for (var i = 0; i < background.colors.length; i++) {
              var color = background.colors[i];
              gradient += "," + color.c + " " + color.p + "% ";
            }

            gradient += ")";
            result += "  background: linear-gradient".concat(gradient, ";\n");
          } else {
            result += "  background-color: ".concat(style.background, ";\n");
          }
        }

        if (style.backgroundColor) {
          result += "  background-color: ".concat(style.backgroundColor, ";\n");
        }

        if (style.backgroundImage && style.backgroundImage.url) {
          if (style.backgroundImage.url.indexOf('http') === 0) {
            result += "  background-image: url(".concat(style.backgroundImage.url, ");\n");
          } else {
            result += "  background-image: url(".concat(this.imagePrefix, "/").concat(style.backgroundImage.url, ");\n");
          }
        }
      }
      /**
       * Check if we have full screen (height = 100%) or fixed size, component
       */


      if (widget.isComponentScreen) {
        result += "  height:".concat(widget.h, "px;\n");
        result += "  width:".concat(widget.w, "px;\n");
        result += this.cssFactory.getStyleByKey(style, widget, ['boxShadow']);
        result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      } else {
        result += '  height:100%;\n';
      }

      result += '}\n\n';
      return result;
    }
  }]);

  return ScreenCSS;
}();

var RepeaterCSS = /*#__PURE__*/function () {
  function RepeaterCSS(cssFactory) {
    _classCallCheck(this, RepeaterCSS);

    Logger$1.log(5, 'RepeaterCSS.constructor()');
    this.cssFactory = cssFactory;
  }

  _createClass(RepeaterCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      /**
       * Set here somehow justify-content
       */

      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      /**
       * We might habve here some weird conditions
       *
       * a) Row
       * b) Grid
       *  1) Auto => Wrapped
       *  2) Fixed margin
       *
       * TODO: Use here some implicit GRID?
       */

      if (isWrappedContainer(widget)) {
        Logger$1.warn('RepeaterCSS.run () > wrapped container not supported', widget);
      }
      /**
       * If we have just one child, we just take this to male sure we use teh min and max width
       */


      var boundingBox = widget.children.length === 1 ? widget.children[0] : getBoundingBoxByBoxes(widget.children);
      boundingBox.parent = widget;

      if (isRepeaterGrid(widget)) {
        Logger$1.log(5, 'RepeaterCSS.run () > grid', widget);
        result += selector + ' .qux-repeater-child {\n';
        result += '  display: inline-block;\n';
        result += this.cssFactory.getWrappedWidth(boundingBox);
        var height = this.cssFactory.getFixedHeight(boundingBox);
        result += "  height: ".concat(height, ";\n");
        result += "  margin-bottom:".concat(widget.props.distanceY, "px;\n");

        if (!isRepeaterAuto(widget)) {
          result += "  margin-right:".concat(widget.props.distanceX, "px;\n");
        }

        if (boundingBox.x > 0) {
          result += "  margin-left:".concat(boundingBox.x, "px;\n");
        }

        if (boundingBox.y > 0) {
          result += "  margin-top:".concat(boundingBox.y, "px;\n");
        }

        result += '}\n\n';
      } else {
        Logger$1.log(5, 'RepeaterCSS.run () > row', widget);
        /**
         * Row
         */

        result += selector + ' .qux-repeater-child {\n';
        result += "  margin-bottom:".concat(widget.props.distanceY, "px;\n");
        result += '}\n\n';
      }

      return result;
    }
  }]);

  return RepeaterCSS;
}();

var ChartCSS = /*#__PURE__*/function () {
  function ChartCSS(cssFactory) {
    _classCallCheck(this, ChartCSS);

    Logger$1.log(5, 'ChartCSS.constructor()');
    this.cssFactory = cssFactory;
  }

  _createClass(ChartCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += '}\n\n';
      return result;
    }
  }]);

  return ChartCSS;
}();

var VectorCSS = /*#__PURE__*/function () {
  function VectorCSS(cssFactory) {
    _classCallCheck(this, VectorCSS);

    Logger$1.log(5, 'VectorCSS()');
    this.cssFactory = cssFactory;
    this.imagePrefix = cssFactory.imagePrefix;
  }

  _createClass(VectorCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget); // FIXME: make this smarter?

      result += "  height:".concat(this.cssFactory.getCorrectedHeight(widget), ";\n");
      result += "  width:".concat(this.cssFactory.getCorrectedWidth(widget), ";\n");

      if (style.backgroundImage && style.backgroundImage.url) {
        if (style.backgroundImage.url.indexOf('http') === 0) {
          result += "  background-image: url(".concat(style.backgroundImage.url, ");\n");
        } else {
          result += "  background-image: url(".concat(this.imagePrefix, "/").concat(style.backgroundImage.url, ");\n");
        }
      }

      result += '}\n\n';
      return result;
    }
  }]);

  return VectorCSS;
}();

var VectorCSS$1 = /*#__PURE__*/function () {
  function VectorCSS(cssFactory) {
    _classCallCheck(this, VectorCSS);

    Logger$1.log(5, 'Timeline()');
    this.cssFactory = cssFactory;
    this.imagePrefix = cssFactory.imagePrefix;
  }

  _createClass(VectorCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);

      if (style.elementSpacing === -1) {
        result += "  display:flex;\n";
        result += "  flex-direction: column;\n";
        result += "  justify-content: space-around;\n";
      }

      result += '}\n\n';
      var circleSize = style.circleSize - style.circleBorderWidth;
      var left = (circleSize - style.lineWidth) / 2 + 1;
      result += selector + ' .qux-timeline-line{\n';
      result += "  background:".concat(style.lineBackground, ";\n");
      result += "  width:".concat(style.lineWidth, "px;\n");
      result += "  border-radius:".concat(Math.round(style.lineWidth / 2), "px;\n");
      result += "  left:".concat(Math.round(left), "px;\n");
      result += '}\n\n';

      if (style.elementSpacing > 0) {
        result += selector + ' .qux-timeline-element{\n';
        result += "  margin-top:".concat(style.elementSpacing, "px;\n");
        result += '}\n\n';
      }

      result += selector + ' .qux-timeline-element-selected .qux-timeline-circle{\n';
      result += "  background:".concat(style.cicleActiveBackground, ";\n");
      result += "  border-color:".concat(style.cicleActiveBorderColor, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-timeline-element-selected .qux-timeline-label{\n';
      result += "  color:".concat(style.cicleActiveTextColor, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-timeline-label{\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.textProperties);
      result += '}\n\n';
      result += selector + ' .qux-timeline-circle{\n';
      result += "  background:".concat(style.cicleBackground, ";\n");
      result += "  width:".concat(circleSize, "px;\n");
      result += "  height:".concat(circleSize, "px;\n");
      result += "  border-color:".concat(style.cicleBorderColor, ";\n");
      result += "  border-width:".concat(style.circleBorderWidth, "px;\n");
      result += '}\n\n';
      return result;
    }
  }]);

  return VectorCSS;
}();

var SegmentCSS = /*#__PURE__*/function () {
  function SegmentCSS(cssFactory) {
    _classCallCheck(this, SegmentCSS);

    Logger$1.log(5, 'SegmentCSS()');
    this.cssFactory = cssFactory;
    this.imagePrefix = cssFactory.imagePrefix;
  }

  _createClass(SegmentCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += selector + ' .qux-segment-item {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.textProperties);
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += this.cssFactory.getBackGround(style, widget);
      result += "  border-left: none;\n";
      result += "  border-radius: 0px;\n";
      result += '}\n\n';
      result += selector + ' .qux-segment-item:first-child {\n';
      result += "  border-left-color: ".concat(style._borderLeftColor, ";\n");
      var borderLeftStyle = style._borderLeftStyle ? style._borderLeftStyle : 'solid';
      result += "  border-left-style: ".concat(borderLeftStyle, ";\n");
      result += "  border-left-width: ".concat(style._borderLeftWidth, "px;\n");

      if (style._borderTopLeftRadius) {
        result += "  border-top-left-radius: ".concat(style._borderTopLeftRadius, "px;\n");
      }

      if (style._borderBottomLeftRadius) {
        result += "  border-bottom-left-radius: ".concat(style._borderBottomLeftRadius, "px;\n");
      }

      result += '}\n\n';
      result += selector + ' .qux-segment-item:last-child {\n';

      if (style._borderTopRightRadius) {
        result += "  border-top-right-radius: ".concat(style._borderTopRightRadius, "px;\n");
      }

      if (style._borderBottomRightRadius) {
        result += "  border-bottom-right-radius: ".concat(style._borderBottomRightRadius, "px;\n");
      }

      result += '}\n\n';

      if (widget.active) {
        var active = widget.active;
        result += selector + ' .qux-segment-item.qux-segment-item-selected{\n';
        result += "  background:".concat(active.background, ";\n");
        result += "  color:".concat(active.color, ";\n");
        result += this.cssFactory.getStyleByKey(active, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      return result;
    }
  }]);

  return SegmentCSS;
}();

var UploadCSS = /*#__PURE__*/function () {
  function UploadCSS(cssFactory) {
    _classCallCheck(this, UploadCSS);

    Logger$1.log(5, 'UploadCSS()');
    this.cssFactory = cssFactory;
    this.imagePrefix = cssFactory.imagePrefix;
  }

  _createClass(UploadCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += this.cssFactory.getRawStyle(style, widget);
      result += '}\n\n';

      if (widget.hover) {
        var hover = widget.hover;
        result += selector + ':hover {\n';
        result += "  background:".concat(hover.background, ";\n");
        result += "  color:".concat(hover.color, ";\n");
        result += this.cssFactory.getStyleByKey(hover, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      if (widget.active) {
        var active = widget.active;
        result += selector + '.qux-upload-has-files {\n';
        result += "  background:".concat(active.background, ";\n");
        result += "  color:".concat(active.color, ";\n");
        result += this.cssFactory.getStyleByKey(active, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      return result;
    }
  }]);

  return UploadCSS;
}();

var CameraCSS = /*#__PURE__*/function () {
  function CameraCSS(cssFactory) {
    _classCallCheck(this, CameraCSS);

    Logger$1.log(5, 'CameraCSS()');
    this.cssFactory = cssFactory;
    this.imagePrefix = cssFactory.imagePrefix;
  }

  _createClass(CameraCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += this.cssFactory.getRawStyle(style, widget);
      result += '}\n\n';

      if (widget.hover) {
        var hover = widget.hover;
        result += selector + ':hover {\n';
        result += "  background:".concat(hover.background, ";\n");
        result += "  color:".concat(hover.color, ";\n");
        result += this.cssFactory.getStyleByKey(hover, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      if (widget.active) {
        var active = widget.active;
        result += selector + '.qux-upload-has-files {\n';
        result += "  background:".concat(active.background, ";\n");
        result += "  color:".concat(active.color, ";\n");
        result += this.cssFactory.getStyleByKey(active, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      result += selector + ' .qux-camera-icon {\n';
      result += "  font-size:".concat(Math.min(widget.w, widget.h) * 0.6, "px;\n");
      result += '}\n\n';
      return result;
    }
  }]);

  return CameraCSS;
}();

var UploadPreviewCSS = /*#__PURE__*/function () {
  function UploadPreviewCSS(cssFactory) {
    _classCallCheck(this, UploadPreviewCSS);

    Logger$1.log(5, 'UploadPreviewCSS.constructor()');
    this.cssFactory = cssFactory;
  }

  _createClass(UploadPreviewCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += '}\n\n';
      return result;
    }
  }]);

  return UploadPreviewCSS;
}();

var ComponentSetCSS = /*#__PURE__*/function () {
  function ComponentSetCSS(cssFactory) {
    _classCallCheck(this, ComponentSetCSS);

    Logger$1.log(5, 'ComponentSetCSS.constructor()');
    this.cssFactory = cssFactory;
  }

  _createClass(ComponentSetCSS, [{
    key: "run",
    value: function run(selector, style, widget) {
      var _this = this;

      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      /**
       * We also layout the childrem here
       */

      widget.children.forEach(function (child) {
        result += child.cssSelector + ' {\n';

        if (isFixedHorizontal(child)) {
          result += "  width: ".concat(_this.cssFactory.getCorrectedWidth(child), ";\n");
        } else if (hasMinMaxWdith(child)) {
          result += _this.getMinMaxWidth(child, false);
        } else {
          result += "  min-width: ".concat(_this.cssFactory.getCorrectedWidth(child), ";\n");
        }

        if (isFixedVertical(child)) {
          result += "  height: ".concat(_this.cssFactory.getCorrectedHeight(child), ";\n");
        } else {
          result += "  min-height: ".concat(_this.cssFactory.getCorrectedHeight(child), ";\n");
        }

        result += '}\n\n';
      });
      return result;
    }
  }]);

  return ComponentSetCSS;
}();

var CSSWidgetFactory = /*#__PURE__*/function () {
  function CSSWidgetFactory(cssFactory) {
    _classCallCheck(this, CSSWidgetFactory);

    Logger$1.log(5, 'CSSWidgetFactory.constructor()');
    this.cssFactory = cssFactory;
    this.factories = {
      'Paging': new PaginCSS(cssFactory),
      'Table': new TableCSS(cssFactory),
      'Image': new ImageCSS(cssFactory),
      'Screen': new ScreenCSS(cssFactory),
      'Repeater': new RepeaterCSS(cssFactory),
      'BarChart': new ChartCSS(cssFactory),
      'Vector': new VectorCSS(cssFactory),
      'Timeline': new VectorCSS$1(cssFactory),
      'Segment': new SegmentCSS(cssFactory),
      'Upload': new UploadCSS(cssFactory),
      'Camera': new CameraCSS(cssFactory),
      'UploadPreview': new UploadPreviewCSS(cssFactory),
      'ComponentSet': new ComponentSetCSS(cssFactory)
    };
  }

  _createClass(CSSWidgetFactory, [{
    key: "getCSS_ComponentSet",
    value: function getCSS_ComponentSet(selector, style, widget) {
      Logger$1.log(5, 'getComponentSet', widget);
      return this.factories.ComponentSet.run(selector, style, widget);
    }
  }, {
    key: "getCSS_UploadPreview",
    value: function getCSS_UploadPreview(selector, style, widget) {
      Logger$1.log(5, 'getCSS_UploadPreview', widget);
      return this.factories.UploadPreview.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Camera",
    value: function getCSS_Camera(selector, style, widget) {
      Logger$1.log(5, 'getCSS_Camera', widget);
      return this.factories.Camera.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Upload",
    value: function getCSS_Upload(selector, style, widget) {
      Logger$1.log(5, 'getCSS_Upload', widget);
      return this.factories.Upload.run(selector, style, widget);
    }
  }, {
    key: "getCSS_BarChart",
    value: function getCSS_BarChart(selector, style, widget) {
      Logger$1.log(5, 'getCSS_BarChart', widget);
      return this.factories.BarChart.run(selector, style, widget);
    }
  }, {
    key: "getCSS_RingChart",
    value: function getCSS_RingChart(selector, style, widget) {
      Logger$1.log(5, 'getCSS_RingChart', widget);
      return this.factories.BarChart.run(selector, style, widget);
    }
  }, {
    key: "getCSS_SegmentButton",
    value: function getCSS_SegmentButton(selector, style, widget) {
      Logger$1.log(5, 'getCSS_SegmentButton', widget);
      return this.factories.Segment.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Timeline",
    value: function getCSS_Timeline(selector, style, widget) {
      Logger$1.log(5, 'getCSS_Timeline', widget);
      return this.factories.Timeline.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Vector",
    value: function getCSS_Vector(selector, style, widget) {
      Logger$1.log(5, 'getCSS_Vector', widget);
      return this.factories.Vector.run(selector, style, widget);
    }
  }, {
    key: "getCSS_PieChart",
    value: function getCSS_PieChart(selector, style, widget) {
      Logger$1.log(5, 'getCSS_PieChart', widget);
      return this.factories.BarChart.run(selector, style, widget);
    }
  }, {
    key: "getCSS_MultiRingChart",
    value: function getCSS_MultiRingChart(selector, style, widget) {
      Logger$1.log(5, 'getCSS_MultiRingChart', widget);
      return this.factories.BarChart.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Screen",
    value: function getCSS_Screen(selector, style, widget) {
      Logger$1.log(5, 'getCSS_Screen', widget);
      return this.factories.Screen.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Repeater",
    value: function getCSS_Repeater(selector, style, widget) {
      Logger$1.log(5, 'getCSS_Repeater', widget);
      return this.factories.Repeater.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Icon",
    value: function getCSS_Icon(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      result += this.cssFactory.getPosition(widget);
      result += "  font-size:".concat(widget.h, "px;\n");
      result += "  line-height:1;\n";
      result += '}\n\n';
      result += selector + ' .mdi:before {\n';
      result += "  font-size:".concat(widget.h, "px;\n");
      result += '}\n\n';
      return result;
    }
  }, {
    key: "getCSS_ChildrenToggle",
    value: function getCSS_ChildrenToggle(selector, style, widget) {
      /**
       * For now we assume this thingy has a fixed width...
       */
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      result += this.cssFactory.getPosition(widget);
      result += "  width:".concat(widget.w, "px;\n");
      result += '}\n\n';

      if (widget.active) {
        result += selector + '.qux-active {\n';
        result += this.getRawStyle(widget.active, widget);
        result += '}\n\n';
      }
      /**
       * We should add here still some other stuff for children...
       */


      return result;
    }
  }, {
    key: "getCSS_RadioGroup",
    value: function getCSS_RadioGroup(selector, style, widget) {
      var result = '';
      var correctedHeight = this.cssFactory.getCorrectedHeight(widget, false, widget.style.boxHeight);
      var height = widget.style.boxHeight + 'px';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += selector + '.qux-radiobox {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += this.cssFactory.getBackGround(style, widget);
      result += "  height:".concat(height, ";\n");
      result += "  width:".concat(height, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-radiobox-cntr {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += this.cssFactory.getBackGround(style, widget);
      result += "  height:".concat(correctedHeight, ";\n");
      result += "  width:".concat(correctedHeight, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-radiobox-hook {\n';
      result += "  background: ".concat(style.colorButton, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-radiobox-label {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.fontProperties);
      result += '}\n\n';

      if (widget.checked) {
        result += selector + '.qux-radiobox-checked .qux-radiobox-cntr {\n';
        result += this.cssFactory.getStyleByKey(widget.checked, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_CheckBoxGroup",
    value: function getCSS_CheckBoxGroup(selector, style, widget) {
      var result = '';
      var correctedHeight = this.cssFactory.getCorrectedHeight(widget, false, widget.style.boxHeight);
      var height = widget.style.boxHeight + 'px';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += selector + '.qux-checkbox {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += this.cssFactory.getBackGround(style, widget);
      result += "  height:".concat(height, ";\n");
      result += "  width:".concat(height, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-checkbox-cntr {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += this.cssFactory.getBackGround(style, widget);
      result += "  height:".concat(correctedHeight, ";\n");
      result += "  width:".concat(correctedHeight, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-checkbox-hook {\n';
      result += "  border-color: ".concat(style.colorButton, ";\n");
      result += "  border-bottom-width: ".concat(Math.round(height / 10), "px;\n");
      result += "  border-right-width:  ".concat(Math.round(height / 10), "px;\n");
      result += '}\n\n';
      result += selector + ' .qux-checkbox-label {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.fontProperties);
      result += '}\n\n';

      if (widget.checked) {
        result += selector + '.qux-checkbox-checked .qux-checkbox-cntr {\n';
        result += this.cssFactory.getStyleByKey(widget.checked, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_RadioBox2",
    value: function getCSS_RadioBox2(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += selector + ' .qux-radiobox-cntr {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += this.cssFactory.getBackGround(style, widget);
      result += "  height:".concat(this.cssFactory.getCorrectedHeight(widget), ";\n");
      result += "  width:".concat(this.cssFactory.getCorrectedWidth(widget), ";\n");
      result += '}\n\n';
      result += selector + ' .qux-radiobox-hook {\n';
      result += "  background: ".concat(style.colorButton, ";\n");
      result += '}\n\n';

      if (widget.checked) {
        result += selector + '.qux-radiobox-checked .qux-radiobox-cntr {\n';
        result += this.cssFactory.getStyleByKey(widget.checked, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_CheckBox",
    value: function getCSS_CheckBox(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget); // FIXME: we set width and height twice

      result += "  height:".concat(widget.h, "px;\n");
      result += "  width:".concat(widget.w, "px;\n");
      result += '}\n\n';
      result += selector + ' .qux-checkbox-cntr {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += this.cssFactory.getBackGround(style, widget);
      result += "  height:".concat(this.cssFactory.getCorrectedHeight(widget), ";\n");
      result += "  width:".concat(this.cssFactory.getCorrectedWidth(widget), ";\n");
      result += '}\n\n';
      result += selector + ' .qux-checkbox-hook {\n';
      result += "  border-color: ".concat(style.colorButton, ";\n");
      result += "  border-bottom-width: ".concat(Math.round(widget.h / 10), "px;\n");
      result += "  border-right-width:  ".concat(Math.round(widget.h / 10), "px;\n");
      result += '}\n\n';

      if (widget.checked) {
        result += selector + '.qux-checkbox-checked .qux-checkbox-cntr {\n';
        result += this.cssFactory.getStyleByKey(widget.checked, widget, this.cssFactory.borderColorProperties);
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_Switch",
    value: function getCSS_Switch(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      var cntrHeight = this.cssFactory.getCorrectedHeight(widget, false, widget.h);
      var cntrWidth = this.cssFactory.getCorrectedWidth(widget, false, widget.w);

      if (style.cssClass === 'MatcWidgetTypeSwitchThin') {
        cntrHeight = '50%';
      }

      result += selector + ' .qux-switch-cntr {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += "  height:".concat(cntrHeight, ";\n");
      result += "  width:".concat(cntrWidth, ";\n");
      result += '}\n\n';
      var borderWidthButton = style.borderWidthButton ? style.borderWidthButton : 0;
      var borderColorButton = style.borderColorButton ? style.borderColorButton : 'rgba(0,0,0,0)';
      result += selector + ' .qux-switch-handle {\n';
      result += "  background:".concat(style.colorButton, ";\n");
      result += "  border-radius:".concat(style.borderRadius, ";\n");
      result += "  border-width:".concat(borderWidthButton, "px;\n");
      result += "  border-color:".concat(borderColorButton, ";\n");
      result += this.cssFactory.getStyleByKey(style, widget, ['boxShadow']);
      result += "  height: ".concat(widget.h, "px;\n");
      result += "  width: ".concat(widget.h, "px;\n");
      result += '}\n\n';
      result += selector + '.qux-active .qux-switch-handle {\n';
      result += "  left:calc(100% - ".concat(widget.h, "px);\n");
      result += '}\n\n';
      result += selector + ' .qux-switch-on {\n';
      result += "  background:".concat(style.background, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-switch-off {\n';
      result += "  background:".concat(style.colorForeGround, ";\n");
      result += '}\n\n';
      return result;
    }
  }, {
    key: "getCSS_MobileDropDown",
    value: function getCSS_MobileDropDown(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n'; // make sure we have always some focus

      result += this.addOpenZIndex(selector);
      result += this._addCaret(selector, widget, style);
      result += selector + ' .qux-dropdown-popup {\n';
      result += "  background:".concat(style.popupBackground, ";\n");
      result += "  color:".concat(style.popupColor, ";\n");
      result += '}\n\n';

      if (widget.focus) {
        result += selector + ':hover {\n';
        result += this.cssFactory.getRawStyle(widget.focus, widget);
        result += '}\n\n';
        result += this._addCaret(selector + ':hover', widget, widget.focus);
        result += selector + ':hover .qux-dropdown-popup {\n';
        result += this.cssFactory.getStyleByKey(widget.focus, widget, this.cssFactory.borderProperties);
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_DropDown",
    value: function getCSS_DropDown(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += this._addCaret(selector, widget, style); // make sure we have always some focus

      result += this.addOpenZIndex(selector);
      result += selector + ':not(.qux-dropdown-mobile) .qux-dropdown-popup {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += '}\n\n';
      result += selector + ':not(.qux-dropdown-mobile) .qux-dropdown-item {\n';
      result += "  background:".concat(style.popupBackground, ";\n");
      result += "  color:".concat(style.popupColor, ";\n");
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.paddingProperties);
      result += '}\n\n';
      result += selector + ':not(.qux-dropdown-mobile) .qux-dropdown-item:hover {\n';
      result += "  background:".concat(style.selectedOptionBackground, ";\n");
      result += "  color:".concat(style.selectedOptionColor, ";\n");
      result += '}\n\n';

      if (widget.focus) {
        result += selector + ':hover {\n';
        result += this.cssFactory.getRawStyle(widget.focus, widget);
        result += '}\n\n';
        result += this._addCaret(selector + ':hover', widget, widget.focus);
        result += selector + ':hover .qux-dropdown-popup {\n';
        result += this.cssFactory.getStyleByKey(widget.focus, widget, this.cssFactory.borderProperties);
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "_addCaret",
    value: function _addCaret(selector, widget, style) {
      var result = '';

      if (widget.props && widget.props.caretBorderColor) {
        result += selector + ' .qux-dropdown-expend {\n';
        result += "  background:".concat(style._borderRightColor, ";\n");
        result += '}\n\n';
        result += selector + ' .qux-dropdown-carret {\n';
        result += "  color:".concat(style.background, ";\n");
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_Stepper",
    value: function getCSS_Stepper(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';

      if (widget.hover) {
        result += selector + ' .qux-stepper-btn:hover {\n';
        result += "  background:".concat(widget.hover.background, ";\n");
        result += "  color:".concat(widget.hover.color, ";\n");
        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_HSlider",
    value: function getCSS_HSlider(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += selector + ' .qux-slider-track {\n';
      result += "  background:".concat(style.background, ";\n");
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += '}\n\n';
      result += selector + ' .qux-slider-progress {\n';
      result += "  background:".concat(style.barColor, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-slider-handle  {\n';
      result += "  background:".concat(style.handleColor, ";\n");
      result += "  border-radius:".concat(style.handleRadius, "%;\n");
      result += "  height:".concat(style.handleHeight * widget.h, "px;\n");
      result += "  width:".concat(style.handleWidth, "px;\n");
      result += '}\n\n';
      result += selector + ' .qux-slider-handle-cntr  {\n';
      result += "  margin-left: ".concat(style.handleWidth / 2, "px;\n");
      result += "  width: calc(100% - ".concat(style.handleWidth, "px);\n");
      result += '}\n\n';
      return result;
    }
  }, {
    key: "getCSS_Date",
    value: function getCSS_Date(selector, style, widget) {
      var isInPopup = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var result = '';

      if (!isInPopup) {
        result += selector + ' {\n';
        result += this.cssFactory.getRawStyle(style, widget);
        result += this.cssFactory.getPosition(widget);
        result += '}\n\n';
      }

      if (style.tableBorderWidth) {
        result += selector + ' table {\n';
        result += "  border-spacing:".concat(style.tableBorderWidth, "px;\n");
        result += "  border-collapse: separate;\n";
        result += '}\n\n';
      }

      result += selector + ' .qux-date-week-days {\n';
      result += "  background:".concat(style.tableHeaderBackground, ";\n");
      result += "  color:".concat(style.tableHeaderColor, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-date-header {\n';
      result += "  background:".concat(style.headerBackground, ";\n");
      result += "  color:".concat(style.headerColor, ";\n");
      result += '}\n\n';

      if (style.weekendBackground && style.weekendColor) {
        result += selector + ' .qux-date-weekend {\n';
        result += "  background:".concat(style.weekendBackground, ";\n");
        result += "  color:".concat(style.weekendColor, ";\n");
        result += '}\n\n';
      }

      if (style.weekdayBackground && style.weekdayColor) {
        result += selector + ' .qux-date-workday {\n';
        result += "  background:".concat(style.weekdayBackground, ";\n");
        result += "  color:".concat(style.weekdayColor, ";\n");
        result += '}\n\n';
      }

      if (widget.props.range) {
        result += selector + ' .qux-date-range-start {\n';
        result += "  background:".concat(style.selectedBackground, ";\n");
        result += "  color:".concat(style.selectedColor, ";\n");

        if (style.itemBorderRadius) {
          result += "  border-radius:".concat(style.itemBorderRadius, "%;\n");
        }

        result += '}\n\n';
        result += selector + ' .qux-date-range-end {\n';
        result += "  background:".concat(style.selectedBackground, ";\n");
        result += "  color:".concat(style.selectedColor, ";\n");

        if (style.itemBorderRadius) {
          result += "  border-radius:".concat(style.itemBorderRadius, "%;\n");
        }

        result += '}\n\n';
        result += selector + ' .qux-date-range-middle {\n';
        result += "  background:".concat(style.selectedInRangeBackground, ";\n");
        result += "  color:".concat(style.selectedInRangeColor, ";\n");

        if (style.itemBorderRadius) {
          result += "  border-radius:".concat(style.itemBorderRadius, "%;\n");
        }

        result += '}\n\n';
      } else {
        result += selector + ' .qux-date-selected {\n';
        result += "  background:".concat(style.selectedBackground, ";\n");
        result += "  color:".concat(style.selectedColor, ";\n");

        if (style.itemBorderRadius) {
          result += "  border-radius:".concat(style.itemBorderRadius, "%;\n");
        }

        result += '}\n\n';
      }

      return result;
    }
  }, {
    key: "getCSS_DateDropDown",
    value: function getCSS_DateDropDown(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n'; // make sure we have always some focus

      result += this.addOpenZIndex(selector);
      result += this._addCaret(selector, widget, style);
      result += selector + ' .qux-date-picker-popup {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += "  width:".concat(style.fontSize * 18, "px;\n");
      result += "  height:".concat(style.fontSize * 18, "px;\n");
      result += '}\n\n';
      result += this.getCSS_Date(selector + " .qux-date-picker-popup", style, widget, true);
      return result;
    }
  }, {
    key: "getCSS_Rating",
    value: function getCSS_Rating(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += "  color:".concat(style.color, ";\n");
      result += "  font-size:".concat(widget.h, "px;\n");
      result += '}\n\n';
      return result;
    }
  }, {
    key: "getCSS_LabeledIconToggle",
    value: function getCSS_LabeledIconToggle(selector, style, widget) {
      return this.getCSS_IconToggle(selector, style, widget);
    }
  }, {
    key: "getCSS_IconToggle",
    value: function getCSS_IconToggle(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.textProperties);
      result += "  color:".concat(style.passiveColor, ";\n");
      result += "  font-size:".concat(style.fontSize, "px;\n");
      result += '}\n\n';
      result += selector + '.qux-icon-toggle-selected {\n';
      result += "  color:".concat(style.activeColor, ";\n");
      result += '}\n\n';
      result += selector + ' .qux-icon {\n';
      result += "  font-size:".concat(widget.h, "px;\n");
      result += '}\n\n';
      return result;
    }
  }, {
    key: "getCSS_TypeAheadTextBox",
    value: function getCSS_TypeAheadTextBox(selector, style, widget) {
      var result = '';
      result += selector + ' {\n';
      result += this.cssFactory.getPosition(widget);
      result += '}\n\n';
      result += selector + ' .qux-combo-input {\n';
      result += this.cssFactory.getRawStyle(style, widget);
      var paddingH = style._paddingLeft + style._paddingRight;
      var paddingV = style._paddingTop + style._paddingBottom;
      result += "  width:calc(100% - ".concat(paddingH, "px);\n");
      result += "  height:calc(100% - ".concat(paddingV, "px);\n");
      result += '}\n\n'; // make sure we have always some focus

      result += this.addOpenZIndex(selector);
      result += selector + ' .qux-combo-popup {\n';
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.borderProperties);
      result += '}\n\n';
      result += selector + ' .qux-combo-item {\n';
      result += "  background:".concat(style.background, ";\n");
      result += "  color:".concat(style.color, ";\n");
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.paddingProperties);
      result += '}\n\n';
      result += selector + ' .qux-combo-item:hover,\n';
      result += selector + ' .qux-combo-item-selected {\n';
      result += "  background:".concat(style.selectedOptionBackground, ";\n");
      result += this.cssFactory.getStyleByKey(style, widget, this.cssFactory.paddingProperties);
      result += "  color:".concat(style.selectedOptionColor, ";\n");
      result += '}\n\n'; // FIXME: make here a default style for mobile?

      if (widget.focus) {
        result += selector + ':hover {\n';
        result += this.cssFactory.getRawStyle(widget.focus, widget);
        result += '}\n\n';
        result += this._addCaret(selector + ':hover', widget, widget.focus); //result += selector + ':hover .qux-combo-popup {\n'
        //result += this.cssFactory.getStyleByKey(widget.focus, widget, this.cssFactory.borderProperties)
        //result += '}\n\n'
      }

      return result;
    }
  }, {
    key: "getCSS_Image",
    value: function getCSS_Image(selector, style, widget) {
      return this.factories.Image.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Paging",
    value: function getCSS_Paging(selector, style, widget) {
      return this.factories.Paging.run(selector, style, widget);
    }
  }, {
    key: "getCSS_Table",
    value: function getCSS_Table(selector, style, widget) {
      return this.factories.Table.run(selector, style, widget);
    }
  }, {
    key: "addOpenZIndex",
    value: function addOpenZIndex(selector) {
      var result = '';
      result += selector + '.qux-open {\n';
      result += "  z-index: 1000;\n";
      result += '}\n\n';
      return result;
    }
  }]);

  return CSSWidgetFactory;
}();

var CSSLayouter = /*#__PURE__*/function () {
  function CSSLayouter(config, f) {
    _classCallCheck(this, CSSLayouter);

    this.cssFacotory = f;
    this.gridAutoErrorThreshold = 5;

    if (config.css) {
      this.isForceGrid = config.css.grid;
      this.justifyContentInWrapper = config.css.justifyContentInWrapper;
      this.prefix = config.css.prefix ? config.css.prefix : '';
      this.gridAutoErrorThreshold = config.css.gridAutoErrorThreshold ? config.css.gridAutoErrorThreshold : 5;
    }

    if (config.responsive) {
      this.responsive = config.responsive;
    }

    this.ignoreCorrectWidthAndHeigth = ['CheckBox', 'RadioBox', 'RadioBox2', 'Switch', 'Stepper', 'TypeAheadTextBox', 'Paging', 'Camera'];
    this.heightProperties = ['paddingTop', '_paddingTop', 'paddingBottom', '_paddingBottom', 'borderTopWidth', '_borderTopWidth', 'borderBottomWidth', '_borderBottomWidth'];
    this.widthProperties = ['paddingLeft', '_paddingLeft', 'paddingRight', '_paddingRight', 'borderLeftWidth', '_borderLeftWidth', 'borderRightWidth', '_borderRightWidth'];
  }
  /*********************************************************************
   * Design System
   *********************************************************************/


  _createClass(CSSLayouter, [{
    key: "getDesignSystemPosition",
    value: function getDesignSystemPosition(widget) {
      Logger$1.log(3, "CSSLayouter.getDesignSystemPosition()" + widget.name, widget);
      var result = "";
      /**
       * ComponentSet are just placed as block or inline block. The child will
       * determine the size. This will happen the ComponenSetCSS.js file
       * TODO factor this out...
       */

      if (isComponentSet(widget)) {
        if (isBlock(widget)) {
          result += "  display:block;\n";
        } else {
          result += "  display:inline-block;\n";
        }
      } else {
        /**
         * For all other components we set (inline)grid or block,
         * with and height and a grid of needed-
         */
        if (this.isGrid(widget)) {
          if (isBlock(widget)) {
            result += "  display:grid;\n";
          } else {
            result += "  display:inline-grid;\n";
          }
        } else if (isBlock(widget)) {
          result += "  display:block;\n";
        } else {
          result += "  display:inline-block;\n";
        }
        /**
         * For wrapped we just add margins
         */


        if (isFixedHorizontal(widget)) {
          result += "  width: ".concat(this.getCorrectedWidth(widget), ";\n");
        } else if (hasMinMaxWdith(widget)) {
          result += this.getMinMaxWidth(widget, false);
        } else {
          result += "  width: auto;\n";
        }

        if (isFixedVertical(widget)) {
          result += "  height: ".concat(this.getCorrectedHeight(widget), ";\n");
        } else {
          result += "  min-height: ".concat(this.getCorrectedHeight(widget), ";\n");
        }

        if (hasGrid(widget) && hasChildren(widget)) {
          Logger$1.log(3, "CSSFactory.getComponentScreenPosition() > add grid" + widget.name);
          result += "  grid-template-columns: " + this.getGridColumnTracks(widget.w, widget.grid.columns, widget) + ";\n";
          result += "  grid-template-rows: " + this.getGridRowTracks(widget.h, widget.grid.rows, widget) + ";\n";
        }
      }

      return result;
    }
  }, {
    key: "getMinMaxWidth",
    value: function getMinMaxWidth(widget) {
      var isWrapped = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var result = "";

      if (widget.style && widget.style.minWidth) {
        result += "  min-width: ".concat(widget.style.minWidth, "px;\n");
      }

      if (widget.style && widget.style.maxWidth) {
        result += "  max-width: ".concat(widget.style.maxWidth, "px;\n");
      }
      /**
       * We need to make sure that we also include the reponsive with,
       * to make it 'push' outwards
       */


      if (isWrapped) {
        result += "  width: ".concat(this.getResponsiveWidth(widget), ";\n");
      }

      return result;
    }
  }, {
    key: "isInlineBlock",
    value: function isInlineBlock(widget) {
      return widget.qtype !== 'qContainer';
    }
  }, {
    key: "isGrid",
    value: function isGrid(widget) {
      return hasGrid(widget) && hasChildren(widget);
    }
    /*********************************************************************
     * Child of component screen
     *********************************************************************/

  }, {
    key: "getComponentScreenPosition",
    value: function getComponentScreenPosition(widget) {
      Logger$1.log(3, "CSSFactory.getComponentScreenPosition()" + widget.name);
      var result = "";
      /**
       * For wrapped we just add margins
       */

      result += "  height:100%;\n";
      result += "  width: 100%;\n";

      if (hasGrid(widget)) {
        Logger$1.log(-1, "CSSFactory.getComponentScreenPosition() > add grid" + widget.name);
        result += "  display: grid;\n";
        result += "  grid-template-columns: " + this.getGridColumnTracks(widget.w, widget.grid.columns, widget) + ";\n";
        result += "  grid-template-rows: " + this.getGridRowTracks(widget.h, widget.grid.rows, widget) + ";\n";
      }

      return result;
    }
    /*********************************************************************
     * Wrapped Position
     *********************************************************************/

  }, {
    key: "getWrappedPosition",
    value: function getWrappedPosition(widget) {
      Logger$1.log(3, "CSSFactory.getWrappedPosition()" + widget.name);
      var result = "";
      /**
       * For wrapped we just add margins
       */

      result += "  min-height: ".concat(this.getWrappedHeight(widget), ";\n");
      result += this.getWrappedWidth(widget);

      if (widget.wrapOffSetBottom && widget.wrapOffSetRight && !this.justifyContentInWrapper) {
        result += "  margin-bottom: ".concat(widget.wrapOffSetBottom, "px ;\n");
        result += "  margin-right: ".concat(widget.wrapOffSetRight, "px ;\n");
      } else {
        result += "  margin: ".concat(widget.wrapOffSetY, "px ").concat(widget.wrapOffSetX, "px;\n");
      }
      /**
       * If the wrapped element has a grid, add it as well
       */


      if (hasGrid(widget)) {
        Logger$1.log(3, "CSSFactory.getWrappedPosition() > add grid" + widget.name);
        result += "  display: grid;\n";
        result += "  grid-template-columns: " + this.getGridColumnTracks(widget.w, widget.grid.columns, widget) + ";\n";
        result += "  grid-template-rows: " + this.getGridRowTracks(widget.h, widget.grid.rows, widget) + ";\n";
      } else {
        widget.grid.isRow = true;
        result += "  display: flex;\n";
        result += "  flex-direction: column;\n";
      }

      return result;
    }
  }, {
    key: "getWrappedEnd",
    value: function getWrappedEnd(selector, widget) {
      var result = "";

      if (isWrappedContainer(widget)) {
        result += selector + ":after {\n";
        result += "  content:'';\n";
        result += "  flex:auto;\n";
        result += "}\n\n";
      }

      return result;
    }
  }, {
    key: "getWrappedHeight",
    value: function getWrappedHeight(widget) {
      return this.getCorrectedHeight(widget);
    }
  }, {
    key: "getWrappedWidth",
    value: function getWrappedWidth(widget) {
      Logger$1.log(-1, "CSSFactory.getWrappedWidth() " + widget.name, hasMinMaxWdith(widget));

      if (hasMinMaxWdith(widget)) {
        return this.getMinMaxWidth(widget, true);
      }

      if (this.isFixedHorizontal(widget)) {
        return "  width: ".concat(this.getFixedWidth(widget), ";\n");
      }

      return "  width: ".concat(this.getResponsiveWidth(widget), ";\n");
    }
  }, {
    key: "setRepeaterContainer",
    value: function setRepeaterContainer(widget) {
      Logger$1.log(5, "CSSFactory.setRepeaterContainer() " + widget.name);
      var result = "";
      result += "  display: flex;\n";
      result += "  flex-direction: row;\n";
      result += "  flex-wrap: wrap;\n";
      result += "  align-items: flex-start;\n";
      result += "  align-content: flex-start;\n";

      if (isRepeaterAuto(widget)) {
        result += "  justify-content: space-between;\n";
      }

      return result;
    }
  }, {
    key: "setWrappedContainer",
    value: function setWrappedContainer(widget) {
      Logger$1.log(4, "CSSFactory.setWrappedContainer() " + widget.name);
      var result = "";
      result += "  display: flex;\n";
      result += "  flex-direction: row;\n";
      result += "  flex-wrap: wrap;\n";
      result += "  align-items: flex-start;\n";
      result += "  align-content: flex-start;\n";

      if (this.justifyContentInWrapper) {
        result += "  justify-content: space-between;\n";
      }

      return result;
    }
    /*********************************************************************
     * Grid Position
     *********************************************************************/

  }, {
    key: "getGridPosition",
    value: function getGridPosition(widget) {
      Logger$1.log(3, "CSSFactory.getGridPosition() > " + widget.name, widget);
      var result = "";
      /**
       * First determine how we align the children
       */

      if (widget.grid) {
        result = this.getGridChildAlignment(widget);
      }
      /**
       * Second align to parent
       */


      result += this.getGridParentAlign(widget);
      return result;
    }
  }, {
    key: "getGridChildAlignment",
    value: function getGridChildAlignment(widget) {
      var result = "";

      if (isWrappedContainer(widget)) {
        result += this.setWrappedContainer(widget);
      } else if (isRepeaterGrid(widget)) {
        result += this.setRepeaterContainer(widget);
      } else if (isRowGrid(widget) && !widget.isComponentScreen) {
        /**
         * FIXME: Move this code to the model transformer. The isRow value
         * will be later used in the getGridParentAlign() method
         */
        if (!widget.grid) {
          widget.grid = {};
        }

        widget.grid.isRow = true;
        result += "  display: flex;\n";
        result += "  flex-direction: column;\n";
      } else {
        result += "  display: grid;\n";
        result += "  grid-template-columns: " + this.getGridColumnTracks(widget.w, widget.grid.columns, widget) + ";\n";
        result += "  grid-template-rows: " + this.getGridRowTracks(widget.h, widget.grid.rows, widget, true) + ";\n";
      }

      return result;
    }
  }, {
    key: "getGridParentAlign",
    value: function getGridParentAlign(widget) {
      Logger$1.log(6, "CSSFactory.getGridParentAlign() > " + widget.name, widget);
      var result = "";

      if (hasParentRepeaterGrid(widget)) {
        Logger$1.log(3, "CSSFactory.getGridParentAlign() > " + widget.name, widget);
        /**
         * FIXME: Do we need this?
         * in a repeater we have a parent element that was
         * aligned by the Grid (qux-repeater-child). We just set the
         * width
         */

        result += "  width: 100%;\n";

        if (isFixedVertical(widget)) {
          result += "  height: ".concat(this.getCorrectedHeight(widget, true), ";\n");
        } else {
          result += "  min-height: ".concat(this.getCorrectedHeight(widget, true), ";\n");
          result += "  height: 100%;\n";
        }
      } else if (widget.parent) {
        /**
         * Check if we have to do a normal flex layout because the grid
         * is row (=== 1 columns)
         */
        if (widget.parent.grid && widget.parent.grid.isRow) {
          result += this.getGridParentRowAlignment(widget);
        } else {
          result += "  grid-column-start: ".concat(widget.gridColumnStart + 1, ";\n");
          result += "  grid-column-end: ".concat(widget.gridColumnEnd + 1, ";\n");
          result += "  grid-row-start: ".concat(widget.gridRowStart + 1, ";\n");
          result += "  grid-row-end: ".concat(widget.gridRowEnd + 1, ";\n");

          if (widget.z) {
            result += "  z-index: ".concat(widget.z, ";\n");
          }
        }
      } else {
        if (this.isForceGrid && isScreen(widget)) {
          result += "  min-height: ".concat(widget.h, "px;\n");
        } else {
          result += "  min-height: 100%;\n";
        }
      }

      return result;
    }
    /**
     * Normal alignment when places as rows in flex
     */

  }, {
    key: "getGridParentRowAlignment",
    value: function getGridParentRowAlignment(widget) {
      Logger$1.log(5, "CSSFactory.getGridParentRowAlignment() > as row: ", widget.name, widget);
      var result = "";

      if (this.isPinnedLeft(widget) && this.isPinnedRight(widget)) {
        result += "  margin-left: ".concat(this.getPinnedLeft(widget), ";\n");
        result += "  margin-right: ".concat(this.getPinnedRight(widget), ";\n");
      } else if (this.isPinnedLeft(widget)) {
        if (this.isFixedHorizontal(widget)) {
          result += "  width: ".concat(this.getFixedWidth(widget), ";\n");
          result += "  margin-left: ".concat(this.getPinnedLeft(widget), ";\n");
        } else {
          result += "  margin-right: ".concat(this.getResponsiveRight(widget), ";\n");
          result += "  margin-left: ".concat(this.getPinnedLeft(widget), ";\n");
        }
      } else if (this.isPinnedRight(widget)) {
        /**
         * This is a tricky one.
         */
        if (this.isFixedHorizontal(widget)) {
          result += "  width: ".concat(this.getFixedWidth(widget), ";\n");
          result += "  margin-left: ".concat(this.getCalcLeft(widget), ";\n");
        } else {
          /**
           * TODO: can we use somehow a reposnive calculated left?
           */
          result += "  margin-left: ".concat(this.getResponsiveLeft(widget), ";\n");
          result += "  margin-right: ".concat(this.getPinnedRight(widget), ";\n");
        }
      } else {
        /**
         * Nothing is pinned.
         * We are in a rowGrid, this means the widget is alone. Therefore
         * we can set the margin left and right and not the width.
         */
        if (this.isFixedHorizontal(widget)) {
          if (isCentered(widget)) {
            result += "  width: ".concat(this.getFixedWidth(widget), ";\n");
            result += "  margin-left: auto;\n";
            result += "  margin-right: auto;\n";
          } else {
            result += "  width: ".concat(this.getFixedWidth(widget), ";\n");
            result += "  margin-left: ".concat(this.getResponsiveLeft(widget), ";\n");
          }
        } else {
          result += "  margin-right: ".concat(this.getResponsiveRight(widget), ";\n");
          result += "  margin-left: ".concat(this.getResponsiveLeft(widget), ";\n");
        }
      }

      if (isFixedVertical(widget)) {
        result += "  height: ".concat(this.getCorrectedHeight(widget, true), ";\n");
      } else {
        result += "  min-height: ".concat(this.getCorrectedHeight(widget, true), ";\n");
      }

      result += "  margin-top: ".concat(this.getPinnedTop(widget), ";\n");
      return result;
    }
    /**
     * Returns the tracks for the grid. It makes sure the biggest element
     * is auto, so the grid is responsive... we could also use minmax()
     */

  }, {
    key: "getGridColumnTracks",
    value: function getGridColumnTracks(total, list) {
      var _this = this;

      Logger$1.log(6, "CSSFactory.getGridColumnTracks() > ", list);

      if (list) {
        /**
         * FIXME: we could get the max not fixed. Still we would
         * need to make sure we get the fixed stuff
         */
        var max = Math.max.apply(Math, _toConsumableArray(list.map(function (i) {
          return i.l;
        })));
        return list.map(function (i) {
          /**
           * We might want several autos. This is very sensitive
           * to small changes in the editor. Therefore we give a
           * small error margin. Use minmax to prevent blowout
           * https://css-tricks.com/preventing-a-grid-blowout/
           */
          if (Math.abs(max - i.l) <= _this.gridAutoErrorThreshold) {
            // max === i.l

            /**
             * If we have a min max , we use max-content.
             */
            if (i.hasMinMax) {
              return "minmax(0,max-content)"; //'1fr'
            } else {
                return "minmax(0,1fr)"; //'1fr'
              }
          } // TODO: Check if we have min max??????

          /**
           * Fixed has priority. For rows we have always fixed...
           */


          if (i.fixed) {
            return i.l + "px";
          }

          return Math.round(i.l * 100 / total) + "%";
        }).join(" ");
      }
    }
  }, {
    key: "getGridRowTracks",
    value: function getGridRowTracks(total, rows) {
      Logger$1.log(6, "CSSFactory.getGridRowTracks() > ", rows);

      if (rows) {
        return rows.map(function (row, index) {
          /**
           * The last row will be free space, if it is
           * not fixed
           */
          if (!row.fixed && index === rows.length - 1) {
            return "1fr";
          }
          /**
           * Fixed rows or spacer (no element starts here, or first)
           * rows have a fixed size. Everything else is minmax
           */


          if (row.fixed || row.start.length === 0 || index === 0) {
            return Math.round(row.l) + "px";
          }

          return "minmax(".concat(Math.round(row.l), "px, auto)");
        }).join(" ");
      }
    }
    /*********************************************************************
     * Position Helpers
     *********************************************************************/

  }, {
    key: "isPinnedLeft",
    value: function isPinnedLeft$1(widget) {
      return isPinnedLeft(widget);
    }
  }, {
    key: "isPinnedRight",
    value: function isPinnedRight$1(widget) {
      return isPinnedRight(widget);
    }
  }, {
    key: "getPinnedBottom",
    value: function getPinnedBottom(widget) {
      if (widget.parent) {
        var parent = widget.parent;
        var innerHeight = parent.children.map(function (c) {
          // grid has top
          if (c.top != undefined) {
            return c.h + c.top;
          }

          return c.h + c.y;
        }).reduce(function (a, b) {
          return a + b;
        }, 0);
        return Math.max(0, parent.h - innerHeight) + "px";
      }

      return "auto";
    }
  }, {
    key: "getFixedWidth",
    value: function getFixedWidth(widget) {
      if (isFullWidth(widget)) {
        return "100%";
      }

      return widget.w + "px";
    }
  }, {
    key: "getFixedTop",
    value: function getFixedTop(widget) {
      return widget.y + "px";
    }
  }, {
    key: "getPinnedTop",
    value: function getPinnedTop(widget) {
      return widget.top + "px";
    }
  }, {
    key: "getCalcLeft",
    value: function getCalcLeft(widget) {
      if (widget.parent) {
        var right = widget.parent.w - (widget.x + widget.w);
        return "calc(100% - ".concat(widget.w + right, "px)");
      }

      return "0px";
    }
  }, {
    key: "getResponsiveLeft",
    value: function getResponsiveLeft(widget) {
      if (widget.parent) {
        return Math.round(widget.x * 100 / widget.parent.w) + "%";
      }

      return widget.x + "px";
    }
  }, {
    key: "getResponsiveRight",
    value: function getResponsiveRight(widget) {
      if (widget.parent) {
        var right = widget.parent.w - (widget.x + widget.w);
        return Math.round(right * 100 / widget.parent.w) + "%";
      }

      return widget.x + "px";
    }
  }, {
    key: "getPinnedLeft",
    value: function getPinnedLeft(widget) {
      return widget.x + "px";
    }
  }, {
    key: "getPinnedRight",
    value: function getPinnedRight(widget) {
      if (widget.parent) {
        if (widget.absX) {
          return widget.parent.w - (widget.absX + widget.w) + "px";
        } else {
          return widget.parent.w - (widget.x + widget.w) + "px";
        }
      }

      return "0px";
    }
  }, {
    key: "getResponsiveWidth",
    value: function getResponsiveWidth(widget) {
      if (widget.parent) {
        /**
         * What about border...
         */
        return Math.round(widget.w * 100 / widget.parent.w) + "%";
      }

      Logger$1.warn("CSSFactory.getResponsiveWidth() > No parent! " + widget.name);
      return "100%";
    }
  }, {
    key: "getFixedHeight",
    value: function getFixedHeight(widget) {
      return widget.h + "px";
    }
  }, {
    key: "getCorrectedHeight",
    value: function getCorrectedHeight(widget) {
      var isPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

      if (h < 0) {
        h = widget.h;
      }
      /**
       * when we are positioning, we only sustract
       * for certain widgets
       */


      if (isPosition && this.ignoreCorrectWidthAndHeigth.indexOf(widget.type) >= 0) {
        return h + "px";
      }

      this.heightProperties.forEach(function (key) {
        if (widget.style[key]) {
          h -= widget.style[key];
        }
      });
      return h + "px";
    }
  }, {
    key: "getCorrectedWidth",
    value: function getCorrectedWidth(widget) {
      var isPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var w = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

      if (w < 0) {
        w = widget.w;
      }

      if (isPosition && this.ignoreCorrectWidthAndHeigth.indexOf(widget.type) >= 0) {
        return w + "px";
      }

      this.widthProperties.forEach(function (key) {
        if (widget.style[key]) {
          w -= widget.style[key];
        }
      });
      return w + "px";
    }
  }, {
    key: "isFixedHorizontal",
    value: function isFixedHorizontal$1(widget) {
      return isFixedHorizontal(widget);
    }
    /*********************************************************************
     * Fixed Position
     *********************************************************************/

  }, {
    key: "getFixedPosition",
    value: function getFixedPosition(widget) {
      var result = "  position: fixed;\n";

      if (this.isFixedHorizontal(widget)) {
        result += "  width: ".concat(this.getFixedWidth(widget), ";\n");
      } else {
        result += "  width: ".concat(this.getResponsiveWidth(widget), ";\n");
      }

      if (isPinnedLeft(widget)) {
        result += "  left: ".concat(this.getPinnedLeft(widget), ";\n");
      } else if (isPinnedRight(widget)) {
        result += "  right: ".concat(this.getPinnedRight(widget), ";\n");
      } else {
        result += "  left: ".concat(this.getResponsiveLeft(widget), ";\n");
      }

      if (isPinnedDown(widget)) {
        result += "  bottom: ".concat(widget.bottom, "px;\n");
      } else {
        result += "  top: ".concat(widget.y, "px;\n");
      }

      result += "  height: ".concat(this.getCorrectedHeight(widget), ";\n");
      /**
       * Align children in grid
       */

      result += this.getGridChildAlignment(widget);
      return result;
    }
  }, {
    key: "getAbsolutePosition",
    value: function getAbsolutePosition(widget) {
      var result = "";
      /**
       * If the widget is on the root level, we use teh screen!
       */

      var w = widget.w;
      var h = widget.h;
      var top = widget.y;
      var left = Math.max(0, widget.x - this.marginWhiteSpaceCorrect);
      var unitX = "px";
      var unitY = "px";
      /**
       * Take padding and border into account into account
       */

      if (widget.style) {
        if (widget.style.paddingTop) {
          h -= widget.style.paddingTop;
        }

        if (widget.style.paddingBottom) {
          h -= widget.style.paddingBottom;
        }

        if (widget.style.paddingLeft) {
          w -= widget.style.paddingLeft;
        }

        if (widget.style.paddingRight) {
          w -= widget.style.paddingRight;
        }

        if (widget.style.borderTopWidth) {
          h -= widget.style.borderTopWidth;
        }

        if (widget.style.borderBottomWidth) {
          h -= widget.style.borderBottomWidth;
        }

        if (widget.style.borderLeftWidth) {
          w -= widget.style.borderLeftWidth;
        }

        if (widget.style.borderRightWidth) {
          w -= widget.style.borderRightWidth;
        }
      }
      /**
       * To deal with margin collapsing we set things to inline-block. We could
       * still check for borders...
       */


      if (this.getSiblings(widget).length > 1) {
        result += "  display: inline-block;\n";
      }

      result += "  width: ".concat(w, "px;\n");
      result += "  min-height: ".concat(h).concat(unitY, ";\n");
      result += "  margin-top: ".concat(top).concat(unitY, ";\n");
      result += "  margin-left: ".concat(left).concat(unitX, ";\n");
      return result;
    }
  }, {
    key: "getSiblings",
    value: function getSiblings(widget) {
      if (widget.parent && widget.parent.children) {
        return widget.parent && widget.parent.children;
      }

      return [];
    }
  }]);

  return CSSLayouter;
}();

var CSSFactory = /*#__PURE__*/function () {
  function CSSFactory() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var imagePrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _classCallCheck(this, CSSFactory);

    Logger$1.log(4, 'CSSFactory.constructor() ', config);
    this.marginWhiteSpaceCorrect = 0;
    this.imagePrefix = imagePrefix;
    this.responsive = {
      mobile: {
        min: 0,
        max: 400
      },
      tablet: {
        min: 401,
        max: 1000
      },
      desktop: {
        min: 1201,
        max: 1000000
      }
    };

    if (config.css) {
      this.prefix = config.css.prefix ? config.css.prefix : '';
    }

    if (config.responsive) {
      this.responsive = config.responsive;
    }

    this.mapping = {
      "color": "color",
      "textAlign": "text-align",
      "fontFamily": "font-family",
      "fontSize": "font-size",
      "fontStyle": "font-style",
      "fontWeight": "font-weight",
      "letterSpacing": "letter-spacing",
      "lineHeight": "line-height",
      "border": "border",
      "borderWidth": "border-width",
      "borderStyle": "border-style",
      "borderColor": "border-color",
      "borderRadius": "border-radius",
      "borderLeft": "border-left",
      "borderRight": "border-right",
      "borderTop": "border-top",
      "borderBottom": "border-bottom",
      "borderBottomColor": "border-bottom-color",
      "borderTopColor": "border-top-color",
      "borderLeftColor": "border-left-color",
      "borderRightColor": "border-right-color",
      "borderBottomLeftRadius": "border-bottom-left-radius",
      "borderTopLeftRadius": "border-top-left-radius",
      "borderBottomRightRadius": "border-bottom-right-radius",
      "borderTopRightRadius": "border-top-right-radius",
      "borderBottomWidth": "border-bottom-width",
      "borderTopWidth": "border-top-width",
      "borderLeftWidth": "border-left-width",
      "borderRightWidth": "border-right-width",
      "borderTopStyle": "border-top-style",
      "borderBottomStyle": "border-bottom-style",
      "borderRightStyle": "border-left-style",
      "borderLeftStyle": "border-right-style",
      "paddingBottom": "padding-bottom",
      "paddingLeft": "padding-left",
      "paddingRight": "padding-right",
      "paddingTop": "padding-top",
      "padding": "padding",
      //"marginBottom" : "margin-bottom",
      //"marginLeft" : "margin-left",
      //"marginRight" : "margin-right",
      //"marginTop": "margin-top",
      "textDecoration": "text-decoration",
      "boxShadow": "box-shadow",
      "textShadow": "text-shadow",
      "opacity": "opacity"
    };
    this.paddingProperties = ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "padding"];
    this.borderProperties = ['borderWidth', 'border', 'borderRadius', 'boderColor', 'borderBottomColor', 'borderTopColor', 'borderLeftColor', 'borderRightColor', 'borderTopStyle', 'borderBottomStyle', 'borderRightStyle', 'borderLeftStyle', 'borderBottomWidth', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomLeftRadius', 'borderTopLeftRadius', 'borderBottomRightRadius', 'borderTopRightRadius'];
    this.borderColorProperties = ['borderBottomColor', 'borderTopColor', 'borderLeftColor', 'borderRightColor'];
    this.borderWidthProperties = ['borderBottomWidth', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth'];
    this.borderStyleProperties = ['borderTopStyle', 'borderBottomStyle', 'borderRightStyle', 'borderLeftStyle'];
    this.borderRadiusProperties = ['borderBottomLeftRadius', 'borderTopLeftRadius', 'borderBottomRightRadius', 'borderTopRightRadius'];
    this.textProperties = ['color', 'textDecoration', 'textAlign', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight'];
    this.isPixel = {
      "borderBottomLeftRadius": true,
      "borderBottomRightRadius": true,
      "borderTopRightRadius": true,
      "borderTopLeftRadius": true,
      "borderBottomWidth": true,
      "borderLeftWidth": true,
      "borderTopWidth": true,
      "borderRightWidth": true,
      "paddingBottom": true,
      "paddingLeft": true,
      "paddingRight": true,
      "paddingTop": true,
      "fontSize": true,
      "letterSpacing": true
    };
    this.easingMapping = {
      'easeInQuad': 'ease-in',
      'easeOutQuad': 'ease-out',
      'linear': 'linear',
      'easeInOutQuad': 'ease-in-out',
      'easeElasticIn': 'ease-in',
      'easeElasticOut': 'ease-out',
      'easeBounceIn': 'ease-in',
      'easeBounceOut': 'ease-out'
    };
    this.fontProperties = ['color', 'fontSize', 'fontWeight', 'textAlign', 'fontStyle', 'letterSpacing', 'lineHeight']; //this.isAlwaysFixedHorizontal = ['Switch', 'Stepper']

    this.widgetFactory = new CSSWidgetFactory(this);
    this.positionFactory = new CSSLayouter(config, this);
  }

  _createClass(CSSFactory, [{
    key: "generate",
    value: function generate(model) {
      var _this = this;

      var start = new Date().getTime();
      var result = {};
      /**
       * Generate the template styles
       */

      model.templates.forEach(function (t) {
        if (t.style) {
          var style = {
            type: 'template',
            css: t.cssSelector,
            global: true,
            code: _this.getCSS(t, null, false)
          };
          result[t.id] = [style];
        }
      });
      /**
       * Generate styles for each screen. The templates styles
       * might here be reused!
       */

      model.screens.forEach(function (screen) {
        result[screen.id] = [];
        result[screen.id].push({
          type: 'screen',
          css: screen.cssSelector,
          global: false,
          code: _this.getCSS(screen)
        });
        screen.children.forEach(function (child) {
          _this.generateElement(child, result, screen);
        });
        screen.fixedChildren.forEach(function (child) {
          _this.generateElement(child, result, screen);
        });
      });
      /**
       * Add some normalizer styles
       */

      result['$NORMALIZE'] = [];
      result['$NORMALIZE'].push({
        type: 'screen',
        css: '',
        global: true,
        code: this.getGlobalStyles()
      });
      var end = new Date().getTime();
      Logger$1.log(-1, 'CSSFactory.generate() > took ', end - start);
      return result;
    }
  }, {
    key: "getGlobalStyles",
    value: function getGlobalStyles() {
      var result = '';
      result += "body {\n  margin:0px;\n  font-family:'Source Sans Pro', 'Helvetica Neue', 'Helvetica', sans-serif;\n}\n\n";
      result += "div {\n  margin:0px;\n}\n\n";
      return result;
    }
  }, {
    key: "generateDesignSystemRoot",
    value: function generateDesignSystemRoot(node) {
      var _this2 = this;

      var result = {};
      var style = {
        type: 'template',
        css: node.cssSelector,
        global: true,
        code: this.getCSS(node, null, false)
      };
      result[node.id] = [style];

      if (node.children) {
        node.children.forEach(function (child) {
          _this2.generateElement(child, result, screen);
        });
      } // add something like inlibe block, and fexl with if no children
      // generate rest like usual


      return result;
    }
  }, {
    key: "generateElement",
    value: function generateElement(node, result, screen) {
      var _this3 = this;

      result[node.id] = [];
      /**
       * If we have a templated node,
       * add also the template class here
       */

      if (node.template) {
        var template = result[node.template];

        if (template) {
          template.forEach(function (t) {
            result[node.id].push(t);
          });
        }
      }
      /**
       * TDOD: If we have shared code...
       */


      result[node.id].push({
        type: 'widget',
        css: node.cssSelector,
        global: false,
        code: this.getCSS(node, screen),
        inherited: node.inherited,
        inheritedScreen: node.inheritedScreen
      });

      if (node.children) {
        node.children.forEach(function (child) {
          _this3.generateElement(child, result, screen);
        });
      }
    }
  }, {
    key: "getRaw",
    value: function getRaw(model, selectedWidgets) {
      var result = "";

      for (var i = 0; i < selectedWidgets.length; i++) {
        var id = selectedWidgets[i];
        var widget = model.widgets[id];

        if (widget) {
          result += this.getCSS(widget, null, false);
        } else {
          this.logger.warn("getRaw", "No widget with id > " + widget);
        }
      }

      return result;
    }
  }, {
    key: "getSelector",
    value: function getSelector(widget) {
      return widget.cssSelector;
    }
  }, {
    key: "getName",
    value: function getName(box) {
      var name = box.name.replace(/\s+/g, '_');

      if (box.inherited) {
        name += '_Master';
      }

      if (this.prefix) {
        name = "".concat(this.prefix, "_").concat(name);
      }

      return name;
    }
  }, {
    key: "getCSS",
    value: function getCSS(widget, screen) {
      var result = "";
      var style = widget.style;
      style = fixAutos(style, widget);
      var selector = this.getSelector(widget, screen);

      if (this.widgetFactory['getCSS_' + widget.type]) {
        result += this.widgetFactory['getCSS_' + widget.type](selector, widget.style, widget);
      } else if (widget.isCustomComponent) {
        /**
         * For custom components we just set the position!
         */
        result += selector + ' {\n';
        result += this.getPosition(widget);
        result += '}\n\n';
      } else {
        /**
         * Add normal css
         */
        result += selector + ' {\n';
        result += this.getRawStyle(style, widget);
        result += this.getPosition(widget);
        result += '}\n\n';

        if (widget.hover) {
          result += selector + ':hover {\n';
          result += '  transition: all 0.2s;\n';
          result += this.getRawStyle(widget.hover, widget);
          result += '}\n\n';
        }

        if (widget.focus) {
          result += selector + ':focus {\n';
          result += this.getRawStyle(widget.focus, widget);
          result += '}\n\n';
        }

        if (widget.error) {
          result += selector + ':invalid {\n';
          result += this.getRawStyle(widget.error, widget);
          result += '}\n\n';
        }

        if (widget.active) {
          result += selector + '.qux-active {\n';
          result += this.getRawStyle(widget.active, widget);
          result += '}\n\n';
        }

        if (isInputElement(widget)) {
          result += selector + '::placeholder {\n';
          result += "  color: ".concat(this.getPlaceHolderColor(style.color), ";\n");
          result += '}\n\n';
        }
      }
      /**
       * Break points
       */


      result += this.getBreakpoints(selector, widget);
      /**
       * Animation
       */

      if (screen && screen.animation && screen.animation.ScreenLoaded) {
        var animation = screen.animation.ScreenLoaded;

        if (widget.id in animation.widgets) {
          var widgetAnimation = animation.widgets[widget.id];

          if (widgetAnimation) {
            result += this.getAnimation(widgetAnimation, selector, widget, screen);
          }
        }

        if (widget.isGroup && widget.groupId in animation.groups) {
          var groupAnimation = animation.groups[widget.groupId];

          if (groupAnimation) {
            result += this.getAnimation(groupAnimation, selector, widget, screen);
          }
        }
      }

      return result;
    }
  }, {
    key: "getBreakpoints",
    value: function getBreakpoints(selector, widget) {
      var result = '';

      if (widget.props.breakpoints) {
        Logger$1.log(-1, 'CSSFactory.getBreakpoints()', widget.name);
        var breakpoints = widget.props.breakpoints;
        /**
         * Assume at leats one is true
         */

        if (!breakpoints.mobile) {
          result += "@media only screen and (min-width: ".concat(this.responsive.mobile.min, "px) and (max-width: ").concat(this.responsive.mobile.max, "px) {\n");
          result += "  ".concat(selector, " {\n");
          result += '    display: none;\n';
          result += '  }\n';
          result += '}\n\n';
        }

        if (!breakpoints.tablet) {
          result += "@media only screen and (min-width: ".concat(this.responsive.tablet.min, "px) and (max-width: ").concat(this.responsive.tablet.max, "px) {\n");
          result += "  ".concat(selector, " {\n");
          result += '    display: none;\n';
          result += '  }\n';
          result += '}\n\n';
        }

        if (!breakpoints.desktop) {
          result += "@media only screen and (min-width: ".concat(this.responsive.desktop.min, "px) and (max-width: ").concat(this.responsive.desktop.max, "px) {\n");
          result += "  ".concat(selector, " {\n");
          result += '    display: none;\n';
          result += '  }\n';
          result += '}\n\n';
        }
      }

      return result;
    }
  }, {
    key: "getAnimation",
    value: function getAnimation(animation, selector, widget) {
      var result = '';
      var total = animation.delay + animation.duration;
      var delay = Math.round(animation.delay / total * 100);
      var animId = "".concat(widget.id, "-anim-load");
      var easing = animation.easing ? this.getEasing(animation.easing) : 'linear';

      if (animation.type === 'fadeIn') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { opacity:0; }\n';
        result += "  ".concat(delay, "% { opacity: 0;}\n");
        result += "  100% { opacity: 1;}\n";
        result += '}\n\n';
      }

      if (animation.type === 'fadeOut') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { opacity:1; }\n';
        result += "  ".concat(delay, "% { opacity: 1;}\n");
        result += "  100% { opacity: 0;}\n";
        result += '}\n\n';
      }

      if (animation.type === 'zoomIn') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform:scale(0, 0); transform-origin: 50% 50%;}\n';
        result += "  ".concat(delay, "% { transform:scale(0, 0); transform-origin: 50% 50%;}\n");
        result += "  100% { transform:scale(1, 1); transform-origin: 50% 50%;}\n";
        result += '}\n\n';
      }

      if (animation.type === 'fadeOut') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { opacity:1; }\n';
        result += "  ".concat(delay, "% {opacity: 1;}\n");
        result += "  100% {opacity: 0;}\n";
        result += '}\n\n';
      }

      if (animation.type === 'growRight') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform:scale(0, 1); transform-origin: top left;}\n';
        result += "  ".concat(delay, "% { transform:scale(0, 1); transform-origin: top left;}\n");
        result += "  100% { transform:scale(1, 1); transform-origin: top left;}\n";
        result += '}\n\n';
      }

      if (animation.type === 'growLeft') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform:scale(0, 1); transform-origin: top right;}\n';
        result += "  ".concat(delay, "% {transform:scale(0, 1); transform-origin: top right;}\n");
        result += "  100% { transform:scale(1, 1); transform-origin: top right;}\n";
        result += '}\n\n';
      }

      if (animation.type === 'growUp') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform:scale(1, 0); transform-origin: bottom right;}\n';
        result += "  ".concat(delay, "% {transform:scale(1, 0); transform-origin: bottom right;}\n");
        result += "  100% { transform:scale(1, 1); transform-origin: bottom right;}\n";
        result += '}\n\n';
      }

      if (animation.type === 'growDown') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform:scale(1, 0); transform-origin: top right;}\n';
        result += "  ".concat(delay, "% {transform:scale(1, 0); transform-origin: top right;}\n");
        result += "  100% { transform:scale(1, 1); transform-origin: top right;}\n";
        result += '}\n\n';
      }
      /**
       * Use calc(100vh) and so?
       */


      if (animation.type === 'slideRight') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform: translateX(-1000px) }\n';
        result += "  ".concat(delay, "% { transform: translateX(-1000px); }\n");
        result += "  100% { transform:translateX(0); }\n";
        result += '}\n\n';
      }

      if (animation.type === 'slideLeft') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform: translateX(1000px) }\n';
        result += "  ".concat(delay, "% { transform: translateX(1000px); }\n");
        result += "  100% {transform:translateX(0); }\n";
        result += '}\n\n';
      }

      if (animation.type === 'slideDown') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform: translateY(-1000px) }\n';
        result += "  ".concat(delay, "% { transform: translateY(-1000px); }\n");
        result += "  100% {transform:translateY(0); }\n";
        result += '}\n\n';
      }

      if (animation.type === 'slideUp') {
        result += "@keyframes ".concat(animId, "{\n");
        result += '  0% { transform: translateY(1000px) }\n';
        result += "  ".concat(delay, "% { transform: translateY(1000px); }\n");
        result += "  100% {transform:translateY(0); }\n";
        result += '}\n\n';
      }

      result += selector + ' {\n';
      result += "  animation-fill-mode: forwards;\n";
      result += "  animation-name:".concat(animId, ";\n");
      result += "  animation-duration:".concat(total, "ms;\n");
      result += "  animation-timing-function:".concat(easing, ";\n");
      result += '}\n\n';
      return result;
    }
  }, {
    key: "getEasing",
    value: function getEasing(easing) {
      return this.easingMapping[easing];
    }
    /*********************************************************************
     * Position
     *********************************************************************/

  }, {
    key: "getPosition",
    value: function getPosition(widget) {
      // Overlays will no be rendered as fixed...

      /**
       * FIXME we should have here better support for the
       * for auto layouts like wrap, row and column
       */
      if (isDesignSystemRoot(widget)) {
        return this.positionFactory.getDesignSystemPosition(widget);
      } else if (hasComponentScreenParent(widget)) {
        return this.positionFactory.getComponentScreenPosition(widget);
      } else if (widget.style.fixed && widget.type !== 'Screen') {
        return this.positionFactory.getFixedPosition(widget);
      } else if (hasWrappedParent(widget)) {
        return this.positionFactory.getWrappedPosition(widget);
      } else {
        return this.positionFactory.getGridPosition(widget);
      }
    }
  }, {
    key: "getStyleByKey",
    value: function getStyleByKey(style, widget, keys) {
      var _this4 = this;

      var result = '';
      keys.forEach(function (key) {
        if (style[key] !== undefined && style[key] !== null) {
          var value = style[key];
          result += '  ' + _this4.getKey(key) + ': ' + _this4.getValue(key, value) + ';\n';
        }
      });
      return result;
    }
  }, {
    key: "getRawStyle",
    value: function getRawStyle(style, widget) {
      var result = this.getStyleByKey(style, widget, Object.keys(this.mapping));
      result += this.getBackGround(style, widget);
      return result;
    }
  }, {
    key: "getPlaceHolderColor",
    value: function getPlaceHolderColor(color) {
      if (color) {
        var c = fromString(color);
        c.a = 0.5;
        return toString(c);
      }

      return 'rgba(0, 0, 0, 0.5)';
    }
  }, {
    key: "getBackGround",
    value: function getBackGround(style, widget) {
      var result = '';

      if (style.background && style.overlay !== true) {
        if (style.background.colors) {
          if (style.background.radial) {
            var background = style.background;
            var gradient = background.colors.map(function (color) {
              return color.c + ' ' + color.p + '%';
            }).join(', ');
            result += "  background: radial-gradient(circle, ".concat(gradient, ");\n");
          } else {
            var _background = style.background;

            var _gradient = "(" + _background.direction + "deg";

            for (var i = 0; i < _background.colors.length; i++) {
              var color = _background.colors[i];
              _gradient += "," + color.c + " " + color.p + "% ";
            }

            _gradient += ")";
            result += "  background: linear-gradient".concat(_gradient, ";\n");
          }
        } else {
          result += "  background-color: ".concat(style.background, ";\n");
        }
      }

      if (style.backgroundColor) {
        result += "  background-color: ".concat(style.backgroundColor, ";\n");
      }

      if (style.backgroundImage && style.backgroundImage.url) {
        if (style.backgroundImage.url.indexOf('http') === 0) {
          result += "  background-image: url(".concat(style.backgroundImage.url, ");\n");
        } else {
          result += "  background-image: url(".concat(this.imagePrefix, "/").concat(style.backgroundImage.url, ");\n");
        }

        if (style.backgroundSize) {
          result += "  background-size: ".concat(style.backgroundSize, "%;\n");
        } else {
          result += "  background-size: 100%;\n";
        }

        if (style.backgroundPosition) {
          var pos = style.backgroundPosition;
          var w = Math.round(pos.left * widget.w);
          var h = Math.round(pos.top * widget.h);
          result += "  background-position: ".concat(w, "px ").concat(h, "px;\n");
        } else {
          result += "  background-position: 0px 0px;\n";
        }

        result += "  background-repeat: no-repeat;\n";
      }

      return result;
    }
  }, {
    key: "getKey",
    value: function getKey(key) {
      return this.mapping[key];
    }
  }, {
    key: "getValue",
    value: function getValue(key, value) {
      var result = '';

      if (key === 'fontFamily') {
        result += this.escapeFontFamily(value);
      } else if (this.isPixel[key]) {
        result += value + 'px';
      } else if (key === "boxShadow") {
        result = value.h + "px " + value.v + "px " + value.b + "px " + value.s + "px " + value.c;

        if (value.i) {
          result += 'inset';
        }
      } else if (key === 'textShadow') {
        result = value.h + "px " + value.v + "px " + value.b + "px " + value.c;
      } else {
        result += value;
      }

      return result;
    }
  }, {
    key: "escapeFontFamily",
    value: function escapeFontFamily(value) {
      return value.split(',').map(function (f) {
        if (f.indexOf(' ') >= 0) {
          return '"' + f + '"';
        }

        return f;
      }).join(', ');
    }
  }, {
    key: "clone",
    value: function clone(obj) {
      if (!obj) {
        return null;
      }

      var _s = JSON.stringify(obj);

      return JSON.parse(_s);
    }
  }, {
    key: "getFixedHeight",
    value: function getFixedHeight(widget) {
      return this.positionFactory.getFixedHeight(widget);
    }
  }, {
    key: "getWrappedWidth",
    value: function getWrappedWidth(widget) {
      return this.positionFactory.getWrappedWidth(widget);
    }
  }, {
    key: "getCorrectedHeight",
    value: function getCorrectedHeight(widget) {
      var isPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      return this.positionFactory.getCorrectedHeight(widget, isPosition, h);
    }
  }, {
    key: "getCorrectedWidth",
    value: function getCorrectedWidth(widget) {
      var isPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var w = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      return this.positionFactory.getCorrectedWidth(widget, isPosition, w);
    }
  }, {
    key: "hasAllwaysFixedHeight",
    value: function hasAllwaysFixedHeight(widget) {
      return widget.type === 'Icon';
    }
  }]);

  return CSSFactory;
}();

var CSSWriter = /*#__PURE__*/function () {
  function CSSWriter() {
    _classCallCheck(this, CSSWriter);

    this.styleElement = {};
  }

  _createClass(CSSWriter, [{
    key: "write",
    value: function write(css) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      var head = document.head || document.getElementsByTagName('head')[0];

      if (this.styleElement[id]) {
        /**
         * This can lead to errors when the hash is changed.
         * This is edge case for development (I hope)
         */
        Logger$1.log(5, 'CSSWriter.write() > Clean up old');
        head.removeChild(this.styleElement[id]);
      }

      var style = document.createElement('style');
      style.type = 'text/css';
      style.qux = true;
      style.setAttribute('qux', id);
      style.appendChild(document.createTextNode(css));
      head.appendChild(style);
      this.styleElement[id] = style;
    }
  }]);

  return CSSWriter;
}();

var CSSWriter$1 = new CSSWriter();

var JSONPath = /*#__PURE__*/function () {
  function JSONPath() {
    _classCallCheck(this, JSONPath);
  }

  _createClass(JSONPath, [{
    key: "get",
    value: function get(data, path) {
      if (data != null && data != undefined) {
        if (data[path] !== null && data[path] !== undefined) {
          return data[path];
        }

        if (path.indexOf('.') >= 0 || path.indexOf('[') >= 0) {
          var elements = this.getJsonPath(path);
          var current = elements.shift();
          var value = data[current];

          while (current != null && current != undefined && value !== null && value != undefined && elements.length > 0) {
            current = elements.shift();
            value = value[current];
          }

          return value;
        }
      }
    }
  }, {
    key: "set",
    value: function set(data, path, value) {
      var elements = this.getJsonPath(path);
      var current = elements.shift();
      var node = data;
      var i = 0;

      while (current !== null && current !== undefined && i < 100) {
        i++;

        if (elements.length > 0) {
          if (!node[current]) {
            if (elements[0].toLowerCase) {
              this._set(node, current, {});
            } else {
              this._set(node, current, []);
            }
          }

          node = node[current];
          current = elements.shift();
        } else {
          this._set(node, current, value);
        }
      }

      return data;
    }
  }, {
    key: "_set",
    value: function _set(node, key, value) {
      /**
       * Not sure how this works for new props. Maybe we have to use VUE here
       */
      //node[key] =value
      Vue__default['default'].set(node, key, value);
    }
  }, {
    key: "getJsonPath",
    value: function getJsonPath(path) {
      return path.split('.').flatMap(function (p) {
        if (p.indexOf('[') >= 0) {
          var parts = p.split('[');

          if (parts.length == 2) {
            var key = parts[0];
            var index = parts[1].substring(0, parts[1].length - 1) * 1;
            return [key, index];
          }

          return p.substring(1, p.length - 1) * 1;
        }

        return p;
      });
    }
  }, {
    key: "has",
    value: function has(data, path) {
      if (data != null && data != undefined) {
        if (data[path] != null && data[path] != null) {
          return true;
        }

        if (path.indexOf('.') >= 0 || path.indexOf('[') >= 0) {
          var elements = this.getJsonPath(path);
          var current = elements.shift();
          var value = data[current];

          while (current != null && current != undefined && value !== null && value != undefined && elements.length > 0) {
            current = elements.shift();
            value = value[current];
          }

          return value !== undefined && value !== null;
        }

        return false;
      }
    }
  }]);

  return JSONPath;
}();

var JSONPath$1 = new JSONPath();

//
var script = {
  name: 'Base',
  props: {
    'model': {
      type: Object
    },
    'element': {
      type: Object
    },
    'config': {
      type: Object
    },
    'value': {},
    'lbl': {
      type: String
    },
    'url': {
      type: String
    },
    'optionList': {
      type: Array
    },
    'isStandAlone': {
      type: Boolean
    }
  },
  computed: {
    isDesignSystemRoot: function isDesignSystemRoot() {
      return this.element && this.element.isDesignSystemRoot;
    },
    hasSlot: function hasSlot() {
      return this.$slots.default !== undefined && this.$slots.default !== null;
    },
    hasLink: function hasLink() {
      var _this = this;

      if (this.url && this.url.length > 0) {
        return true;
      }

      if (this.element && this.element.lines && this.element.lines) {
        var line = this.element.lines.find(function (l) {
          return _this.isClick(l);
        });

        if (line) {
          var box = getBoxById(line.to, this.model);

          if (box.type === 'Screen' && !box.style.overlay) {
            return true;
          }
        }
      }

      return false;
    },
    link: function link() {
      var _this2 = this;

      if (this.url) {
        return this.url;
      }

      if (this.element && this.element.lines && this.element.lines.length === 1) {
        var line = this.element.lines.find(function (l) {
          return _this2.isClick(l);
        });

        if (line) {
          var box = getBoxById(line.to, this.model);

          if (box.type === 'Screen') {
            var prefix = '';

            if (this.config && this.config.router && this.config.router.prefix) {
              prefix = this.config.router.prefix + '/';
            }

            return "#/".concat(prefix).concat(box.name, ".html");
          }
        }
      }

      return false;
    },
    hasAction: function hasAction() {
      return this.element && this.element.actions && Object.values(this.element.actions).length > 0 || this.element.lines && this.element.lines.length > 0 || this.element.props.callbacks && this.element.props.callbacks.click;
    },
    label: function label() {
      if (this.lbl) {
        return this.lbl;
      }

      if (this.dataBindingInputPath && this.dataBindingInputPath.indexOf('$') === 0) {
        var dsRoot = this.getDesignSystemRoot();
        var path = this.dataBindingInputPath.substring(1);

        if (dsRoot) {
          if (dsRoot[path]) {
            return dsRoot[path];
          }
        }
      }

      if (this.element && this.element.props && this.element.props.label) {
        return this.escapeLabel(this.element.props.label);
      }

      return '';
    },
    cssClass: function cssClass() {
      var result = 'qux-element ';

      if (this.element) {
        /**
         * FIXME: Move this to CSSFactory
         */
        if (this.element.style && this.element.style.verticalAlign) {
          result += "qux-valign-".concat(this.element.style.verticalAlign, " ");
        }

        if (this.hasAction) {
          result += "qux-action ";
        }

        if (this.config && this.config.debug && this.config.debug.resize === true) {
          if (this.element.props && this.element.props.resize) {
            var resize = this.element.props.resize;

            for (var direction in resize) {
              if (resize[direction]) {
                result += "qux-resize-".concat(direction, " ");
              }
            }
          }
        }

        if (this.element.sharedCssClasses) {
          result += this.element.sharedCssClasses.join(' ') + ' ';
        }

        result += this.element.cssClass;
      }

      return result;
    },
    dataBinding: function dataBinding() {
      if (this.element && this.element.props && this.element.props.databinding) {
        return this.element.props.databinding;
      }

      return null;
    },
    dataBindingInput: function dataBindingInput() {
      if (this.element && this.element.props && this.element.props.databinding) {
        var path = this.element.props.databinding.default;

        if (path) {
          var value = JSONPath$1.get(this.value, path);
          Logger$1.log(5, '_Base.dataBindingInput() > ' + path, "\"".concat(value, "\""));
          return value;
        }
      }

      return null;
    },
    dataBindingOptions: function dataBindingOptions() {
      if (this.element && this.element.props && this.element.props.databinding) {
        var path = this.element.props.databinding.options;

        if (path) {
          var value = JSONPath$1.get(this.value, path);
          Logger$1.log(5, '_Base.dataBindingOptions() > ' + path, "\"".concat(value, "\""));
          return value;
        }
      }

      return null;
    },
    dataBindingInputPath: function dataBindingInputPath() {
      if (this.element && this.element.props && this.element.props.databinding) {
        var path = this.element.props.databinding.default;
        return path;
      }

      return '';
    },
    dataBindingOutputPath: function dataBindingOutputPath() {
      if (this.element && this.element.props && this.element.props.databinding) {
        var path = this.element.props.databinding.output;
        return path;
      }

      return '';
    },
    dataBindingLabel: function dataBindingLabel() {
      /**
       * First, cgeck if we have set a lbl property
       */
      if (this.lbl) {
        return this.lbl;
      }
      /**
       * Next, check data binding
       */


      if (this.hasDataBinding) {
        /**
         * Check if we have a magic property path like $label
         */
        if (this.dataBindingInputPath && this.dataBindingInputPath.indexOf('$') === 0) {
          Logger$1.log(4, '_Base.dataBindingLabel() > props : ', "\"".concat(this.dataBindingInputPath, "\""));
          var dsRoot = this.getDesignSystemRoot();

          if (dsRoot) {
            var path = this.dataBindingInputPath.substring(1);

            if (dsRoot[path]) {
              return dsRoot[path];
            }
          }
        } else {
          /**
           * If not magic, check if there is a variable
           */
          var value = this.dataBindingInput;

          if (value !== undefined && value != null) {
            Logger$1.log(6, '_Base.dataBindingLabel() > ', "\"".concat(value, "\""));
            return value;
          }
        }
      }
      /**
       * Last, check element properties
       */


      if (this.element && this.element.props && this.element.props.label) {
        return this.escapeLabel(this.element.props.label);
      }

      return '';
    },
    hasError: function hasError() {
      return false;
    },
    options: function options() {
      if (this.optionList) {
        return this.optionList;
      }

      var dataBindingOptions = this.dataBindingOptions;

      if (dataBindingOptions) {
        return dataBindingOptions;
      }

      if (this.element && this.element.props && this.element.props.options) {
        return this.element.props.options;
      }

      return [];
    }
  },
  watch: {
    value: function value(v) {
      Logger$1.log(3, '_Base.watch(value) > enter', v);
      this.value = v;
    }
  },
  methods: {
    stopEvent: function stopEvent(e) {
      Logger$1.warn('_Base.stopEvent()');

      if (e) {
        e.stopPropagation();
      }
    },
    getDesignSystemRoot: function getDesignSystemRoot() {
      var parent = this.$parent;

      while (parent && parent.element && !parent.element.isDesignSystemRoot) {
        parent = parent.$parent;
      }

      if (parent.element && parent.element.isDesignSystemRoot) {
        return parent;
      }
    },
    escapeLabel: function escapeLabel(lbl) {
      lbl = lbl.replace(/&nbsp;/ig, ' ');
      return lbl;
    },
    isClick: function isClick(line) {
      return line.event = 'click';
    },
    hasDataBinding: function hasDataBinding() {
      return this.element && this.element.props && this.element.props.databinding;
    },

    /**
     * Default event handlers which just delegate up
     * the hierachy
     */
    onClick: function onClick(e) {
      this.$emit('qClick', this.element, e, this.getValue());
      this.$emit('click', e);
      this.checkDesignSystemCallback(e, 'click');
      this.fireParentDomEvent('click', e);
    },
    fireParentDomEvent: function fireParentDomEvent(type, e) {
      /**
        * The wrapper stops our events, so we fire DOM event on parent
        */
      if (this.element && this.element.isDesignSystemRoot) {
        this.$parent.$emit(type, e);
      }
    },
    onChange: function onChange(e) {
      this.$emit('qChange', this.element, e, this.getValue());
      this.checkDesignSystemCallback(e, 'change');
      this.fireParentDomEvent('change', e);
    },
    onKeyPress: function onKeyPress(e) {
      this.$emit('qKeyPress', this.element, e, this.getValue());
      this.checkDesignSystemCallback(e, 'change');
      this.fireParentDomEvent('keyPress', e);
    },
    onFocus: function onFocus(e) {
      this.$emit('qFocus', this.element, e);
      this.fireParentDomEvent('focus', e);
    },
    onBlur: function onBlur(e) {
      this.$emit('qBlur', this.element, e);
      this.fireParentDomEvent('blur', e);
    },
    onMouseOver: function onMouseOver(e) {
      this.$emit('qMouseOver', this.element, e);
    },
    onMouseOut: function onMouseOut(e) {
      this.$emit('qMouseOut', this.element, e);
    },
    checkDesignSystemCallback: function checkDesignSystemCallback(e, type) {
      Logger$1.log(4, '_Base.checkDesignSystemCallback() > : ' + type, this.element);

      if (this.element && this.element.props && this.element.props.callbacks) {
        var callback = this.element.props.callbacks[type];

        if (callback) {
          Logger$1.log(1, '_Base.checkDesignSystemCallback() > : ' + this.element.name, type, callback);
          this.$emit('qDesignSystemCallback', this.element, e, type, callback, this.getValue());
          this.emitDesignSystemCallback();
        }
      }
    },
    forwardDesignSystemCallback: function forwardDesignSystemCallback(element, e, type, callback, elementValue) {
      Logger$1.log(5, '_Base.forwardDesignSystemCallback() > : ' + this.element.name, element.name);
      this.$emit('qDesignSystemCallback', element, e, type, callback, elementValue);
      this.emitDesignSystemCallback(element, e, type, callback, elementValue);
    },
    emitDesignSystemCallback: function emitDesignSystemCallback(element, e, type, callback) {
      if (this.element.isDesignSystemRoot && this.$parent) {
        Logger$1.log(1, '_Base.emitDesignSystemCallback() > : ' + this.element.name, callback, this.value);
        /**
         * We have to call on parent, because
         * we have this virtual wrapper around.
         */

        this.$parent.$emit(callback, this.value, e);
      }
    },

    /**
     * Template method which can be implemnted by children to
     * give the current value to the onChange
     */
    getValue: function getValue() {
      return this.dataBindingInput;
    },

    /**
     * Method wich sets the value accoridng to the dataBing path.
     */
    onValueChange: function onValueChange(value) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
      var e = arguments.length > 2 ? arguments[2] : undefined;
      Logger$1.log(3, '_Base.onValueChange() > change : ' + this.element.name, value);

      if (this.element && this.element.props && this.element.props.databinding) {
        var path = this.element.props.databinding[key];

        if (path && this.value != undefined && this.value !== true && this.value !== false) {
          try {
            Logger$1.log(4, '_Base.onValueChange() > change : ' + path, value);
            JSONPath$1.set(this.value, path, value);
          } catch (ex) {
            Logger$1.error('_Base.onValueChange() > Could not set value in path' + path, this.value);
          } //Logger.log(-1, '_Base.onValueChange() > exit : ', JSON.stringify(this.value, null, 2))

        }
      }
      /**
       * We also trigger the change event
       */


      this.$emit('qChange', this.element, e, value);
      /**
       * For design system roots, we also fire event
       */

      if (this.element.isDesignSystemRoot && this.$parent) {
        this.$parent.$emit('input', value);
        this.$parent.$emit('change', value);
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux-base"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n")]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

//
var script$1 = {
  name: 'qButton',
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
};

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasLink ? _c('a', {
    class: ['qux-button', _vm.cssClass],
    attrs: {
      "href": _vm.link
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm.dataBindingLabel && !_vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._v("\n    " + _vm._s(_vm.dataBindingLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._t("default")], 2) : _vm._e()]) : _c('div', {
    class: ['qux-button', _vm.cssClass],
    on: {
      "click": _vm.onClick
    }
  }, [_vm.dataBindingLabel && !_vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._v("\n    " + _vm._s(_vm.dataBindingLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-11644b0f_0", {
    source: ".qux{background:0 0;height:100%}.qux.qux-component-screen{height:auto;display:inline-block}.qux-screen{display:flex;flex-direction:column;min-height:100%;background-size:100%}.qux-action{cursor:pointer}.qux-valign-middle{position:relative}.qux-valign-middle .qux-common-label{width:100%;position:absolute;top:50%;left:0;transform:translateY(-50%)}.qux-valign-bottom{position:relative}.qux-valign-bottom .qux-common-label{width:100%;position:absolute;bottom:0;left:0}.qux-overlay-wrapper{width:100%;height:100%;position:absolute;top:0;left:0;z-index:99999}.qux-overlay-wrapper.qux-overlay-wrapper-fixed{position:fixed}.qux-screen-blurred{filter:blur(10px)}.qux-resize-left::before{content:\"\";width:3px;background:orange}.qux-resize-right::after{content:\"\";width:3px;background:orange}.qux-common-no-select{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.qux-common-valign-center{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.qux-button{display:inline-block;border-style:solid;border-width:0}a.qux-button{text-decoration:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
var script$2 = {
  name: 'qLabel',
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasLink ? _c('a', {
    class: ['qux-label', _vm.cssClass],
    attrs: {
      "href": _vm.link
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm.dataBindingLabel && !_vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._v("\n    " + _vm._s(_vm.dataBindingLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._t("default")], 2) : _vm._e()]) : _c('label', {
    class: ['qux-label', _vm.cssClass],
    on: {
      "click": _vm.onClick
    }
  }, [_vm.dataBindingLabel && !_vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._v("\n    " + _vm._s(_vm.dataBindingLabel) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.hasSlot ? _c('span', {
    staticClass: "qux-common-label"
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-05a0915b_0", {
    source: ".qux-label{display:inline-block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
var script$3 = {
  name: 'qIcon',
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },
  computed: {
    icon: function icon() {
      return this.element.style.icon;
    }
  },
  mounted: function mounted() {//console.debug('Label.mounted()', this.label)
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    class: ['qux-icon', _vm.cssClass, _vm.icon],
    on: {
      "click": _vm.onClick
    }
  });
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-9626a664_0", {
    source: ".qux-icon{display:inline-block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

//
var script$4 = {
  name: 'qTestBox',
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },
  computed: {
    type: function type() {
      if (this.element && this.element.type === 'Password') {
        return 'password';
      }

      return 'text';
    },
    placeholder: function placeholder() {
      if (this.element && this.element.props && this.element.props.placeholder) {
        return this.element.props.label;
      }

      return '';
    },
    selectedValue: function selectedValue() {
      if (this.element && this.element.isDesignSystemRoot) {
        return this.value;
      }

      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          if (!input.toLowerCase) {
            if (isNaN(input)) {
              try {
                input = JSON.stringify(input);
              } catch (e) {
                Logger$1.warn('TextBox.selectedValue() > Can stringify ', input);
              }
            }
          }
        }

        return input;
      }

      return '';
    }
  },
  methods: {
    onKeyPress: function onKeyPress(e) {
      var value = e.target.value;
      this.onValueChange(value, 'default');
      this.$emit('qKeyPress', this.element, e, value);
      Logger$1.log(6, 'qTextBox.onKeyPress() > exit', value);
    },
    setFocus: function setFocus() {
      Logger$1.log(0, 'qTextBox.setFocus() > enter');

      if (this.$el) {
        this.$el.focus();
      }
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qTextBox.mounted() enter');

    if (this.element && this.element.props && this.element.props.focus) {
      setTimeout(this.setFocus, 100);
    }
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('input', {
    class: ['qux-textbox qux-text-input', _vm.cssClass],
    attrs: {
      "placeholder": _vm.placeholder,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.selectedValue
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "click": _vm.onClick,
      "change": _vm.onChange,
      "keyup": _vm.onKeyPress
    }
  });
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-2ff49110_0", {
    source: ".qux-textbox{border:1px solid #333;transition:all .2s}.qux-textbox:focus{outline:0}.qux-screen .qux-textbox{padding:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
var script$5 = {
  name: 'qContainer',
  mixins: [__vue_component__],
  data: function data() {
    return {
      debug: false
    };
  },
  computed: {
    justifyContent: function justifyContent() {
      if (isWrappedContainer(this.element) && this.config.css.justifyContentInWrapper) {
        return true;
      }

      return false;
    },
    wrapperPlaceHolders: function wrapperPlaceHolders() {
      return [1, 2, 3, 4, 5, 6, 7, 8];
    }
  },
  methods: {
    forwardClick: function forwardClick(element, e, value) {
      this.$emit('qClick', element, e, value);
    },
    forwardChange: function forwardChange(element, e, value) {
      this.$emit('qChange', element, e, value);
    },
    forwardFocus: function forwardFocus(element, e, value) {
      this.$emit('qFocus', element, e, value);
    },
    forwardBlur: function forwardBlur(element, e, value) {
      this.$emit('qBlur', element, e, value);
    },
    forwardMouseOver: function forwardMouseOver(element, e, value) {
      this.$emit('qMouseOver', element, e, value);
    },
    forwardMouseOut: function forwardMouseOut(element, e, value) {
      this.$emit('qMouseOut', element, e, value);
    },
    forwardKeyPress: function forwardKeyPress(element, e, value) {
      this.$emit('qKeyPress', element, e, value);
    },
    forwardCallback: function forwardCallback(element, e, value) {
      this.$emit('qCallback', element, e, value);
    }
  },
  mounted: function mounted() {}
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-container', _vm.cssClass],
    on: {
      "click": _vm.onClick
    }
  }, [_vm.element ? [_vm._l(_vm.element.children, function (child) {
    return _c(child.qtype, {
      key: child.id,
      tag: "component",
      attrs: {
        "element": child,
        "model": _vm.model,
        "config": _vm.config
      },
      on: {
        "qDesignSystemCallback": _vm.forwardDesignSystemCallback,
        "qCallback": _vm.forwardCallback,
        "qClick": _vm.forwardClick,
        "qChange": _vm.forwardChange,
        "qKeyPress": _vm.forwardKeyPress,
        "qFocus": _vm.forwardFocus,
        "qBlur": _vm.forwardBlur,
        "qMouseOver": _vm.forwardMouseOver,
        "qMouseOut": _vm.forwardMouseOut
      },
      model: {
        value: _vm.value,
        callback: function callback($$v) {
          _vm.value = $$v;
        },
        expression: "value"
      }
    });
  }), _vm._v(" "), _vm.element.fixedChildren ? _vm._l(_vm.element.fixedChildren, function (child) {
    return _c(child.qtype, {
      key: child.id,
      tag: "component",
      attrs: {
        "element": child,
        "model": _vm.model,
        "config": _vm.config
      },
      on: {
        "qDesignSystemCallback": _vm.forwardDesignSystemCallback,
        "qCallback": _vm.forwardCallback,
        "qClick": _vm.forwardClick,
        "qChange": _vm.forwardChange,
        "qKeyPress": _vm.forwardKeyPress,
        "qFocus": _vm.forwardFocus,
        "qBlur": _vm.forwardBlur,
        "qMouseOver": _vm.forwardMouseOver,
        "qMouseOut": _vm.forwardMouseOut
      },
      model: {
        value: _vm.value,
        callback: function callback($$v) {
          _vm.value = $$v;
        },
        expression: "value"
      }
    });
  }) : _vm._e()] : [_vm._t("default")]], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-7b43dc2e_0", {
    source: ".qux-container{border-style:solid;border-width:0}.qux-container .qux-container-debug{color:red}.qux-container .qux-container-wrapper-placeholder{background:red;height:1px;width:100px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

var script$6 = {
  name: 'qRepeater',
  mixins: [__vue_component__],
  data: function data() {
    return {
      debug: false
    };
  },
  computed: {
    placeholders: function placeholders() {
      /**
       * Make here some better math and calculate hwo many elements i really need?
       */
      return [1, 2, 3, 4, 5, 6, 7];
    },
    rows: function rows() {
      if (this.element && this.element.props && this.element.props.databinding) {
        var path = this.element.props.databinding.default;
        var value = JSONPath$1.get(this.value, path);
        Logger$1.log(5, 'Repeater.rows() > exit path: > ' + path, value);

        if (Array.isArray(value)) {
          return value;
        } else {
          Logger$1.warn('Repeater.rows() > Value is no array: > ' + path, value);
        }
      } else {
        return this.getRowsFromTable(this.element);
      }

      return [];
    }
  },
  methods: {
    getDeepCopy: function getDeepCopy(element, row, i) {
      Logger$1.log(4, 'Repeater.getDeepCopy() > exit : > ' + i, row);
      var copy = this.clone(element);
      var path = this.dataBindingInputPath;
      this.updateDataBinding(copy, i, path);
      return copy;
    },
    clone: function clone(obj) {
      if (obj === null || _typeof(obj) !== 'object' || 'isActiveClone' in obj) return obj;
      var temp = obj.constructor();

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (key !== 'parent') {
            /**
             * FIXME: Make this somehow better
             */
            obj['isActiveClone'] = null;
            temp[key] = this.clone(obj[key]);
            delete obj['isActiveClone'];
          } else {
            temp[key] = obj[key];
          }
        }
      }

      return temp;
    },
    updateDataBinding: function updateDataBinding(copy, i, parentPath) {
      var _this = this;

      Logger$1.log(5, 'Repeater.updateDataBinding() > exit : > ' + i, copy.name);

      if (copy.children) {
        copy.children.forEach(function (child) {
          if (child && child.props && child.props.databinding) {
            var databinding = child.props.databinding;

            for (var key in databinding) {
              var path = databinding[key]; // if we have parent path remove

              if (path.indexOf(parentPath) === 0) {
                path = path.substring(parentPath.length);
              } // if path starts with array we remove


              if (path.indexOf('[0]') === 0) {
                path = path.substring(3);
              }

              if (path.indexOf('.') === 0) {
                path = path.substring(1);
              }

              databinding[key] = "".concat(parentPath, "[").concat(i, "].").concat(path); //Logger.log(0, 'Repeater.updateDataBinding() > exit : > ' + copy.name, databinding[key])
              // otherwise add parent
            }
          }

          _this.updateDataBinding(child, i, parentPath);
        });
      }
    },
    forwardClick: function forwardClick(i, element, e) {
      var row = this.dataBindingInputPath ? JSONPath$1.get(this.value, "".concat(this.dataBindingInputPath, "[").concat(i, "]")) : null;

      if (element.lines && element.lines.length > 0) {
        if (this.dataBindingOutputPath && this.dataBindingInputPath) {
          if (row) {
            Logger$1.log(3, 'qRepeater.forwardClick() > Update databidning' + this.dataBindingOutputPath, row);
            /**
             * FIXME: Should we do a copy here???
             */

            JSONPath$1.set(this.value, this.dataBindingOutputPath, row);
          }
        }
      }
      /**
       * We could still check if there is a click method defined on the repeater and dispatch the click on this element
       * if the clicked child does not have a link or call back
       */


      Logger$1.log(5, 'qRepeater.forwardClick() ', JSON.stringify(row));
      this.$emit('qClick', element, e, row);
    },
    forwardChange: function forwardChange(element, e, value) {
      this.$emit('qChange', element, e, value);
    },
    forwardFocus: function forwardFocus(element, e, value) {
      this.$emit('qFocus', element, e, value);
    },
    forwardBlur: function forwardBlur(element, e, value) {
      this.$emit('qBlur', element, e, value);
    },
    forwardMouseOver: function forwardMouseOver(element, e, value) {
      this.$emit('qMouseOver', element, e, value);
    },
    forwardMouseOut: function forwardMouseOut(element, e, value) {
      this.$emit('qMouseOut', element, e, value);
    },
    forwardKeyPress: function forwardKeyPress(element, e, value) {
      this.$emit('qKeyPress', element, e, value);
    },
    forwardCallback: function forwardCallback(element, e, value) {
      this.$emit('qCallback', element, e, value);
    },
    getRowsFromTable: function getRowsFromTable(widget) {
      var result = [];

      if (widget.props.data && widget.props.data.length > 1) {
        var data = widget.props.data;
        this.dataBindingValues = [];
        var header = widget.props.data[0];

        for (var r = 1; r < data.length; r++) {
          var row = {};

          for (var c = 0; c < header.length; c++) {
            var col = header[c];
            row[col] = data[r][c];
          }

          result.push(row);
        }
      }

      return result;
    }
  },
  mounted: function mounted() {
    Logger$1.log(3, 'Repeater.mounted() > enter', this.element);
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-repeater', _vm.cssClass]
  }, [_vm._l(_vm.rows, function (row, i) {
    return _c('div', {
      key: i,
      staticClass: "qux-repeater-child"
    }, _vm._l(_vm.element.children, function (child) {
      return _c(child.qtype, {
        key: child.id,
        tag: "component",
        attrs: {
          "element": _vm.getDeepCopy(child, row, i),
          "model": _vm.model,
          "config": _vm.config
        },
        on: {
          "qClick": function qClick($event) {
            return _vm.forwardClick(i, $event);
          },
          "qChange": _vm.forwardChange,
          "qKeyPress": _vm.forwardKeyPress,
          "qFocus": _vm.forwardFocus,
          "qBlur": _vm.forwardBlur,
          "qMouseOver": _vm.forwardMouseOver,
          "qMouseOut": _vm.forwardMouseOut
        },
        model: {
          value: _vm.value,
          callback: function callback($$v) {
            _vm.value = $$v;
          },
          expression: "value"
        }
      });
    }), 1);
  }), _vm._v(" "), _vm._l(_vm.placeholders, function (placeholder, i) {
    return _c('div', {
      key: 'p' + i,
      staticClass: "qux-repeater-child qux-repeater-placeholder",
      staticStyle: {
        "height": "0px",
        "margin": "0px"
      }
    });
  })], 2);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-553020b4_0", {
    source: ".qux-repeater{overflow:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

//
var script$7 = {
  name: 'qImage',
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },

  /**
   * FIXME: add here some stuff for image uploads
   */
  mounted: function mounted() {
    Logger$1.log(0, 'qImage.mounted()');
  }
};

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-image', _vm.cssClass],
    on: {
      "click": _vm.onClick
    }
  });
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
var script$8 = {
  name: 'qCheckBox',
  mixins: [__vue_component__],
  data: function data() {
    return {
      checked: false
    };
  },
  computed: {
    isChecked: function isChecked() {
      if (this.isDesignSystemRoot) {
        return this.value;
      }

      if (this.element) {
        var input = this.dataBindingInput;
        return input === true;
      }

      return this.checked;
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.element) {
        var value = !this.isChecked;
        this.onValueChange(value, 'default');
        Logger$1.log(-1, 'qCheckBox.toggle() >' + this.dataBindingInputPath, value);
      } else {
        this.checked = !this.checked;
        this.$emit('change', this.checked);
        this.$emit('input', this.checked);
        Logger$1.log(5, 'qCheckBox.toggle() >' + this.checked);
      }
    }
  },
  watch: {
    value: function value(v) {
      Logger$1.log(5, 'qCheckBox.watch(value) > enter', v);

      if (v === false || v === true) {
        this.checked = v;
      }

      this.value = v;
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qCheckBox.mounted() enter');

    if (this.value === true || this.value === true) {
      this.checked = this.value;
    }
  }
};

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-checkbox', _vm.cssClass, {
      'qux-checkbox-checked': _vm.isChecked
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm._m(0), _vm._v(" "), _vm.label ? _c('span', {
    staticClass: "qux-checkbox-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]);
};

var __vue_staticRenderFns__$8 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux-checkbox-cntr"
  }, [_c('span', {
    staticClass: "qux-checkbox-hook"
  })]);
}];
/* style */

var __vue_inject_styles__$8 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-3e65d3a9_0", {
    source: ".qux-checkbox{display:inline-block;overflow:hidden;cursor:pointer}.qux-checkbox .qux-checkbox-cntr{position:relative;width:100%;height:100%;display:inline-block;vertical-align:top;border:1px solid #333}.qux-checkbox .qux-checkbox-hook{opacity:0;transition-duration:.3s;transition-property:opacity;border-bottom:3px solid #333;border-right:3px solid #333;transform:rotate(45deg);-ms-transform:rotate(45deg);-webkit-transform:rotate(45deg);display:inline-block;height:70%;width:30%;left:30%;position:absolute;opacity:0;top:0}.qux-checkbox .qux-checkbox-label{margin-left:10px;vertical-align:middle;cursor:pointer}.qux-checkbox-checked .qux-checkbox-hook{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

//
var script$9 = {
  name: 'qCheckBoxGroup',
  mixins: [__vue_component__],
  data: function data() {
    return {
      selected: []
    };
  },
  components: {
    'CheckBox': __vue_component__$8
  },
  computed: {
    checkBoxOptions: function checkBoxOptions() {
      if (this.element) {
        return this.options.map(function (o) {
          if (o.toLowerCase) {
            return {
              label: o,
              value: o
            };
          }

          return o;
        });
      }

      return [];
    }
  },
  methods: {
    isChecked: function isChecked(option) {
      Logger$1.log(5, 'qCheckBoxGroup.isChecked() >' + this.dataBindingInputPath, option);
      var input = this.dataBindingInput;

      if (input && Array.isArray(input)) {
        return input.indexOf(option) > -1;
      }

      return false;
    },
    select: function select(option) {
      var input = this.dataBindingInput;

      if (input) {
        if (Array.isArray(input)) {
          var pos = input.indexOf(option);

          if (pos < 0) {
            input.push(option);
          } else {
            Vue__default['default'].delete(input, pos);
          }
        }
      } else {
        input = [option];
      }

      this.onValueChange(input, 'default');
      Logger$1.log(5, 'qCheckBoxGroup.select() >' + this.dataBindingInputPath, input);
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qCheckBoxGroup.mounted() enter');
  }
};

/* script */
var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-checkgroup', _vm.cssClass]
  }, _vm._l(_vm.checkBoxOptions, function (option) {
    return _c('CheckBox', {
      key: option.value,
      attrs: {
        "lbl": option.label,
        "value": _vm.isChecked(option.value)
      },
      on: {
        "change": function change($event) {
          return _vm.select(option.value);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

var __vue_inject_styles__$9 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-dbe1bc1e_0", {
    source: ".qux-checkgroup{display:flex;flex-direction:column;justify-content:space-between}.qux-checkgroup .qux-checkbox{display:block}.qux-checkgroup .qux-checkbox .qux-checkbox-cntr{vertical-align:middle}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

//
var script$a = {
  name: 'qRadio',
  mixins: [__vue_component__],
  data: function data() {
    return {
      checked: false
    };
  },
  computed: {
    isChecked: function isChecked() {
      if (this.isDesignSystemRoot) {
        // FIXME: make like real checkbox
        return this.value === this.element.name;
      }

      if (this.element) {
        var input = this.dataBindingInput;
        return input === this.element.name;
      }

      Logger$1.log(5, 'qRadioBox.isChecked() >' + this.lbl, this.checked);
      return this.checked;
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.element) {
        var value = !this.isChecked ? this.element.name : null;
        this.onValueChange(value, 'default');
        Logger$1.log(5, 'qRadioBox.toggle() >' + this.dataBindingInputPath, value);
      } else {
        this.checked = !this.checked;
        this.$emit('change', this.checked);
        this.$emit('input', this.checked);
        Logger$1.log(5, 'qRadioBox.toggle() >' + this.checked);
      }
    }
  },
  watch: {
    value: function value(v) {
      Logger$1.log(5, 'qRadioBox.watch(value) > enter ' + this.lbl, v);

      if (v === false || v === true) {
        this.checked = v;
      }

      this.value = v;
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qRadioBox.mounted() enter');

    if (this.value === true || this.value === true) {
      this.checked = this.value;
    }
  }
};

/* script */
var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-radiobox', _vm.cssClass, {
      'qux-radiobox-checked': _vm.isChecked
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm._m(0), _vm._v(" "), _vm.label ? _c('span', {
    staticClass: "qux-radiobox-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]);
};

var __vue_staticRenderFns__$a = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux-radiobox-cntr"
  }, [_c('span', {
    staticClass: "qux-radiobox-hook"
  })]);
}];
/* style */

var __vue_inject_styles__$a = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-a24ddac4_0", {
    source: ".qux-radiobox{display:inline-block;overflow:hidden}.qux-radiobox .qux-radiobox-cntr{position:relative;width:100%;height:100%;display:inline-block;vertical-align:middle}.qux-radiobox .qux-radiobox-hook{opacity:0;transition-duration:.3s;transition-property:opacity;background:#1973e8;border-radius:50%;display:inline-block;height:60%;width:60%;left:20%;position:absolute;opacity:0;top:20%}.qux-radiobox .qux-radiobox-label{margin-left:10px;vertical-align:middle;cursor:pointer}.qux-radiobox-checked .qux-radiobox-hook{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

//
var script$b = {
  name: 'qRadioGroup',
  mixins: [__vue_component__],
  data: function data() {
    return {
      selected: null
    };
  },
  components: {
    'RadioBox': __vue_component__$a
  },
  methods: {
    isChecked: function isChecked(option) {
      var input = this.dataBindingInput;
      Logger$1.log(5, 'qRadioGroup.isChecked() >' + option, input);

      if (input) {
        return input === option;
      }

      return false;
    },
    select: function select(option, e) {
      this.onValueChange(option, 'default');
      this.onClick(e);
      Logger$1.log(5, 'qRadioGroup.select() >' + this.dataBindingInputPath, option);
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qRadioGroup.mounted() enter');
  }
};

/* script */
var __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-radiogroup', _vm.cssClass]
  }, _vm._l(_vm.options, function (option) {
    return _c('RadioBox', {
      key: option,
      attrs: {
        "lbl": option,
        "value": _vm.isChecked(option)
      },
      on: {
        "change": function change($event) {
          return _vm.select(option);
        }
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$b = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-98feb130_0", {
    source: ".qux-radiogroup{display:flex;flex-direction:column;justify-content:space-between}.qux-radiogroup .qux-radiobox{display:block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

//
var script$c = {
  name: 'qToggle',
  mixins: [__vue_component__],
  data: function data() {
    return {
      active: false
    };
  },
  computed: {
    isActive: function isActive() {
      if (this.element) {
        var input = this.dataBindingInput;
        return input === true;
      }

      return this.active;
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.element) {
        var value = !this.isActive;
        this.onValueChange(value, 'default');
        Logger$1.log(5, 'qToggle.toggle() >' + this.dataBindingInputPath, value);
      } else {
        this.active = !this.active;
        this.$emit('change', this.active);
        this.$emit('input', this.active);
        Logger$1.log(5, 'qToggle.toggle() >' + this.active);
      }
    }
  },
  watch: {
    value: function value(v) {
      Logger$1.log(5, 'qToggle.watch(value) > enter', v);

      if (v === false || v === true) {
        this.active = v;
      }

      this.value = v;
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qToggle.mounted() enter');

    if (this.value === true || this.value === true) {
      this.active = this.value;
    }
  }
};

/* script */
var __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-toggle', _vm.cssClass, {
      'qux-active': _vm.isActive
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    staticClass: "qux-common-label"
  }, [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")])]);
};

var __vue_staticRenderFns__$c = [];
/* style */

var __vue_inject_styles__$c = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-4b60be54_0", {
    source: ".qux-toggle{cursor:pointer;transition:all .2s}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$c = undefined;
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

//
var script$d = {
  name: 'qSwitch',
  mixins: [__vue_component__],
  data: function data() {
    return {
      active: false
    };
  },
  computed: {
    isThin: function isThin() {
      if (this.element && this.element.style.cssClass === 'MatcWidgetTypeSwitchThin') {
        return true;
      }

      return false;
    },
    isActive: function isActive() {
      if (this.element) {
        var input = this.dataBindingInput;
        Logger$1.log(1, 'qSwitch.isActive() >' + this.dataBindingInputPath, input);
        return input === true;
      }

      return this.active;
    }
  },
  methods: {
    toggle: function toggle(e) {
      if (this.element) {
        var value = !this.isActive;
        this.onValueChange(value, 'default');
        this.onClick(e);
        Logger$1.log(5, 'qSwitch.toggle() >' + this.dataBindingInputPath, value);
      } else {
        this.active = !this.active;
        this.$emit('change', this.active);
        this.$emit('input', this.active);
        Logger$1.log(5, 'qSwitch.toggle() >' + this.active);
      }
    }
  },
  watch: {
    value: function value(v) {
      Logger$1.log(5, 'qSwitch.watch(value) > enter', v);

      if (v === false || v === true) {
        this.active = v;
      }

      this.value = v;
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qSwitch.mounted() enter');

    if (this.value === true || this.value === true) {
      this.active = this.value;
    }
  }
};

/* script */
var __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-switch', _vm.cssClass, {
      'qux-active': _vm.isActive
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    class: ['qux-switch-cntr', {
      'qux-switch-cntr-thin': _vm.isThin
    }]
  }, [_c('div', {
    staticClass: "qux-switch-on"
  }), _vm._v(" "), _c('div', {
    staticClass: "qux-switch-off"
  })]), _vm._v(" "), _c('div', {
    staticClass: "qux-switch-handle"
  })]);
};

var __vue_staticRenderFns__$d = [];
/* style */

var __vue_inject_styles__$d = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-3a4c29b8_0", {
    source: ".qux-switch{cursor:pointer;position:relative}.qux-switch .qux-switch-cntr{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden}.qux-switch .qux-switch-cntr.qux-switch-cntr-thin{height:50%;top:50%;transform:translateY(-50%);-webkit-transform:translateY(-50%)}.qux-switch .qux-switch-cntr .qux-switch-on{position:absolute;width:100%;height:100%;top:0;left:-100%;transition:all .3s}.qux-switch .qux-switch-cntr .qux-switch-off{position:absolute;width:100%;height:100%;top:0;left:0;transition:all .3s}.qux-switch .qux-switch-handle{position:absolute;top:0;left:0;transition:all .3s;border:1px solid transparent}.qux-switch.qux-active .qux-switch-handle{position:absolute;top:0;left:auto;right:0}.qux-switch.qux-active .qux-switch-on{left:0}.qux-switch.qux-active .qux-switch-off{left:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$d = undefined;
/* module identifier */

var __vue_module_identifier__$d = undefined;
/* functional template */

var __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

//
var script$e = {
  name: '_DND',
  props: {},
  computed: {},
  methods: {
    on: function on(node, event, callback) {
      if (node && node.toLowerCase) {
        node = document.getElementById(node);
      }

      if (node && node.addEventListener) {
        node.addEventListener(event, callback);
        return {
          'callback': callback,
          'node': node,
          'event': event,
          'remove': function remove() {
            this.node.removeEventListener(this.event, this.callback);
          }
        };
      } else {
        Logger$1.warn('_DNDN.on() > Pass a node of valid id');
      }
    },
    body: function body() {
      return document.getElementsByTagName("BODY")[0];
    },
    position: function position(node) {
      var ret = node.getBoundingClientRect();
      ret = {
        x: ret.left,
        y: ret.top,
        w: ret.right - ret.left,
        h: ret.bottom - ret.top
      };
      return ret;
    },
    mouse: function mouse(e) {
      var result = {
        x: 0,
        y: 0
      };

      if (e) {
        if (e.touches && e.touches.length > 0) {
          e = e.touches[0];
          result.x = e.clientX;
          result.y = e.clientY;
        } else if (e.changedTouches && e.changedTouches.length > 0) {
          e = e.changedTouches[0];
          result.x = e.clientX;
          result.y = e.clientY;
        } else {
          result.x = e.pageX;
          result.y = e.pageY;
        }
      }

      return result;
    },
    startDND: function startDND(e, move, up) {
      var _this = this;

      this._dndStartPos = this.mouse(e);
      this._dndMouseUpListener = this.on(this.body(), 'mouseup', function (upEvent) {
        _this.endDND(upEvent, up);
      });
      this._dndMouseMoveListener = this.on(this.body(), 'mousemove', function (moveEvent) {
        _this.moveDND(moveEvent, move);
      });
    },
    moveDND: function moveDND(e, move) {
      if (move) {
        try {
          var currentPos = this.mouse(e);
          var delta = this.getMouseDelta(this._dndStartPos, currentPos);
          move(delta, e);
        } catch (err) {
          Logger$1.error('_DND.moveDND()', err);
          this.cleanDND();
        }
      }
    },
    endDND: function endDND(e, up) {
      if (up) {
        try {
          var currentPos = this.mouse(e);
          var delta = this.getMouseDelta(this._dndStartPos, currentPos);
          up(delta, e);
        } catch (err) {
          Logger$1.error('_DND.endDND()', err);
        }
      }

      this.cleanDND();
    },
    getMouseDelta: function getMouseDelta(start, end) {
      return {
        x: end.x - start.x,
        y: end.y - start.y
      };
    },
    cleanDND: function cleanDND() {
      if (this._dndMouseUpListener) {
        this._dndMouseUpListener.remove();

        delete this._dndMouseUpListener;
      }

      if (this._dndMouseMoveListener) {
        this._dndMouseMoveListener.remove();

        delete this._dndMouseMoveListener;
      }

      delete this._dndStartPos;
    }
  },
  destroyed: function destroyed() {
    this.cleanDND();
  }
};

/* script */
var __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux-dnd"
  });
};

var __vue_staticRenderFns__$e = [];
/* style */

var __vue_inject_styles__$e = undefined;
/* scoped */

var __vue_scope_id__$e = undefined;
/* module identifier */

var __vue_module_identifier__$e = undefined;
/* functional template */

var __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

//
var script$f = {
  name: 'qDropDown',
  mixins: [__vue_component__, __vue_component__$e],
  data: function data() {
    return {
      isOpen: false,
      selected: null
    };
  },
  computed: {
    isMobile: function isMobile() {
      if (this.element && this.element.type === 'MobileDropDown') {
        return true;
      }

      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /iPad|iPhone|iPod/.test(userAgent) || /android/i.test(userAgent);
    },
    dropDownOption: function dropDownOption() {
      if (this.element) {
        return this.options.map(function (o) {
          if (o.toLowerCase || typeof o === 'number') {
            return {
              label: o,
              value: o
            };
          }

          return o;
        });
      }

      return [];
    },
    selectOption: function selectOption() {
      if (this.isDesignSystemRoot) {
        return this.value;
      }

      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          var found = this.options.find(function (o) {
            return o.value === input;
          });

          if (found) {
            return found.label;
          }

          return input;
        } else {
          var option = this.options[0];

          if (option.label) {
            return option.label;
          }

          return option;
        }
      }

      return this.selected;
    }
  },
  methods: {
    open: function open() {
      Logger$1.log(5, 'qDropDown.open()');
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this._bodyListener = this.on(this.body(), 'mousedown', this.close);
      }
    },
    close: function close() {
      Logger$1.log(5, 'qDropDown.close()');
      this.isOpen = false;

      if (this._bodyListener) {
        this._bodyListener.remove();
      }
    },
    select: function select(option) {
      Logger$1.log(5, 'qDropDown.select()', option);

      if (this.element) {
        this.onValueChange(option.value, 'default');
        Logger$1.log(5, 'qDropDown.toggle() >' + this.dataBindingInputPath, option.value);
      } else {
        this.selected = option.value;
        this.$emit('change', this.selected);
        this.$emit('input', this.selected);
        Logger$1.log(5, 'qSwitch.select() >' + this.selected);
      }

      this.close();
    }
  },
  watch: {},
  destroyed: function destroyed() {
    this.close();
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qDropDown.mounted() enter');
  }
};

/* script */
var __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-dropdown', _vm.cssClass, {
      'qux-error': _vm.hasError
    }, {
      'qux-open': _vm.isOpen
    }, {
      'qux-dropdown-mobile': _vm.isMobile
    }],
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "qux-dropdown-label"
  }, [_c('span', {
    staticClass: "qux-common-label qux-dropdown-label"
  }, [_vm._v("\n              " + _vm._s(_vm.selectOption) + "\n      ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm.isOpen ? _c('div', {
    staticClass: "qux-dropdown-popup"
  }, _vm._l(_vm.dropDownOption, function (o) {
    return _c('span', {
      key: o.label,
      staticClass: "qux-dropdown-item",
      on: {
        "mousedown": function mousedown($event) {
          $event.stopPropagation();
          return _vm.select(o);
        }
      }
    }, [_vm._v("\n            " + _vm._s(o.label) + "\n        ")]);
  }), 0) : _vm._e()]);
};

var __vue_staticRenderFns__$f = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux-dropdown-expend"
  }, [_c('span', {
    staticClass: "qux-dropdown-carret"
  })]);
}];
/* style */

var __vue_inject_styles__$f = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-c810c474_0", {
    source: ".qux-dropdown{border:1px solid #333;transition:all .2s;display:inline-block;position:relative;cursor:pointer}.qux-dropdown .qux-dropdown-label{display:flex;flex-direction:row;height:100%;width:100%;align-items:center}.qux-dropdown .qux-dropdown-label .qux-dropdown-expend{position:absolute;height:100%;top:0;right:0;width:40px}.qux-dropdown .qux-dropdown-label .qux-dropdown-carret{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid;display:inline-block;height:0;margin-left:2px;vertical-align:middle;width:0;position:absolute;right:50%;top:50%;transform:translateY(-50%) translateX(50%);cursor:pointer}.qux-dropdown .qux-dropdown-popup{position:absolute;top:calc(100% + 1px);left:0;display:none;border:1px solid #333;width:100%;z-index:1000;background:#fff}.qux-dropdown .qux-dropdown-item{display:block;cursor:pointer}.qux-dropdown.qux-open .qux-dropdown-popup{display:block}.qux-dropdown.qux-dropdown-mobile .qux-dropdown-popup{position:fixed;top:50%;transform:translateY(-50%);left:10%;width:80%;max-height:80%;overflow:auto;border-radius:20px;background:#333;color:#fff;box-shadow:0 3px 100px rgba(0,0,0,.5);border:none;z-index:10001}.qux-dropdown.qux-dropdown-mobile .qux-dropdown-popup .qux-dropdown-item{display:block;cursor:pointer;padding:20px;font-size:20px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$f = undefined;
/* module identifier */

var __vue_module_identifier__$f = undefined;
/* functional template */

var __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

//
var script$g = {
  name: 'qTestBox',
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },
  computed: {
    type: function type() {
      if (this.element && this.element.type === 'Password') {
        return 'password';
      }

      return 'text';
    },
    placeholder: function placeholder() {
      if (this.element && this.element.props && this.element.props.placeholder) {
        return this.element.props.label;
      }

      return '';
    }
  },
  methods: {
    onKeyPress: function onKeyPress(e) {
      var value = e.target.value;
      this.onValueChange(value, 'default');
      this.$emit('qKeyPress', this.element, e);
      Logger$1.log(3, 'qTextBox.onKeyPress() > exit', value);
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qTextBox.mounted() enter');
  }
};

/* script */
var __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('textarea', {
    class: ['qux-textarea qux-text-input', _vm.cssClass],
    attrs: {
      "placeholder": _vm.placeholder,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.dataBindingInput
    },
    on: {
      "click": _vm.onClick,
      "change": _vm.onChange,
      "keyup": _vm.onKeyPress
    }
  });
};

var __vue_staticRenderFns__$g = [];
/* style */

var __vue_inject_styles__$g = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-63a7598c_0", {
    source: ".qux-textarea{border:1px solid #333;resize:none;transition:all .2s}.qux-textarea:focus{outline:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$g = undefined;
/* module identifier */

var __vue_module_identifier__$g = undefined;
/* functional template */

var __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

//
var script$h = {
  name: 'qStepper',
  mixins: [__vue_component__],
  data: function data() {
    return {
      count: 0
    };
  },
  methods: {
    getCount: function getCount() {
      if (this.element) {
        var count = this.dataBindingInput;

        if (!isNaN(count)) {
          return count;
        }
      }

      return this.count;
    },
    onMinus: function onMinus(e) {
      var count = this.getCount();
      this.count = count - 1;
      this.change();
      this.onClick(e);
    },
    onPlus: function onPlus(e) {
      var count = this.getCount();
      this.count = count + 1;
      this.change();
      this.onClick(e);
    },
    change: function change() {
      if (this.element) {
        this.onValueChange(this.count, 'default');
      } else {
        this.$emit('change', this.count);
        this.$emit('input', this.count);
      }
    }
  },
  mounted: function mounted() {
    if (this.element && this.element.props && this.element.props.value) {
      this.count = this.element.props.value;
    }
  }
};

/* script */
var __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-stepper qux-common-no-select', _vm.cssClass]
  }, [_c('div', {
    staticClass: "qux-stepper-btn qux-stepper-minus",
    on: {
      "click": _vm.onMinus
    }
  }, [_c('span', {
    staticClass: "qux-stepper-label"
  }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
    staticClass: "qux-stepper-btn qux-stepper-plus",
    on: {
      "click": _vm.onPlus
    }
  }, [_c('span', {
    staticClass: "qux-stepper-label"
  }, [_vm._v("\n          +\n      ")])])]);
};

var __vue_staticRenderFns__$h = [];
/* style */

var __vue_inject_styles__$h = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-0c126f22_0", {
    source: ".qux-stepper{display:inline-block;border:1px solid #333;color:#333;display:flex}.qux-stepper .qux-stepper-minus{width:50%;position:relative;text-align:center}.qux-stepper .qux-stepper-plus{width:calc(50% - 1px);border-left:1px solid #333;position:relative;text-align:center}.qux-stepper .qux-stepper-label{position:absolute;top:45%;left:0;width:100%;transform:translateY(-50%)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$h = undefined;
/* module identifier */

var __vue_module_identifier__$h = undefined;
/* functional template */

var __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);

//
var script$i = {
  name: 'qSlider',
  mixins: [__vue_component__, __vue_component__$e],
  data: function data() {
    return {
      count: 0
    };
  },
  computed: {
    domPos: function domPos() {
      return this.position(this.$el);
    },
    handleWidth: function handleWidth() {
      if (this.element) {
        return this.element.style.handleWidth;
      }

      return 40;
    },
    minValue: function minValue() {
      if (this.element && this.element.props) {
        return this.element.props.min;
      }

      return 0;
    },
    maxValue: function maxValue() {
      if (this.element && this.element.props) {
        return this.element.props.max;
      }

      return 100;
    },
    left: function left() {
      var offSet = this.handleWidth / 2;
      var left = this.sliderValue / (this.maxValue - this.minValue);
      left = Math.min(1, left);
      left = Math.max(0, left);
      return "calc(".concat(left * 100, "% - ").concat(offSet, "px)");
    },
    progress: function progress() {
      return this.sliderValue;
    },
    sliderValue: function sliderValue() {
      if (this.element) {
        var count = this.dataBindingInput;

        if (!isNaN(count)) {
          return count;
        }
      }

      return this.count;
    }
  },
  methods: {
    onSliderClick: function onSliderClick(e) {
      this.setByMouse(e);
      this.onClick(e);
    },
    onHandleDown: function onHandleDown(e) {
      var _this = this;

      this.startDND(e, function (move, e) {
        return _this.setByMouse(e);
      });
    },
    setByMouse: function setByMouse(e) {
      var pos = this.domPos;
      var mouse = this.mouse(e);
      var left = (mouse.x - pos.x) / pos.w;
      left = Math.min(1, left);
      left = Math.max(0, left);
      var value = (this.maxValue - this.minValue) * left;
      this.onChange(value);
    },
    onChange: function onChange(value) {
      this.count = Math.round(value);

      if (this.element) {
        this.onValueChange(this.count, 'default');
        this.$emit('qChange', this.element, null, this.count);
      } else {
        this.$emit('change', this.count);
        this.$emit('input', this.count);
      }

      Logger$1.log(5, 'qSlider.onChange() exit > ', this.count);
    }
  },
  mounted: function mounted() {
    if (this.element && this.element.props && this.element.props.value) {
      this.count = this.element.props.value;
    }
  }
};

/* script */
var __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-slider', _vm.cssClass],
    on: {
      "click": _vm.onSliderClick
    }
  }, [_c('div', {
    staticClass: "qux-slider-track"
  }, [_c('div', {
    staticClass: "qux-slider-progress",
    style: {
      'width': _vm.progress + '%'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "qux-slider-handle-cntr"
  }, [_c('div', {
    staticClass: "qux-slider-handle",
    style: {
      'left': _vm.left
    },
    on: {
      "mousedown": _vm.onHandleDown
    }
  })])]);
};

var __vue_staticRenderFns__$i = [];
/* style */

var __vue_inject_styles__$i = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-16ccfc23_0", {
    source: ".qux-slider{position:relative;cursor:pointer}.qux-slider .qux-slider-track{width:100%;height:34%;position:absolute;top:calc(50% - 17%);left:0;border:0;overflow:hidden}.qux-slider .qux-slider-track .qux-slider-progress{height:100%}.qux-slider .qux-slider-handle-cntr{position:absolute;top:0;left:0}.qux-slider .qux-slider-handle{position:absolute;top:0;left:0;width:40px;border-radius:20px;cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$i = undefined;
/* module identifier */

var __vue_module_identifier__$i = undefined;
/* functional template */

var __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

//
var script$j = {
  name: 'qDate',
  mixins: [__vue_component__],
  props: ['range'],
  data: function data() {
    return {
      isRange: false,
      selected: new Date(),
      viewDate: new Date(),
      day_names: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      month_names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
  },
  computed: {
    backLabel: function backLabel() {
      if (this.element && this.element.props.lastButtonLbl) {
        return '<';
      }

      return '-';
    },
    nextLabel: function nextLabel() {
      if (this.element && this.element.props.nextButtonLbl) {
        return '>';
      }

      return '+';
    },
    dateLabel: function dateLabel() {
      return this.month_names[this.viewDate.getMonth()] + ' ' + this.viewDate.getFullYear();
    },
    selectedDate: function selectedDate() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          if (input.start && input.end) {
            if (input.start.toLowerCase) {
              input.start = Date.parse(input.start);
            }

            if (input.end.toLowerCase) {
              input.end = Date.parse(input.end);
            }
          }

          if (input.toLowerCase) {
            input = Date.parse(input);
          }

          return input;
        }
      }

      return this.selected;
    },
    body: function body() {
      var year = this.viewDate.getFullYear();
      var month = this.viewDate.getMonth();
      var first = new Date(year, month, 1);
      var offset = first.getDay();
      var week = [];
      var result = []; // male 45 and filter empty last row

      for (var i = 0; i < 35; i++) {
        if (i % 7 == 0) {
          week = [];
          result.push(week);
        }

        var day = {
          day: '',
          year: year,
          month: month,
          weekend: false
        };
        week.push(day);
        /**
         * Chekc if we are in current month
         */

        if (i - offset >= 0) {
          day.day = i - offset + 1 + '';
          var d1 = new Date(year, month, day.day); // check that we are not in next months

          if (d1.getMonth() != month) {
            day.day = '';
          }
        }

        if (i % 7 == 0 || i % 7 == 6) {
          day.weekend = true;
        }

        day.css = this.getSelectedCSS(day);
      }

      return result;
    }
  },
  methods: {
    getSelectedCSS: function getSelectedCSS(day) {
      if (this.isRange) {
        /**
         * Check if we have start range
         */
        if (this.selected.start) {
          var start = this.selected.start;

          if (day.year === start.getFullYear() && day.month === start.getMonth() && day.day == start.getDate()) {
            return 'qux-date-range-start';
          }
        }
        /**
         * Check if end
         */


        if (this.selected.end) {
          var end = this.selected.end;

          if (day.year === end.getFullYear() && day.month === end.getMonth() && day.day == end.getDate()) {
            return 'qux-date-range-end';
          }
        }
        /**
         * Check if between
         */


        if (this.selected.start && this.selected.end) {
          var dayMS = this.getMillis(day);
          var startMS = this.selected.start.getTime();
          var endMS = this.selected.end.getTime();

          if (startMS < dayMS && dayMS < endMS) {
            return 'qux-date-range-middle';
          }
        }
      } else {
        var selected = this.selected;

        if (day.year === selected.getFullYear() && day.month === selected.getMonth() && day.day == selected.getDate()) {
          return 'qux-date-selected';
        }
      }

      return '';
    },
    getMillis: function getMillis(day) {
      return new Date(day.year, day.month, day.day).getTime();
    },
    onBack: function onBack() {
      var date = this.viewDate;
      var day = date.getDay();
      var month = date.getMonth();
      var year = date.getFullYear();
      month--;

      if (month < 0) {
        month = 11;
        year--;
      }

      this.setView(year, month, day);
    },
    onNext: function onNext() {
      var date = this.viewDate;
      var day = date.getDay();
      var month = date.getMonth();
      var year = date.getFullYear();
      month++;

      if (month > 11) {
        month = 0;
        year++;
      }

      this.setView(year, month, day);
    },
    setView: function setView(year, month, day) {
      this.viewDate = new Date(year, month, day);
    },
    onSelect: function onSelect(d) {
      if (this.isRange) {
        if (this.selected.end) {
          this.selected.start = new Date(d.year, d.month, d.day), this.selected.end = null;
        } else {
          this.selected.end = new Date(d.year, d.month, d.day);

          if (this.selected.start > this.selected.end) {
            var help = this.selected.start;
            this.selected.start = this.selected.end;
            this.selected.end = help;
          }
        }

        if (this.selected.end) {
          Logger$1.log(5, 'qDate.select() > range : ', this.selected);

          if (this.element) {
            this.onValueChange({
              start: this.toIsoString(this.selected.start),
              end: this.toIsoString(this.selected.end)
            }, 'default');
          } else {
            this.$emit('change', this.selected);
            this.$emit('input', this.selected);
          }
        }
      } else {
        if (d.day !== '') {
          this.selected = new Date(d.year, d.month, d.day);
          Logger$1.log(5, 'qDate.select() > date : ', this.selected);

          if (this.element) {
            /**
             * Here is something wrong with UTC offsets
             */
            this.onValueChange(this.toIsoString(this.selected), 'default');
          } else {
            this.$emit('change', this.selected);
            this.$emit('input', this.selected);
          }
        }
      }
    },
    toIsoString: function toIsoString(date) {
      if (date) {
        var month = date.getMonth() + 1;

        if (month < 10) {
          month = '0' + month;
        }

        var day = date.getDate();

        if (day < 10) {
          day = '0' + day;
        }

        return "".concat(date.getFullYear(), "-").concat(month, "-").concat(day);
      }

      return null;
    }
  },
  watch: {},
  mounted: function mounted() {
    if (this.element) {
      this.isRange = this.element.props.range;
    }

    if (this.range === true) {
      this.isRange = true;
    }

    if (this.isRange) {
      this.selected = {
        start: new Date(),
        end: new Date(new Date().getTime() + 86400000 * 4)
      };
    }

    if (!this.element && this.value) {
      Logger$1.log(5, 'qDate.mounted() standalone');
      this.selected = this.value;

      if (this.value.start) {
        // copy value to ensure changes are not leaked
        this.selected = {
          start: this.value.start,
          end: this.value.end
        };
        this.viewDate = this.selected.start;
      } else {
        this.viewDate = this.value;
      }
    }

    Logger$1.log(0, 'qDate.mounted() enter', this.element);
  }
};

/* script */
var __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-date', _vm.cssClass],
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "qux-date-header"
  }, [_c('div', {
    staticClass: "qux-date-header-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onBack($event);
      }
    }
  }, [_c('span', {
    staticClass: "qux-common-valign-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.backLabel) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "qux-date-header-label"
  }, [_c('span', {
    staticClass: "qux-common-valign-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.dateLabel) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "qux-date-header-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onNext($event);
      }
    }
  }, [_c('span', {
    staticClass: "qux-common-valign-center"
  }, [_vm._v("\n                     " + _vm._s(_vm.nextLabel) + "\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "qux-date-body"
  }, [_c('table', [_c('tbody', [_c('tr', _vm._l(_vm.day_names, function (d) {
    return _c('th', {
      key: d,
      staticClass: "qux-date-week-days"
    }, [_vm._v(_vm._s(d))]);
  }), 0), _vm._v(" "), _vm._l(_vm.body, function (week, i) {
    return _c('tr', {
      key: i
    }, _vm._l(week, function (d, j) {
      return _c('td', {
        key: j,
        class: [d.css, {
          'qux-date-weekend': d.weekend
        }, {
          'qux-date-workday': !d.weekend
        }],
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.onSelect(d);
          }
        }
      }, [_vm._v("\n                          " + _vm._s(d.day) + "\n                      ")]);
    }), 0);
  })], 2)])])]);
};

var __vue_staticRenderFns__$j = [];
/* style */

var __vue_inject_styles__$j = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-7e8de3dc_0", {
    source: ".qux-date{overflow:hidden}.qux-date .qux-date-header{display:flex;width:100%;height:15%;font-size:120%}.qux-date .qux-date-header .qux-date-header-btn{position:relative;width:15%;text-align:center;cursor:pointer}.qux-date .qux-date-header .qux-date-header-label{position:relative;text-align:center;flex-grow:1}.qux-date .qux-date-header-label .qux-common-valign-center{width:100%}.qux-date .qux-date-body{width:100%;height:85%}.qux-date .qux-date-body table{width:100%;height:100%;border-spacing:0;border-collapse:collapse;text-align:center}.qux-date .qux-date-body td,.qux-date .qux-date-body th{padding:5px;width:14.3%}.qux-date .qux-date-body td{cursor:pointer}.qux-date .qux-date-body .qux-date-range-end,.qux-date .qux-date-body .qux-date-range-start,.qux-date .qux-date-body .qux-date-selected{background:#333;color:#fff}.qux-date .qux-date-body .qux-date-range-middle{background:#555;color:#fff}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$j = undefined;
/* module identifier */

var __vue_module_identifier__$j = undefined;
/* functional template */

var __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

//
var script$k = {
  name: 'qDatePicker',
  mixins: [__vue_component__, __vue_component__$e],
  data: function data() {
    return {
      isRange: false,
      isOpen: false,
      selected: null
    };
  },
  components: {
    'qDate': __vue_component__$j
  },
  computed: {
    icon: function icon() {
      if (this.element) {
        if (this.element.props.icon) {
          return this.element.props.icon;
        }
      }

      return false;
    },
    dropDownOption: function dropDownOption() {
      if (this.element) {
        return this.options.map(function (o) {
          if (o.toLowerCase) {
            return {
              label: o,
              value: o
            };
          }

          return o;
        });
      }

      return [];
    },
    selectedDate: function selectedDate() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          return input;
        }
      }

      return this.selected;
    },
    selectedLabel: function selectedLabel() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          if (input.start && input.end) {
            return this.toDateString(input.start) + ' - ' + this.toDateString(input.end);
          }

          if (input.toLowerCase) {
            input = Date.parse(input);
          }

          return this.toDateString(input);
        }
      }

      if (this.selected) {
        if (this.selected.start && this.selected.end) {
          return this.toDateString(this.selected.start) + ' - ' + this.toDateString(this.selected.end);
        }

        return this.toDateString(this.selected);
      }

      return this.label;
    },
    hasValue: function hasValue() {
      if (this.element) {
        var input = this.dataBindingInput;
        return input !== null && input !== undefined;
      }

      return this.selected !== null && this.selected !== undefined;
    }
  },
  methods: {
    open: function open() {
      Logger$1.log(5, 'qDatePicker.open()');
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this._bodyListener = this.on(this.body(), 'mousedown', this.close);
      }
    },
    close: function close() {
      Logger$1.log(5, 'qDatePicker.close()');
      this.isOpen = false;

      if (this._bodyListener) {
        this._bodyListener.remove();
      }
    },
    select: function select(selected) {
      if (this.element) {
        this.onValueChange(selected, 'default');
        Logger$1.log(5, 'qDatePicker.toggle() >' + this.dataBindingInputPath, selected);
      } else {
        this.selected = selected;
        this.$emit('change', this.selected);
        this.$emit('input', this.selected);
        Logger$1.log(5, 'qDatePicker.select() >', this.selected);
      }

      setTimeout(this.close, 250);
    },
    toDateString: function toDateString(d) {
      if (d && d.toLocaleDateString) {
        return d.toLocaleDateString();
      }

      return '';
    }
  },
  watch: {},
  destroyed: function destroyed() {
    this.close();
  },
  mounted: function mounted() {
    if (this.element) {
      this.isRange = this.element.props.range;
    }

    if (this.range === true) {
      this.isRange = true;
    }

    Logger$1.log(5, 'qDatePicker.mounted() enter', this.element);
  }
};

/* script */
var __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-date-picker', _vm.cssClass, {
      'qux-error': _vm.hasError
    }, {
      'qux-open': _vm.isOpen
    }],
    on: {
      "click": _vm.open
    }
  }, [_c('span', {
    class: ['qux-common-label', {
      'qux-common-placeholder': !_vm.hasValue
    }]
  }, [_vm._v("\n          " + _vm._s(_vm.selectedLabel) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "qux-date-picker-expend"
  }, [_vm.icon ? _c('span', {
    class: _vm.icon + ' qux-date-picker-icon'
  }) : _c('span', {
    staticClass: "qux-date-picker-carret"
  })]), _vm._v(" "), _vm.isOpen ? _c('div', {
    staticClass: "qux-date-picker-popup",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      },
      "mousedown": function mousedown($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('qDate', {
    attrs: {
      "range": _vm.isRange,
      "value": _vm.selectedDate
    },
    on: {
      "change": _vm.select
    }
  })], 1) : _vm._e()]);
};

var __vue_staticRenderFns__$k = [];
/* style */

var __vue_inject_styles__$k = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-5a26908a_0", {
    source: ".qux-date-picker{border:1px solid #333;position:relative}.qux-date-picker .qux-common-placeholder{opacity:.7}.qux-date-picker .qux-date-picker-icon{position:absolute;right:50%;top:50%;transform:translateY(-50%) translateX(50%)}.qux-date-picker .qux-date-picker-expend{position:absolute;height:100%;top:0;right:0;width:40px}.qux-date-picker .qux-date-picker-carret{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid;display:inline-block;height:0;margin-left:2px;vertical-align:middle;width:0;position:absolute;right:50%;top:50%;transform:translateY(-50%) translateX(50%);cursor:pointer}.qux-date-picker .qux-date-picker-popup{position:absolute;top:calc(100% + 1px);left:0;display:none;border:1px solid #333;width:100%;height:300px;max-width:300px;max-height:300px;z-index:1000;background:#fff}.qux-date-picker .qux-date-picker-popup .qux-date{height:100%}.qux-date-picker .qux-date-picker-item{display:block;cursor:pointer}.qux-date-picker.qux-open .qux-date-picker-popup{display:block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$k = undefined;
/* module identifier */

var __vue_module_identifier__$k = undefined;
/* functional template */

var __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

//
var script$l = {
  name: 'qStepper',
  mixins: [__vue_component__],
  data: function data() {
    return {
      selected: null
    };
  },
  computed: {
    segmentOptions: function segmentOptions() {
      if (this.element) {
        return this.options.map(function (o) {
          if (o.toLowerCase) {
            return {
              label: o,
              value: o
            };
          }

          return o;
        });
      }

      return [];
    },
    isMultiSelect: function isMultiSelect() {
      if (this.element) {
        return this.element.props.multi;
      }

      return false;
    }
  },
  methods: {
    isChecked: function isChecked(option) {
      var input = this.dataBindingInput;

      if (input) {
        if (this.isMultiSelect) {
          Logger$1.log(5, 'qSegmentButton.isChecked() > Mutli : ' + option.value, input);
          return input.indexOf(option.value) >= 0;
        } else {
          Logger$1.log(5, 'qSegmentButton.isChecked() > Single : ' + option.value, input);
          return input === option.value;
        }
      }

      return false;
    },
    select: function select(option) {
      var value = option.value;

      if (this.isMultiSelect) {
        var input = this.dataBindingInput;

        if (input) {
          if (!Array.isArray(input)) {
            input = [input];
          }

          var pos = input.indexOf(value);

          if (pos < 0) {
            input.push(value);
          } else {
            Vue__default['default'].delete(input, pos);
          }
        } else {
          input = [value];
        }

        this.onValueChange(input, 'default');
        Logger$1.log(5, 'qSegmentButton.select() > Single: ' + this.dataBindingInputPath);
      } else {
        this.onValueChange(value, 'default');
        Logger$1.log(5, 'qSegmentButton.select() > Single: ' + this.dataBindingInputPath, value);
      }
    }
  },
  mounted: function mounted() {}
};

/* script */
var __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-segment', _vm.cssClass]
  }, _vm._l(_vm.segmentOptions, function (option) {
    return _c('div', {
      key: option.value,
      class: ['qux-segment-item', {
        'qux-segment-item-selected': _vm.isChecked(option)
      }],
      on: {
        "click": function click($event) {
          return _vm.select(option);
        }
      }
    }, [_c('span', {
      staticClass: "qux-segment-item-label"
    }, [_vm._v("\n          " + _vm._s(option.label) + "\n      ")])]);
  }), 0);
};

var __vue_staticRenderFns__$l = [];
/* style */

var __vue_inject_styles__$l = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e41effc0_0", {
    source: ".qux-segment{display:flex;justify-content:stretch}.qux-segment .qux-segment-item{flex-grow:1;height:100%;cursor:pointer;display:flex;align-items:center}.qux-segment .qux-segment-item .qux-segment-item-label{display:inline-block;width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$l = undefined;
/* module identifier */

var __vue_module_identifier__$l = undefined;
/* functional template */

var __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

//
var script$m = {
  name: 'qRadioGroup',
  mixins: [__vue_component__],
  data: function data() {
    return {
      selected: null,
      ratingOptions: [1, 2, 3, 4, 5]
    };
  },
  methods: {
    getIcon: function getIcon(option) {
      var input = this.dataBindingInput;
      Logger$1.log(5, 'qRating.isChecked() >' + option, input);

      if (input) {
        if (input >= option) {
          return 'mdi mdi-star';
        }
      }

      return 'mdi mdi-star-outline';
    },
    select: function select(option) {
      this.onValueChange(option, 'default');
      Logger$1.log(5, 'qRating.select() >' + this.dataBindingInputPath, option);
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qRating.mounted() enter');
  }
};

/* script */
var __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-rating', _vm.cssClass]
  }, _vm._l(_vm.ratingOptions, function (option) {
    return _c('span', {
      key: option,
      class: ['qux-rating-icon'],
      on: {
        "click": function click($event) {
          return _vm.select(option);
        }
      }
    }, [_c('span', {
      class: _vm.getIcon(option)
    })]);
  }), 0);
};

var __vue_staticRenderFns__$m = [];
/* style */

var __vue_inject_styles__$m = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-61018948_0", {
    source: ".qux-rating{display:flex;justify-content:space-between}.qux-rating .mdi{cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$m = undefined;
/* module identifier */

var __vue_module_identifier__$m = undefined;
/* functional template */

var __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

//
var script$n = {
  name: 'qIconToggle',
  mixins: [__vue_component__],
  data: function data() {
    return {
      checked: false
    };
  },
  computed: {
    isSelected: function isSelected() {
      if (this.element) {
        var input = this.dataBindingInput;
        return input;
      }

      return this.checked;
    },
    icon: function icon() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          return this.element.props.activeIcon;
        } else {
          return this.element.props.passiveIcon;
        }
      }

      return '';
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.element) {
        var value = !this.isSelected;
        this.onValueChange(value, 'default');
        Logger$1.log(1, 'qIconToggle.toggle() >' + this.dataBindingInputPath, value);
      } else {
        this.checked = !this.checked;
        this.$emit('change', this.checked);
        this.$emit('input', this.checked);
        Logger$1.log(5, 'qIconToggle.toggle() >' + this.checked);
      }
    }
  },
  mounted: function mounted() {}
};

/* script */
var __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-icon-toggle', _vm.cssClass, {
      'qux-icon-toggle-selected': _vm.isSelected
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    class: ['qux-icon', _vm.icon]
  }), _vm._v(" "), _vm.label ? _c('span', {
    staticClass: "qux-icon-toggle-label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]);
};

var __vue_staticRenderFns__$n = [];
/* style */

var __vue_inject_styles__$n = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-47e1fda2_0", {
    source: ".qux-icon-toggle{display:flex;cursor:pointer}.qux-icon-toggle .qux-icon-toggle-label{padding-left:10px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$n = undefined;
/* module identifier */

var __vue_module_identifier__$n = undefined;
/* functional template */

var __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

//
var script$o = {
  name: "qCombo",
  mixins: [__vue_component__, __vue_component__$e],
  data: function data() {
    return {
      inputValue: "",
      isOpen: false,
      selected: null,
      matches: [],
      selectedIndex: 0
    };
  },
  computed: {
    placeholder: function placeholder() {
      if (this.element && this.element.props && this.element.props.placeholder) {
        return this.element.props.label;
      }

      return '';
    },
    hints: function hints() {
      if (this.element) {
        return this.options.map(function (o) {
          if (o.toLowerCase) {
            return {
              label: o,
              value: o
            };
          }

          return o;
        });
      }

      return [];
    },
    selectOption: function selectOption() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          return input;
        } else {
          return this.options[0];
        }
      }

      return this.selected;
    }
  },
  methods: {
    onKeyPress: function onKeyPress(e) {
      if (this.inputValue.length > 2) {
        var search = this.inputValue.toLowerCase();
        this.matches = this.hints.filter(function (hint) {
          return hint.label.toLowerCase().indexOf(search) >= 0;
        });

        if (this.matches.length > 0) {
          this.open();
          this.handleArrows(e);
        }
      } else {
        this.close();
      }
    },
    handleArrows: function handleArrows(e) {
      var key = e.which || e.keyCode;

      if (40 == key) {
        this.selectedIndex = Math.min(this.matches.length, this.selectedIndex + 1);
        return;
      }

      if (38 == key) {
        this.selectedIndex = Math.max(-1, this.selectedIndex - 1);
        return;
      }

      if (13 == key) {
        if (this.selectedIndex >= 0 && this.selectedIndex < this.matches.length) {
          this.select(this.matches[this.selectedIndex]);
          return;
        }

        if (this.suggestions.length == 1) {
          this.onSelect(this.matches[0]);
          return;
        }
      }
    },
    open: function open() {
      Logger$1.log(5, "qCombo.open()");
      this.isOpen = true;

      if (this.isOpen) {
        this._bodyListener = this.on(this.body(), "mousedown", this.close);
      }
    },
    close: function close() {
      Logger$1.log(5, "qCombo.close()");
      this.isOpen = false;
      this.selectedIndex = 0;

      if (this._bodyListener) {
        this._bodyListener.remove();
      }
    },
    select: function select(option) {
      Logger$1.log(5, "qCombo.select()", option);

      if (this.element) {
        this.onValueChange(option.value, "default");
        Logger$1.log(5, "qCombo.toggle() >" + this.dataBindingInputPath, option.value);
      } else {
        this.selected = option.value;
        this.$emit("change", this.selected);
        this.$emit("input", this.selected);
        Logger$1.log(5, "qSwitch.select() >" + this.selected);
      }

      this.inputValue = option.label;
      this.close();
    }
  },
  watch: {},
  destroyed: function destroyed() {
    this.close();
  },
  mounted: function mounted() {
    Logger$1.log(5, "qCombo.mounted() enter");
  }
};

/* script */
var __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-combo', _vm.cssClass, {
      'qux-error': _vm.hasError
    }, {
      'qux-open': _vm.isOpen
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputValue,
      expression: "inputValue"
    }],
    staticClass: "qux-combo-input",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "keyup": _vm.onKeyPress,
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.inputValue = $event.target.value;
      }
    }
  }), _vm._v(" "), _vm.isOpen ? _c('div', {
    staticClass: "qux-combo-popup"
  }, _vm._l(_vm.matches, function (o, i) {
    return _c('span', {
      key: o.label,
      class: ['qux-combo-item', {
        'qux-combo-item-selected': i === _vm.selectedIndex
      }],
      on: {
        "mousedown": function mousedown($event) {
          $event.stopPropagation();
          return _vm.select(o);
        }
      }
    }, [_vm._v("\n      " + _vm._s(o.label) + "\n    ")]);
  }), 0) : _vm._e()]);
};

var __vue_staticRenderFns__$o = [];
/* style */

var __vue_inject_styles__$o = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-722b82f0_0", {
    source: ".qux-combo{border:none;position:relative;transition:all .2s}.qux-combo .qux-combo-input{width:100%;height:100%}.qux-combo .qux-combo-input:focus{outline:0}.qux-combo .qux-combo-popup{position:absolute;top:calc(100% + 1px);left:0;display:none;border:1px solid #333;width:100%;z-index:1000;max-height:300px;overflow:auto;background:#fff}.qux-combo .qux-combo-item{display:block;cursor:pointer}.qux-combo.qux-open .qux-combo-popup{display:block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$o = undefined;
/* module identifier */

var __vue_module_identifier__$o = undefined;
/* functional template */

var __vue_is_functional_template__$o = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, createInjector, undefined, undefined);

//
var script$p = {
  name: 'qTable',
  mixins: [__vue_component__],
  data: function data() {
    return {
      'selected': [],
      'sortColumn': '',
      'sortOrder': 'arc'
    };
  },
  components: {
    'CheckBox': __vue_component__$8
  },
  computed: {
    columns: function columns() {
      if (this.element) {
        var columns = [];

        if (this.element.props.columns && this.element.props.columns.length > 0) {
          columns = this.element.props.columns.map(function (col) {
            return col.label;
          });
        } else {
          var data = this.parseData(this.element.props.data);
          columns = data[0];
        }

        var offset = 0;

        if (this.hasCheckBox) {
          columns.unshift('');
          offset = 1;
        }

        if (this.hasActions) {
          columns.push('');
        }

        return columns.map(function (col, i) {
          return {
            id: i,
            label: col,
            key: i - offset
          };
        });
      }

      return [];
    },
    hasCheckBox: function hasCheckBox() {
      if (this.element) {
        return this.element.style.checkBox === true;
      }

      return false;
    },
    hasActions: function hasActions() {
      if (this.element) {
        return this.element.props.tableActions && this.element.props.tableActions.length > 0;
      }

      return false;
    },
    actions: function actions() {
      if (this.element) {
        return this.element.props.tableActions;
      }

      return [];
    },
    sortedRows: function sortedRows() {
      var _this = this;

      if (this.sortColumn) {
        var key = this.sortColumn.key;
        var rows = this.rows;
        return rows.sort(function (a, b) {
          var valueA = a.values[key];
          var valueB = b.values[key];

          if (valueA.localeCompare && valueB.localeCompare) {
            if (_this.sortOrder === 'asc') {
              return valueA.localeCompare(valueB);
            } else {
              return valueB.localeCompare(valueA);
            }
          }

          if (_this.sortOrder === 'asc') {
            return valueA - valueB;
          } else {
            return valueB - valueA;
          }
        });
      }

      return this.rows;
    },
    rows: function rows() {
      var dataBindingInput = this.dataBindingInput;

      if (dataBindingInput && Array.isArray(dataBindingInput)) {
        if (this.element && this.element.props && this.element.props.columns && this.element.props.columns.length > 0) {
          var cols = this.element.props.columns;
          return dataBindingInput.map(function (row, i) {
            var values = cols.map(function (col) {
              if (row[col.databinding] !== undefined) {
                return row[col.databinding];
              }

              return '';
            });
            return {
              id: i,
              values: values,
              obj: row
            };
          });
        }

        return dataBindingInput;
      } else {
        if (this.element) {
          var data = this.parseData(this.element.props.data);
          return data.filter(function (row, i) {
            return i > 0;
          }).map(function (row, i) {
            return {
              id: i,
              values: row,
              obj: row
            };
          });
        }
      }

      return [];
    }
  },
  methods: {
    sortBy: function sortBy(col) {
      Logger$1.log(0, 'qTable.sortBy() enter > ', col);
      this.sortColumn = col;

      if (this.sortOrder === 'asc') {
        this.sortOrder = 'desc';
      } else {
        this.sortOrder = 'asc';
      }
    },
    onActionClick: function onActionClick(action, row) {
      Logger$1.log(5, 'qTable.onActionClick() enter > ' + action.label, row);
      this.$emit('qCallback', this.element, {
        callback: action.callback,
        params: row.obj
      });
    },
    selectRow: function selectRow(row) {
      var _this2 = this;

      var pos = this.selected.indexOf(row.id);

      if (pos < 0) {
        this.selected.push(row.id);
      } else {
        this.$delete(this.selected, pos);
      }

      var databinding = this.dataBinding;

      if (databinding.output) {
        var values = this.rows.filter(function (row) {
          return _this2.selected.indexOf(row.id) >= 0;
        }).map(function (row) {
          return row.obj;
        });
        this.onValueChange(values, 'output');
      }
    },
    isRowSelected: function isRowSelected(row) {
      return this.selected.indexOf(row.id) >= 0;
    },
    parseData: function parseData(data) {
      /**
       * for now assume csv
       */
      if (data.substring) {
        var table = [];
        var lines = data.split("\n");

        for (var i = 0; i < lines.length; i++) {
          var line = lines[i];
          table.push(line.split(","));
        }

        return table;
      } else {
        return data;
      }
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qTable.mounted() enter');
  }
};

/* script */
var __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-table', _vm.cssClass]
  }, [_c('table', [_c('thead', [_c('tr', _vm._l(_vm.columns, function (col) {
    return _c('th', {
      key: col.id,
      class: 'qux-table-cell qux-table-column-' + col.id,
      on: {
        "click": function click($event) {
          return _vm.sortBy(col);
        }
      }
    }, [_vm._v("\n                    " + _vm._s(col.label) + "\n                    "), _vm.sortColumn.id == col.id && _vm.sortOrder === 'asc' ? _c('span', {
      staticClass: "mdi mdi-chevron-down"
    }) : _vm._e(), _vm._v(" "), _vm.sortColumn.id == col.id && _vm.sortOrder !== 'asc' ? _c('span', {
      staticClass: "mdi mdi-chevron-up"
    }) : _vm._e()]);
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l(_vm.sortedRows, function (row) {
    return _c('tr', {
      key: row.id,
      staticClass: "qux-table-row"
    }, [_vm.hasCheckBox ? _c('td', {
      staticClass: "qux-table-cell"
    }, [_c('CheckBox', {
      attrs: {
        "value": _vm.isRowSelected(row)
      },
      on: {
        "change": function change($event) {
          return _vm.selectRow(row);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm._l(row.values, function (value, i) {
      return _c('td', {
        key: i,
        staticClass: "qux-table-cell"
      }, [_vm._v("\n                    " + _vm._s(value) + "\n                ")]);
    }), _vm._v(" "), _vm.hasActions ? _c('td', {
      staticClass: "qux-table-action-cntr"
    }, _vm._l(_vm.actions, function (action, i) {
      return _c('a', {
        key: action.label,
        class: ['qux-table-action', 'qux-table-action-' + i, {
          'qux-table-action-hover': action.isHover
        }],
        on: {
          "click": function click($event) {
            return _vm.onActionClick(action, row);
          }
        }
      }, [_vm._v("\n                        " + _vm._s(action.label) + "\n                    ")]);
    }), 0) : _vm._e()], 2);
  }), 0)])]);
};

var __vue_staticRenderFns__$p = [];
/* style */

var __vue_inject_styles__$p = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-59d391a6_0", {
    source: ".qux-table{overflow:auto}.qux-table.qux-table-fixed{display:flex;flex-direction:column}.qux-table.qux-table-fixed .qux-table-body{overflow:auto;flex-grow:1}.qux-table table{width:100%;height:100%;border-spacing:0;border-collapse:collapse}.qux-table table .qux-table-action{cursor:pointer}.qux-table table .qux-table-action:hover{text-decoration:underline}.qux-table table .qux-table-action-hover{opacity:0}.qux-table table th{cursor:pointer}.qux-table table tr:hover .qux-table-action-hover{opacity:1}.qux-table table .qux-table-action-cntr{text-align:right}.qux-checkbox{display:inline-block;overflow:hidden;cursor:pointer}.qux-checkbox .qux-checkbox-cntr{position:relative;width:100%;height:100%;display:inline-block;vertical-align:top;border:1px solid #333}.qux-checkbox .qux-checkbox-hook{opacity:0;transition-duration:.3s;transition-property:opacity;border-bottom:3px solid #333;border-right:3px solid #333;transform:rotate(45deg);-ms-transform:rotate(45deg);-webkit-transform:rotate(45deg);display:inline-block;height:70%;width:30%;left:30%;position:absolute;opacity:0;top:0}.qux-checkbox .qux-checkbox-label{margin-left:10px;vertical-align:middle;cursor:pointer}.qux-checkbox-checked .qux-checkbox-hook{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$p = undefined;
/* module identifier */

var __vue_module_identifier__$p = undefined;
/* functional template */

var __vue_is_functional_template__$p = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, createInjector, undefined, undefined);

//

var script$q = {
  name: 'qStepper',
  mixins: [__vue_component__],
  data: function data() {
    return {
      selected: 0,
      offset: 0
    };
  },
  computed: {
    selectedValue: function selectedValue() {
      if (this.element) {
        var dataBindig = this.dataBinding;

        if (dataBindig && dataBindig.output) {
          return JSONPath$1.get(this.value, dataBindig.output);
        }
      }

      return this.selected;
    },
    maxValue: function maxValue() {
      var dataBindig = this.dataBinding;

      if (dataBindig && dataBindig.elements) {
        return JSONPath$1.get(this.value, dataBindig.elements);
      }

      if (this.element) {
        return this.element.props.max;
      }

      return 0;
    },
    hasBack: function hasBack() {
      return this.offset > 0;
    },
    backIcon: function backIcon() {
      if (this.element) {
        return this.element.props.iconBack;
      }

      return '';
    },
    nextIcon: function nextIcon() {
      if (this.element) {
        return this.element.props.iconNext;
      }

      return '';
    },
    hasNext: function hasNext() {
      return this.numberofVisibleElements + this.offset < this.maxValue;
    },
    numberofVisibleElements: function numberofVisibleElements() {
      if (this.element) {
        return this.getNumberOfVisibleElements(this.element, this.element.style, this.element.w);
      }

      return 0;
    },
    valign: function valign() {
      if (this.element.style && this.element.style.verticalAlign) {
        return "qux-valign-".concat(this.element.style.verticalAlign, " ");
      }

      return '';
    },
    pages: function pages() {
      var pages = [];

      for (var i = 0; i < this.numberofVisibleElements; i++) {
        pages.push({
          value: this.offset + i,
          label: this.offset + i + 1
        });
      }

      return pages;
    }
  },
  methods: {
    onBack: function onBack() {
      Logger$1.log(0, 'QPaging', 'onBack');
      this.offset -= this.numberofVisibleElements;

      if (this.offset < 2) {
        this.offset = 0;
      }
    },
    onNext: function onNext() {
      Logger$1.log(0, 'QPaging', 'onNext');
      this.offset += this.numberofVisibleElements;

      if (this.offset > this.maxValue - this.numberofVisibleElements) {
        this.offset = this.maxValue - this.numberofVisibleElements;
      }
    },
    onSelect: function onSelect(page) {
      Logger$1.log(1, 'QPaging', 'onSelect', page.value);
      this.onValueChange(page.value, 'output');
      this.selected = page.value;
    },
    isChecked: function isChecked(page) {
      return page.value === this.selectedValue;
    },
    getNumberOfVisibleElements: function getNumberOfVisibleElements(model, style, width) {
      // keep in szyn
      var elementWidth = style.fontSize * 2;
      var numberofVisibleElements = Math.round(width * 0.9 / elementWidth) - 1;
      numberofVisibleElements = Math.min(numberofVisibleElements, model.props.max);

      if (model.props.maxVisisble > 1) {
        numberofVisibleElements = Math.min(numberofVisibleElements, model.props.maxVisisble);
      }

      if (this.offset > 0) {
        numberofVisibleElements--;
      }

      return numberofVisibleElements;
    }
  },
  mounted: function mounted() {
    Logger$1.log(3, 'QPaging', 'mounted');
  }
};

/* script */
var __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-paging qux-common-no-select', _vm.cssClass]
  }, [_vm.hasBack ? _c('span', {
    class: 'qux-paging-item ' + _vm.valign,
    on: {
      "click": _vm.onBack
    }
  }, [_c('span', {
    class: 'qux-common-label'
  }, [_c('span', {
    class: _vm.backIcon
  })])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.pages, function (page) {
    return _c('span', {
      key: page.value,
      class: ['qux-paging-item', {
        'qux-paging-item-active': _vm.isChecked(page)
      }, _vm.valign],
      on: {
        "click": function click($event) {
          return _vm.onSelect(page);
        }
      }
    }, [_c('span', {
      class: 'qux-common-label '
    }, [_vm._v("\n              " + _vm._s(page.label) + "\n        ")])]);
  }), _vm._v(" "), _vm.hasNext ? _c('span', {
    class: 'qux-paging-item ' + _vm.valign,
    on: {
      "click": _vm.onNext
    }
  }, [_c('span', {
    class: 'qux-common-label  '
  }, [_c('span', {
    class: _vm.nextIcon
  })])]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$q = [];
/* style */

var __vue_inject_styles__$q = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-1e229796_0", {
    source: ".qux-paging{display:flex;justify-content:space-between}.qux-paging .qux-paging-item{cursor:pointer;position:relative}.qux-paging .qux-paging-item-active{background:#333}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$q = undefined;
/* module identifier */

var __vue_module_identifier__$q = undefined;
/* functional template */

var __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);

//
var script$r = {
  name: 'qBarCHart',
  mixins: [__vue_component__],
  data: function data() {
    return {
      scaleFactor: 1
    };
  },
  computed: {
    chartType: function chartType() {
      if (this.element) {
        return this.element.type;
      }

      return '';
    },
    chartImage: function chartImage() {
      if (this.element) {
        var url = this.render(this.element, this.element.style, this.chartData, this.chartValue);
        return url;
      }

      return '';
    },
    chartData: function chartData() {
      var input = this.dataBindingInput;

      if (input) {
        return input;
      }

      if (this.element && this.element.props) {
        return this.element.props.data;
      }

      return [];
    },
    chartValue: function chartValue() {
      var input = this.dataBindingInput;

      if (input !== null && input !== undefined) {
        return input;
      }

      if (this.element && this.element.props) {
        return this.element.props.value;
      }

      return 0;
    }
  },
  methods: {
    render: function render(model, style, data, value) {
      if (model.type == "BarChart") {
        if (model.props.isHorizontal) {
          return this.renderHorizontal(model, style, data, value);
        } else if (model.props.isLine) {
          return this.renderLine(model, style, data, value);
        } else {
          return this.renderVertical(model, style, data, value);
        }
      } else if (model.type == "RingChart") {
        return this.renderRing(model, style, data, value);
      } else if (model.type == "MultiRingChart") {
        var r = Math.round(Math.min(model.w, model.h) / 2);
        var width = Math.min(r, style.lineWidth * this.scaleFactor);
        return this.renderPie(model, style, data, width);
      } else if (model.type == "PieChart") {
        var _width = Math.min(model.w, model.h) / 2;

        return this.renderPie(model, style, data, _width);
      } else {
        console.warn("render() > Not supported type : " + model.type);
      }
    },
    renderRing: function renderRing(model, style, data, p) {
      if (p > 1) {
        p = p / 100;
      }

      var w = model.w * this.scaleFactor;
      var h = model.h * this.scaleFactor;
      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h; // let n = 0.5;

      var x = Math.round(Math.min(w, h) / 2);
      var width = Math.min(x, style.lineWidth * this.scaleFactor);
      var ctx = canvas.getContext("2d");
      ctx.beginPath();
      var s = this.degreesToRadians(p * 360);
      var e = this.degreesToRadians(360);
      ctx.arc(x, x, x - width / 2, s, e);
      ctx.strokeStyle = style.background;
      ctx.lineWidth = width;
      ctx.stroke();
      ctx.beginPath();
      s = this.degreesToRadians(0);
      e = this.degreesToRadians(360 * p);
      ctx.arc(x, x, x - width / 2, s, e);
      ctx.strokeStyle = style.color;
      ctx.lineWidth = width;
      ctx.stroke();
      return canvas.toDataURL("image/png");
    },
    renderPie: function renderPie(model, style, data, width) {
      var w = model.w * this.scaleFactor;
      var h = model.h * this.scaleFactor;
      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      var x = Math.round(Math.min(w, h) / 2);
      /**
       * ToDo: Check if array of arrays or simple array
       */

      var row = data[0];
      var sum = 0;

      for (var i = 0; i < row.length; i++) {
        sum += row[i] * 1;
      }

      var ctx = canvas.getContext("2d");
      var lastP = 0;

      for (var _i = 0; _i < row.length; _i++) {
        var v = row[_i];
        var p = v / sum + lastP;
        ctx.beginPath();
        var s = this.degreesToRadians(lastP * 360);
        var e = this.degreesToRadians(360 * p);
        ctx.arc(x, x, x - width / 2, s, e);

        if (style["background" + _i]) {
          ctx.strokeStyle = style["background" + _i];
        }

        ctx.strokeStyle = style.color;
        ctx.lineWidth = width;
        ctx.stroke();
        lastP += v / sum;
      }

      return canvas.toDataURL("image/png");
    },
    degreesToRadians: function degreesToRadians(degrees) {
      return degrees * (Math.PI / 180) - Math.PI / 2;
    },
    renderLine: function renderLine(model, style, data) {
      data = this.flip(data);
      var w = model.w * this.scaleFactor;
      var h = model.h * this.scaleFactor;
      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      var n = 0.5;
      var ctx = canvas.getContext("2d");
      /**
       * Render lines
       */

      for (var r = 0; r < data.length; r++) {
        var row = data[r];
        var step = Math.round(w / (row.length - 1));
        ctx.beginPath();
        var y = 0;

        for (var c = 0; c < row.length; c++) {
          var v = row[c];
          y = h - Math.round(v * 1 / this.max * h);

          if (c == 0) {
            ctx.moveTo(n, y + n);
          } else {
            ctx.lineTo(c * step + n, y + n);
          }
        }

        if (model.has && model.has.fill) {
          ctx.lineTo(w + n, y + n);
          ctx.lineTo(w + n, h + n);
          ctx.lineTo(n, h + n);
          ctx.closePath();
        }

        if (style.lineWidth) {
          ctx.lineWidth = style.lineWidth * this.scaleFactor;
        }

        if (style["background" + r]) {
          ctx.strokeStyle = style["background" + r];

          if (model.has && model.has.fill) {
            ctx.fillStyle = style["background" + r];
            ctx.fill();
          }
        }

        ctx.stroke();
      }

      return canvas.toDataURL("image/png");
    },
    renderVertical: function renderVertical(model, style, data) {
      var w = model.w * this.scaleFactor;
      var h = model.h * this.scaleFactor;
      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext("2d");
      var summary = this.summary(data);
      var groupWidth = w / summary.groups;

      for (var r = 0; r < data.length; r++) {
        var group = data[r];
        var barWidth = Math.floor(groupWidth / (group.length + 1));

        if (barWidth === 100) {
          barWidth = 50;
        }

        var groupOffSet = groupWidth * r + barWidth / 2;

        for (var c = 0; c < group.length; c++) {
          var v = group[c];
          var barHeight = Math.round(h * (v / summary.max));
          var y = Math.round(groupOffSet + c * barWidth);
          ctx.beginPath();
          ctx.lineWidth = "4";
          ctx.strokeStyle = "green";

          if (style["background" + c]) {
            ctx.fillStyle = style["background" + c];
          }

          ctx.fillRect(y, h - barHeight, barWidth, barHeight);
          ctx.stroke();
        }
      }

      return canvas.toDataURL("image/png");
    },
    renderHorizontal: function renderHorizontal(model, style, data) {
      //
      //console.debug(model, style, data)
      var w = model.w * this.scaleFactor;
      var h = model.h * this.scaleFactor;
      var canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext("2d");
      var summary = this.summary(data);
      var groupHeight = w / summary.groups;

      for (var r = 0; r < data.length; r++) {
        var group = data[r];
        var barHeight = Math.floor(groupHeight / (group.length + 1));

        if (barHeight === 100) {
          barHeight = 50;
        }

        var groupOffSet = groupHeight * r + barHeight / 2;

        for (var c = 0; c < group.length; c++) {
          var v = group[c];
          var barWidth = Math.round(h * (v / summary.max));
          var x = Math.round(groupOffSet + c * barHeight);
          ctx.beginPath();
          ctx.lineWidth = "4";
          ctx.strokeStyle = "green";

          if (style["background" + c]) {
            ctx.fillStyle = style["background" + c];
          }

          ctx.fillRect(0, x, barWidth, barHeight);
          ctx.stroke();
        }
      }

      return canvas.toDataURL("image/png");
    },
    summary: function summary(data) {
      var result = {
        max: -10000000,
        groups: data.length
      };

      for (var r = 0; r < data.length; r++) {
        var row = data[r];

        for (var c = 0; c < row.length; c++) {
          result.max = Math.max(result.max, row[c]);
        }
      }

      return result;
    },
    flip: function flip(data) {
      this.max = -10000000;
      this.groups = 0;
      this.count = 0;
      var flipped = [];

      for (var r = 0; r < data.length; r++) {
        var row = data[r];

        for (var c = 0; c < row.length; c++) {
          if (!flipped[c]) {
            flipped[c] = [];
          }

          flipped[c][r] = row[c];
          this.max = Math.max(this.max, row[c]);
          this.count++;
        }
      }

      return flipped;
    },

    /**
     * Can be overwritten by children to have proper type conversion
     */
    _setDataBindingValue: function _setDataBindingValue(v) {
      var data = this.model.props.data;
      var value = this.model.props.value;

      if (this.type == "ring") {
        var v2 = v * 1;

        if (!isNaN(v2)) {
          value = v2;
        } else {
          console.warn('Chart._setDataBindingValue() > Wrong value for ring', v);
          return;
        }
      } else if (this.type === 'pie') {
        /**
         * Expects array with one element of array
         */
        data = [this.objectToArray(v)];
      } else {
        /**
         * Expect columns wise array of arrays
         * [ [1,2], [11, 22]...]
         */
        data = [];
        var temp = this.objectToArray(v);

        for (var r in temp) {
          var row = this.objectToArray(temp[r]);

          for (var c in row) {
            if (!data[c]) {
              data[c] = [];
            }

            data[c].push(row[c]);
          }
        }
      }

      this.renderChart(this.model, this.style, data, value);
      this.setValue(v);
    },
    objectToArray: function objectToArray(v) {
      var result = [];

      for (var key in v) {
        result.push(v[key]);
      }

      return result;
    }
  },
  mounted: function mounted() {//console.debug('Button.mounted()')
  }
};

/* script */
var __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-chart', _vm.cssClass, 'qux-chart-' + _vm.chartType]
  }, [_c('img', {
    attrs: {
      "src": _vm.chartImage
    }
  })]);
};

var __vue_staticRenderFns__$r = [];
/* style */

var __vue_inject_styles__$r = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-324212f1_0", {
    source: ".qux-chart{border:0 solid #333}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$r = undefined;
/* module identifier */

var __vue_module_identifier__$r = undefined;
/* functional template */

var __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);

//
var script$s = {
  name: 'qVector',
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },

  /**
   * FIXME: add here some stuff for image uploads
   */
  mounted: function mounted() {
    Logger$1.log(4, 'qVector.mounted()');
  }
};

/* script */
var __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-vector', _vm.cssClass],
    on: {
      "click": _vm.onClick
    }
  });
};

var __vue_staticRenderFns__$s = [];
/* style */

var __vue_inject_styles__$s = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-64cc6074_0", {
    source: ".qux-vector{background-size:100% 100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$s = undefined;
/* module identifier */

var __vue_module_identifier__$s = undefined;
/* functional template */

var __vue_is_functional_template__$s = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, createInjector, undefined, undefined);

//
var script$t = {
  name: 'qTimeline',
  mixins: [__vue_component__],
  data: function data() {
    return {
      checked: false
    };
  },
  computed: {},
  methods: {
    isChecked: function isChecked(value) {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input !== undefined && input != null) {
          if (isNaN(input)) {
            return input === value;
          }

          var option = this.options[input];
          return option === value;
        }

        if (this.element.props) {
          return this.element.props.selected === value;
        }
      }

      return false;
    }
  },
  watch: {
    value: function value(v) {
      Logger$1.log(5, 'qRadioBox.watch(value) > enter ' + this.lbl, v);

      if (v === false || v === true) {
        this.checked = v;
      }

      this.value = v;
    }
  },
  mounted: function mounted() {
    Logger$1.log(5, 'qRadioBox.mounted() enter');

    if (this.value === true || this.value === true) {
      this.checked = this.value;
    }
  }
};

/* script */
var __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-timeline', _vm.cssClass],
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "qux-timeline-line"
  }), _vm._v(" "), _vm._l(_vm.options, function (opt) {
    return _c('div', {
      key: opt,
      class: ['qux-timeline-element', {
        'qux-timeline-element-selected': _vm.isChecked(opt)
      }]
    }, [_c('div', {
      staticClass: "qux-timeline-circle"
    }), _vm._v(" "), _c('label', {
      staticClass: "qux-timeline-label"
    }, [_vm._v("\n        " + _vm._s(opt) + "\n      ")])]);
  })], 2);
};

var __vue_staticRenderFns__$t = [];
/* style */

var __vue_inject_styles__$t = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-38d3c055_0", {
    source: ".qux-timeline{position:relative}.qux-timeline-line{position:absolute;height:100%;background:#333;width:8px;top:0;left:8px;border-radius:4px}.qux-timeline-element{display:flex;align-items:center;position:relative}.qux-timeline-circle{display:inline-block;border-radius:50%;border-style:solid;width:32px;height:32px;background:#fff;border:2px solid #333}.qux-timeline-label{display:inline-block;flex-grow:1;color:#333;padding-left:8px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$t = undefined;
/* module identifier */

var __vue_module_identifier__$t = undefined;
/* functional template */

var __vue_is_functional_template__$t = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, createInjector, undefined, undefined);

//
var script$u = {
  name: "qUpload",
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },
  components: {},
  computed: {
    hasFiles: function hasFiles() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          return input !== undefined && input !== null;
        }
      }

      return false;
    },
    label: function label() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          if (this.maxFiles > 1 && Array.isArray(input)) {
            return input.map(function (f) {
              return f.name;
            }).join(', ');
          } else {
            return input.name;
          }
        }
      }

      if (this.element && this.element.props) {
        return this.element.props.label;
      }

      return '';
    },
    maxFiles: function maxFiles() {
      if (this.element && this.element.props && this.element.props.maxFiles !== undefined) {
        return this.element.props.maxFiles;
      }

      return 1;
    }
  },
  methods: {
    onFileChange: function onFileChange(e) {
      if (this.$refs.input) {
        var files = this.$refs.input.files;

        if (files.length >= this.maxFiles) {
          this.setFiles(files, e);
        }
      }
    },
    setFiles: function setFiles(files, e) {
      Logger$1.log(1, 'Upload.setFiles', files);

      if (this.element) {
        if (this.maxFiles === 1) {
          var value = files[0];
          this.onValueChange(value, 'default', e);
          Logger$1.log(5, 'Upload.setFiles() >' + this.dataBindingInputPath, value);
        } else {
          var _value = Array.from(files);

          this.onValueChange(_value, 'default', e);
          Logger$1.log(5, 'Upload.setFiles(1) >' + this.dataBindingInputPath, _value);
        }
      }
    }
  }
};

/* script */
var __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-upload', _vm.cssClass, {
      'qux-upload-has-files': _vm.hasFiles
    }]
  }, [_c('span', {
    staticClass: "qux-common-label"
  }, [_vm._v("\n          " + _vm._s(_vm.label) + "\n      ")]), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "MatcWidgetTypeUploadFile",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]);
};

var __vue_staticRenderFns__$u = [];
/* style */

var __vue_inject_styles__$u = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-2aa06362_0", {
    source: ".qux-upload{cursor:pointer;transition:all .2s;border:1px solid red}.qux-upload input{height:100%;width:100%;opacity:0;cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$u = undefined;
/* module identifier */

var __vue_module_identifier__$u = undefined;
/* functional template */

var __vue_is_functional_template__$u = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, createInjector, undefined, undefined);

//
var script$v = {
  name: "qUpload",
  mixins: [__vue_component__],
  data: function data() {
    return {};
  },
  components: {},
  computed: {
    icon: function icon() {
      if (this.element && this.element.style && this.element.style.icon) {
        return 'mdi ' + this.element.style.icon;
      }

      return '';
    },
    hasFiles: function hasFiles() {
      if (this.element) {
        var input = this.dataBindingInput;

        if (input) {
          return input !== undefined && input !== null;
        }
      }

      return false;
    },
    maxFiles: function maxFiles() {
      if (this.element && this.element.props && this.element.props.maxFiles !== undefined) {
        return this.element.props.maxFiles;
      }

      return 1;
    }
  },
  methods: {
    onFileChange: function onFileChange(e) {
      if (this.$refs.input) {
        var files = this.$refs.input.files;

        if (files.length >= this.maxFiles) {
          this.setFiles(files, e);
        }
      }
    },
    setFiles: function setFiles(files, e) {
      Logger$1.log(1, 'Camera.setFiles', files);

      if (this.element) {
        if (this.maxFiles === 1) {
          var value = files[0];
          this.onValueChange(value, 'default', e);
          Logger$1.log(5, 'Upload.setFiles() >' + this.dataBindingInputPath, value);
        } else {
          var _value = Array.from(files);

          this.onValueChange(_value, 'default', e);
          Logger$1.log(5, 'Upload.setFiles(1) >' + this.dataBindingInputPath, _value);
        }

        this.onClick(e);
      }
    }
  }
};

/* script */
var __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-camera', _vm.cssClass, {
      'qux-camera-has-files': _vm.hasFiles
    }]
  }, [_c('span', {
    class: [_vm.icon, 'qux-camera-icon']
  }), _vm._v(" "), _c('input', {
    ref: "input",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "capture": "user"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]);
};

var __vue_staticRenderFns__$v = [];
/* style */

var __vue_inject_styles__$v = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-7f2283cb_0", {
    source: ".qux-camera{cursor:pointer;transition:all .2s;border:1px solid red;position:relative}.qux-camera .qux-camera-icon{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer}.qux-camera input{height:100%;width:100%;opacity:0;cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$v = undefined;
/* module identifier */

var __vue_module_identifier__$v = undefined;
/* functional template */

var __vue_is_functional_template__$v = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, createInjector, undefined, undefined);

//
var script$w = {
  name: 'qUploadPreview',
  mixins: [__vue_component__],
  data: function data() {
    return {
      dataURL: '',
      placeholder: ''
    };
  },
  computed: {
    src: function src() {
      var file = this.dataBindingInput;

      if (file.name && file.size) {
        this.setFile();
        return this.dataURL;
      }

      return this.placeholder;
    }
  },
  methods: {
    getImagePlaceHolder: function getImagePlaceHolder(widget) {
      var w = widget.w * 2;
      var h = widget.h * 2;
      var c = document.createElement("canvas");
      var context = c.getContext("2d");
      c.width = w;
      c.height = h;
      h += 0.5;
      w += 0.5;
      var n = 0.5;
      context.moveTo(n, n);
      context.lineTo(w, h);
      context.moveTo(w, n);
      context.lineTo(n, h);
      context.strokeStyle = "#333";
      context.strokeWidth = 2;
      context.imageSmoothingEnabled = false;
      context.stroke();
      var url = 'url(' + c.toDataURL("image/png") + ')';
      return url;
    },
    setFile: function setFile() {
      var _this = this;

      Logger$1.log(2, 'qUploadPreview.setFile()');
      var file = this.dataBindingInput;

      if (file && file.name && file.size) {
        var reader = new FileReader();

        if (reader.readAsDataURL) {
          reader.onload = function () {
            _this.dataURL = 'url(' + reader.result + ')';
          };

          reader.readAsDataURL(file);
        }
      }
    }
  },
  watch: {
    value: function value(v) {
      this.setFile(v);
    }
  },
  mounted: function mounted() {
    Logger$1.log(4, 'qUploadPreview.mounted()');

    if (this.element) {
      this.placeholder = this.getImagePlaceHolder(this.element);
    }

    this.setFile();
  }
};

/* script */
var __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-upload-preview', _vm.cssClass],
    style: {
      'backgroundImage': _vm.src
    },
    on: {
      "click": _vm.onClick
    }
  });
};

var __vue_staticRenderFns__$w = [];
/* style */

var __vue_inject_styles__$w = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e3cbf4c6_0", {
    source: ".qux-upload-preview{border:0 solid #333;background-size:100%;background-repeat:no-repeat}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$w = undefined;
/* module identifier */

var __vue_module_identifier__$w = undefined;
/* functional template */

var __vue_is_functional_template__$w = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, createInjector, undefined, undefined);

//
var script$x = {
  name: 'qChildrenToggle',
  mixins: [__vue_component__],
  data: function data() {
    return {
      active: true
    };
  },
  computed: {
    isActive: function isActive() {
      if (this.isDesignSystemRoot) {
        /**
         * If no v-model is passed, we take the active
         */
        if (this.value === undefined) {
          return this.active;
        }

        return this.value;
      }

      if (this.element) {
        var input = this.dataBindingInput;
        Logger$1.log(3, 'qChildrenToggle.toggle() >' + this.dataBindingInputPath, input);
        return input === true;
      }

      return this.active;
    }
  },
  methods: {
    toggle: function toggle(e) {
      /**
       * We stop this here, because of the repeater in the demo.
       */
      this.stopEvent(e);

      if (this.element) {
        var value = !this.isActive;
        this.onValueChange(value, 'default');
        this.active = value;
        Logger$1.log(3, 'qChildrenToggle.toggle() >' + this.dataBindingInputPath, value);
      } else {
        this.active = !this.active;
        this.$emit('change', this.active);
        this.$emit('input', this.active);
        Logger$1.log(5, 'qChildrenToggle.toggle() >' + this.active);
      }
    },
    forwardClick: function forwardClick(element, e, value) {
      this.$emit('qClick', element, e, value);
    },
    forwardChange: function forwardChange(element, e, value) {
      this.$emit('qChange', element, e, value);
    },
    forwardFocus: function forwardFocus(element, e, value) {
      this.$emit('qFocus', element, e, value);
    },
    forwardBlur: function forwardBlur(element, e, value) {
      this.$emit('qBlur', element, e, value);
    },
    forwardMouseOver: function forwardMouseOver(element, e, value) {
      this.$emit('qMouseOver', element, e, value);
    },
    forwardMouseOut: function forwardMouseOut(element, e, value) {
      this.$emit('qMouseOut', element, e, value);
    },
    forwardKeyPress: function forwardKeyPress(element, e, value) {
      this.$emit('qKeyPress', element, e, value);
    },
    forwardCallback: function forwardCallback(element, e, value) {
      this.$emit('qCallback', element, e, value);
    },
    forwardDesignSystemCallback: function forwardDesignSystemCallback(element, e, type, callback) {
      this.$emit('qDesignSystemCallback', element, e, type, callback);
    }
  },
  watch: {
    value: function value(v) {
      Logger$1.log(-1, 'qChildrenToggle.watch(value) > enter', v);

      if (v === false || v === true) {
        this.active = v;
      }

      this.value = v;
    }
  },
  mounted: function mounted() {
    Logger$1.log(-1, 'qChildrenToggle.mounted() enter', this.value);

    if (this.value === true || this.value === true) {
      this.active = this.value;
    }
  }
};

/* script */
var __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-children-toggle', _vm.cssClass, {
      'qux-active': _vm.isActive
    }],
    on: {
      "click": _vm.toggle
    }
  }, [_vm.isActive ? _vm._l(_vm.element.children, function (child) {
    return _c(child.qtype, {
      key: child.id,
      tag: "component",
      attrs: {
        "element": child,
        "model": _vm.model,
        "config": _vm.config
      },
      on: {
        "qDesignSystemCallback": _vm.forwardDesignSystemCallback,
        "qCallback": _vm.forwardCallback,
        "qClick": _vm.forwardClick,
        "qChange": _vm.forwardChange,
        "qKeyPress": _vm.forwardKeyPress,
        "qFocus": _vm.forwardFocus,
        "qBlur": _vm.forwardBlur,
        "qMouseOver": _vm.forwardMouseOver,
        "qMouseOut": _vm.forwardMouseOut
      },
      model: {
        value: _vm.value,
        callback: function callback($$v) {
          _vm.value = $$v;
        },
        expression: "value"
      }
    });
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$x = [];
/* style */

var __vue_inject_styles__$x = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-28800f26_0", {
    source: ".qux-toggle{cursor:pointer;transition:all .2s}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$x = undefined;
/* module identifier */

var __vue_module_identifier__$x = undefined;
/* functional template */

var __vue_is_functional_template__$x = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, createInjector, undefined, undefined);

var RestEngine = /*#__PURE__*/function () {
  function RestEngine() {
    _classCallCheck(this, RestEngine);
  }

  _createClass(RestEngine, [{
    key: "run",
    value: function run(request, data) {
      if (request.method === "POST" && request.input.type === 'JSON') {
        return this.postOrPut(request, data);
      }

      if (request.method === "POST" && (request.input.type === 'IMAGE' || request.input.type === 'FILE')) {
        return this.postOrPostImage(request, data);
      }

      if (request.method === "GET") {
        return this.get(request, data);
      }

      if (request.method === "PUT" && request.input.type === 'JSON') {
        return this.postOrPut(request, data);
      }

      if (request.method === "PUT" && (request.input.type === 'IMAGE' || request.input.type === 'FILE')) {
        return this.postOrPostImage(request, data);
      }

      if (request.method === "DELETE") {
        return this.delete(request, data);
      }
    }
  }, {
    key: "buildURL",
    value: async function buildURL(request, values) {
      var url = await this.fillString(request.url, values, false);
      Logger$1.log(1, "buildURL", "exit", url);
      return url;
    }
  }, {
    key: "buildData",
    value: async function buildData(request, values) {
      var data = await this.fillString(request.input.template, values, true);
      Logger$1.log(1, "buildData", "exit", data);
      return data;
    }
  }, {
    key: "fillString",
    value: async function fillString(s, values) {
      var encodeFiles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      for (var key in values) {
        var value = await this.getStringFilelValue(values[key], encodeFiles);
        var pattern = "${" + key + "}";
        var i = 0;

        while (s.indexOf(pattern) >= 0 && i < 100) {
          s = s.replace(pattern, value);
          i++;
        }
      }

      if (s.indexOf('${') >= 0) {
        Logger$1.error("buildURL", "exit", s);
        throw new Error("buildURL() > Not all parameters replaced!" + s);
      }

      return s;
    }
  }, {
    key: "getStringFilelValue",
    value: function getStringFilelValue(value, encodeFiles) {
      // FIXME: check if we contain ${} to avoid messz stuff
      if (value && value.name && value.size && encodeFiles) {
        value = this.readFileAsBase64(value);
      }

      return value;
    }
  }, {
    key: "readFileAsBase64",
    value: async function readFileAsBase64(file) {
      var result = await this.base64(file);
      return result;
    }
  }, {
    key: "dataUrl",
    value: function dataUrl(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onerror = function (error) {
          return reject(error);
        };

        reader.onload = function () {
          return resolve(reader.result);
        };

        reader.readAsDataURL(file);
      });
    }
  }, {
    key: "base64",
    value: function base64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onerror = function (error) {
          return reject(error);
        };

        reader.onload = function () {
          var bytes = Array.from(new Uint8Array(reader.result));
          var base64StringFile = btoa(bytes.map(function (item) {
            return String.fromCharCode(item);
          }).join(""));
          resolve(base64StringFile);
        };

        reader.readAsArrayBuffer(file);
      });
    }
  }, {
    key: "handleOutput",
    value: function handleOutput(resolve, request, response) {
      Logger$1.log(2, "handleOutput", "enter", response);

      if (response.status == 200) {
        if (request.output.type === "JSON") {
          try {
            resolve(response.json());
          } catch (e) {
            throw new Error("Could not ".concat(request.method, " ").concat(request.url, ": ").concat(e.message));
          }
        }

        if (request.output.type === "TEXT") {
          resolve(response.text());
        }

        if (request.output.type === "IMAGE") {
          response.arrayBuffer().then(function (buffer) {
            resolve(buffer);
          });
        }

        return;
      }

      throw new Error("Could not ".concat(request.method, " ").concat(request.url, ": ").concat(response.statusText));
    }
  }, {
    key: "get",
    value: function get(request, values) {
      var _this = this;

      return new Promise(async function (resolve, reject) {
        var url = await _this.buildURL(request, values);

        var header = _this.createDefaultHeader(request);

        fetch(url, {
          method: "GET",
          mode: 'cors',
          cache: 'no-cache',
          headers: header,
          redirect: 'follow',
          referrer: 'no-referrer'
        }).then(function (response) {
          _this.handleOutput(resolve, request, response);
        }).catch(function (e) {
          reject(e);
        });
      });
    }
  }, {
    key: "postOrPostImage",
    value: function postOrPostImage(request, values) {
      var _this2 = this;

      return new Promise(async function (resolve, reject) {
        var url = await _this2.buildURL(request, values);

        var header = _this2.createDefaultHeader(request);

        var formData = new FormData();

        for (var key in values) {
          formData.append(key, values[key]);
        }

        fetch(url, {
          method: request.method,
          mode: 'cors',
          cache: 'no-cache',
          headers: header,
          redirect: 'follow',
          referrer: 'no-referrer',
          body: formData
        }).then(function (response) {
          _this2.handleOutput(resolve, request, response);
        }).catch(function (e) {
          reject(e);
          throw e;
        });
      });
    }
  }, {
    key: "postOrPut",
    value: function postOrPut(request, values) {
      var _this3 = this;

      return new Promise(async function (resolve, reject) {
        var url = await _this3.buildURL(request, values);
        var data = await _this3.buildData(request, values);

        var header = _this3.createDefaultHeader(request);

        fetch(url, {
          method: request.method,
          mode: 'cors',
          cache: 'no-cache',
          headers: header,
          redirect: 'follow',
          referrer: 'no-referrer',
          body: data
        }).then(function (response) {
          _this3.handleOutput(resolve, request, response);
        }).catch(function (e) {
          reject(e);
          throw e;
        });
      });
    }
  }, {
    key: "delete",
    value: function _delete(request, values) {
      var _this4 = this;

      return new Promise(async function (resolve, reject) {
        var url = await _this4.buildURL(request, values);

        var header = _this4.createDefaultHeader(request);

        fetch(url, {
          method: "DELETE",
          mode: 'cors',
          cache: 'no-cache',
          headers: header,
          redirect: 'follow',
          referrer: 'no-referrer'
        }).then(function (response) {
          _this4.handleOutput(resolve, request, response);
        }).catch(function (e) {
          reject(e);
          throw e;
        });
      });
    }
  }, {
    key: "createDefaultHeader",
    value: async function createDefaultHeader(request, values) {
      var token = await this.buildToken(request, values);
      var authType = request.authType ? request.authType : 'Bearer';

      if (request.input.type === 'JSON') {
        var headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': "".concat(authType, " ").concat(token)
        };
        return headers;
      } else if (request.input.type === 'FORM') {
        var _headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': "".concat(authType, " ").concat(token)
        };
        return _headers;
      }

      return new Headers({
        'Authorization': "".concat(authType, " ").concat(token)
      });
    }
  }, {
    key: "getNeededDataBings",
    value: function getNeededDataBings(rest) {
      var result = [];
      this.parseString(rest.url, result);
      this.parseString(rest.token, result);

      if ((rest.method === 'POST' || rest.method === 'PUT') && rest.input.type === 'JSON') {
        this.parseString(rest.input.template, result);
      }

      if ((rest.method === 'POST' || rest.method === 'PUT') && (rest.input.type === 'FILE' || rest.input.type === 'IMAGE')) {
        if (rest.input.fileDataBinding) {
          result.push(rest.input.fileDataBinding);
        }
      }

      return result;
    }
  }, {
    key: "parseString",
    value: function parseString(s, result) {
      var matches = s.match(/\$\{(.*?)\}/g);

      if (matches) {
        matches.forEach(function (m) {
          var variable = m.substring(2, m.length - 1);

          if (result.indexOf(variable) < 0) {
            result.push(variable);
          }
        });
      }
    }
  }]);

  return RestEngine;
}();

var RestEngine$1 = new RestEngine();

//
var script$y = {
  name: 'Logic',
  methods: {
    executeLogic: function executeLogic(widget, line) {
      Logger$1.log(0, 'QUX.executeLogic() > enter', widget.props, line);
      var lines = getLines(widget, this.model);
      var nextLine = null;

      if (widget.props && widget.props.isRandom) {
        var random = Math.random();
        var pos = Math.floor(random * lines.length);
        Logger$1.log(0, "QUX.executeLogic", "enter >  do AB:" + widget.id + " >> " + random + " >> " + pos);
        nextLine = lines[pos];
      } else {
        nextLine = this.getRuleMatchingLine(lines);
      }

      if (nextLine) {
        this.executeLine(nextLine);
      } else {
        /**
         * THis can happs as a modelling error!
         */
        Logger$1.warn('QUX.executeLogic() > NO RULE matching', lines);
      }
    },
    executeRest: async function executeRest(widget) {
      var _this = this;

      Logger$1.log(0, 'QUX.executeRest() > enter', widget.props.rest);
      var rest = widget.props.rest;
      /**
       * get al the data we need!
       */

      var requiredDataBindings = RestEngine$1.getNeededDataBings(rest);
      var data = {};
      requiredDataBindings.forEach(function (path) {
        var value = JSONPath$1.get(_this.value, path);
        data[path] = value;
      });
      /**
       * Call rest
       */

      var success = await this.runRestEngine(rest, data);
      /**
       * Find next line to execute
       */

      var lines = getLines(widget, this.model);
      var nextLine = this.getRuleMatchingLine(lines, success);

      if (nextLine) {
        this.executeLine(nextLine);
      } else {
        Logger$1.warn('QUX.executeRest() > NO RULE matching', lines);
      }
    },
    runRestEngine: async function runRestEngine(rest, data) {
      try {
        var result = await RestEngine$1.run(rest, data);
        Logger$1.log(1, "QUX.executeRest", "set data " + rest.output.databinding, result);

        if (rest.output.databinding) {
          JSONPath$1.set(this.value, rest.output.databinding, result);
        }

        return true;
      } catch (e) {
        Logger$1.error("QUX.executeRest", "error", e);

        if (rest.output.databinding) {
          JSONPath$1.set(this.value, rest.output.databinding, 'Error');
        }
      }

      return false;
    },
    getRuleMatchingLine: function getRuleMatchingLine(lines, restSuccess) {
      var matchedLine;

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];

        if (line.rule) {
          Logger$1.log(4, 'QUX.getRuleMatchingLine() > check', i, line.rule);

          if (line.rule.type === 'widget') {
            Logger$1.error('QUX.getRuleMatchingLine() > widget rules not supported in low code');
          }

          if (line.rule.type === 'databinding') {
            matchedLine = this.checkDataBindingRule(line);
          }

          if (line.rule.type === 'rest') {
            if (line.rule.restResponseStatus === '4xx' && !restSuccess) {
              matchedLine = line;
            }

            if (line.rule.restResponseStatus === '200' && restSuccess) {
              matchedLine = line;
            }
          }

          if (matchedLine) {
            break;
          }
        } else {
          /**
           * The *FIRST* line without a condition will be
           */
          if (!matchedLine) {
            matchedLine = line;
          }
        }
      }

      return matchedLine;
    },
    checkDataBindingRule: function checkDataBindingRule(line) {
      Logger$1.log(4, 'QUX.checkDataBindingRule() > enter', line.rule.databinding);
      var rule = line.rule;
      var value = JSONPath$1.get(this.value, rule.databinding);
      var result = this.isValueMatchingRule(value, true, rule);

      if (result) {
        Logger$1.log(-1, 'QUX.checkDataBindingRule() > match!', line);
        return line;
      }
    },
    isValueMatchingRule: function isValueMatchingRule(value, valid, rule) {
      Logger$1.log(3, 'QUX.isValueMatchingRule() > enter > ' + rule.value + ' ' + rule.operator + ' >' + value + '< / ' + valid);
      var operator = rule.operator;
      /**
       * Special handling for checkbox group.
       * We should have an "in" operation
       */

      if (value && Array.isArray(value) && value.length > 0) {
        value = value[0];
      }

      var result = false;

      switch (operator) {
        case "contains":
          if (value.toLowerCase && rule.value.toLowerCase) {
            var lowerValue = value.toLowerCase();
            var lowerRule = rule.value.toLowerCase();
            result = lowerValue.indexOf(lowerRule) >= 0;
          } else {
            result = false;
          }

          break;

        case "isValid":
          result = valid;
          break;

        case "==":
          result = value == rule.value;
          break;

        case "!=":
          if (rule.value === null || rule.value === undefined) {
            result = value !== null && value !== undefined && value !== '';
          } else {
            result = value != rule.value;
          }

          break;

        case ">":
          if (!value) {
            value = 0;
          }

          result = value * 1 > rule.value * 1;
          break;

        case "<":
          if (!value) {
            value = 0;
          }

          result = value * 1 < rule.value * 1;
          break;

        case ">=":
          if (!value) {
            value = 0;
          }

          result = value * 1 >= rule.value * 1;
          break;

        case "<=":
          if (!value) {
            value = 0;
          }

          result = value * 1 <= rule.value * 1;
          break;

        default:
          Logger$1.warn('QUX.isValueMatchingRule() Not supported operator');
      }

      return result;
    }
  }
};

/* script */
var __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux"
  });
};

var __vue_staticRenderFns__$y = [];
/* style */

var __vue_inject_styles__$y = undefined;
/* scoped */

var __vue_scope_id__$y = undefined;
/* module identifier */

var __vue_module_identifier__$y = undefined;
/* functional template */

var __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

//
var script$z = {
  name: 'Event',
  methods: {
    onScreenLoaded: function onScreenLoaded(screen) {
      Logger$1.log(3, 'QUX.onScreenLoaded() > ', screen);
      this.$emit('qScreenLoad', {
        value: this.value,
        element: screen,
        viewModel: this.value,
        qux: this
      });
      this.dispatchCallback(screen, null, 'load', null);
    },

    /**
     * This event come from now from the table. The event 'e'
     * contains the callback and the data of the row as 'params'.
     */
    onCallback: async function onCallback(element, e) {
      Logger$1.log(5, 'QUX.onCallback() > ' + element.name, e.callback);
      var executor = this.getMethodExcutor();

      if (executor) {
        if (executor[e.callback]) {
          var func = executor[e.callback];

          if (func instanceof Function) {
            var result = await func({
              value: this.value,
              element: element,
              viewModel: this.value,
              qux: this,
              params: e.params,
              event: e
            });
            /**
             * Since 0.4 we check if we can dispatch the result to a screen.
             */

            this.handleCallbackResult(result, e.callback);
            return;
          } else {
            console.warn('QUX.onCallback() > Callback is not method ', e.callback);
          }
        } else {
          console.warn('QUX.onCallback() > no method in executor with name ', e.callback);
        }
      }
    },
    onClick: function onClick(element, e, value) {
      Logger$1.log(4, 'QUX.onClick() > enter', element);

      if (Logger$1.logLevel > 10) {
        Logger$1.log(10, 'QUX.onClick()', e.target);
      }

      if (element.lines) {
        var line = getClickLine(element);

        if (line) {
          this.executeLine(line);
          this.stopEvent(e);
        }
      }

      if (element.action) {
        if (element.action.type === 'back') {
          Logger$1.log(0, 'QUX.onClick() > Go back');
          this.stopEvent(e);

          if (this.overlayScreenIds.length > 0) {
            this.removeLastOverlay();
          } else {
            this.$router.go(-1);
          }

          return;
        }
      }

      this.dispatchCallback(element, e, 'click', value);
    },
    stopEvent: function stopEvent(e) {
      if (e) {
        e.stopPropagation();
      }
    },
    executeLine: function executeLine(line) {
      Logger$1.log(0, 'QUX.executeLine() > enter', line);

      if (line) {
        var box = getBoxById(line.to, this.model);

        if (box.type === 'Screen') {
          this.navigateToScreen(box, line);
          return;
        } else if (box.type === 'Rest') {
          this.executeRest(box, line);
          return;
        } else if (box.type === 'LogicOr') {
          this.executeLogic(box, line);
          return;
        } else {
          Logger$1.warn('QUX.executeLine() > Not supported line target', box);
        }
      } else {
        Logger$1.error('QUX.executeLine() > ERROR. Null passed', line);
      }
    },
    dispatchCallback: async function dispatchCallback(element, e, type, value) {
      Logger$1.log(4, 'QUX.dispatchCallback() > enter > ' + type, element);

      if (element.props && element.props.callbacks) {
        var callback = element.props.callbacks[type];

        if (callback) {
          Logger$1.log(2, 'QUX.dispatchCallback() > callback > ' + type, callback);
          var executor = this.getMethodExcutor();

          if (executor) {
            if (executor[callback]) {
              var func = executor[callback];

              if (func instanceof Function) {
                this.stopEvent(e);
                /**
                 * This is crucial. we need to keep this signature the same.
                 */

                var result = await func({
                  value: value,
                  element: element,
                  viewModel: this.value,
                  qux: this,
                  event: e
                });
                this.handleCallbackResult(result, callback);
                return;
              } else {
                console.warn('QUX.dispatchCallback() > Callback is not method ', callback);
              }
            } else {
              console.warn('QUX.dispatchCallback() > no method in $parent with name ', callback);
            }
          }
        }
      }
    },
    handleCallbackResult: function handleCallbackResult(result, callback) {
      /**
      * Since 0.4 we check if we can dispatch the result to a screen.
      */
      if (result) {
        Logger$1.log(-1, 'QUX.handleCallbackResult() > callback > ' + callback, result);
        var nextScreen = Object.values(this.model.screens).find(function (s) {
          return s.name === result;
        });

        if (nextScreen) {
          this.setScreen(result);
          this.scrollToTop();
        } else {
          Logger$1.warn('QUX.handleCallbackResult() > no screen with name > ' + result);
        }
      }
    },
    navigateToScreen: function navigateToScreen(screen, line) {
      if (screen.style && screen.style.overlay === true) {
        Logger$1.log(1, 'Qux(Event).navigateToScreen() > Overlay', screen.name);
        this.overlayScreenIds.push(screen.id);
      } else {
        Logger$1.log(1, 'Qux(Event).navigateToScreen() > Link', screen.name);
        this.overlayScreenIds = [];
        this.setScreen(screen.name);

        if (!line || line.scroll !== true) {
          this.scrollToTop();
        }
      }
    },
    scrollToTop: function scrollToTop() {
      Logger$1.log(4, 'Qux(Event).scrollToTop()');
      this.$emit('qScrollTop', {});
    },
    popOverlay: function popOverlay(e) {
      /**
       * Only pop of the screen background was hit.
       */
      if (this.$refs.overlayCntr && e && e.target === this.$refs.overlayCntr.$el) {
        Logger$1.log(4, 'Qux(Event).popOverlay()');
        this.removeLastOverlay();
      }
    },
    removeLastOverlay: function removeLastOverlay() {
      Logger$1.log(4, 'Qux(Event).removeLastOverlay()');

      if (this.overlayScreenIds.length > 0) {
        this.overlayScreenIds.pop();
      }
    },
    closeAllOverlays: function closeAllOverlays() {
      Logger$1.log(4, 'Qux(Event).closeAllOverlays()');
      this.overlayScreenIds = [];
    },
    onChange: function onChange(element, e, value) {
      Logger$1.log(1, 'Qux(Event).onChange() > ', value);
      this.$emit('qChange', element, e);
      this.dispatchCallback(element, e, 'change', value);
    },
    onKeyPress: function onKeyPress(element, e, value) {
      Logger$1.log(2, 'Qux(Event).onKeyPress() > ', value);
      this.$emit('qKeyPress', element, e);
      this.dispatchCallback(element, e, 'change', value);
    },
    onFocus: function onFocus(element, e, value) {
      this.$emit('qFocus', element, e);
      this.dispatchCallback(element, e, 'focus', value);
    },
    onBlur: function onBlur(element, e, value) {
      this.$emit('qBlur', element, e);
      this.dispatchCallback(element, e, 'blur', value);
    },
    onMouseOver: function onMouseOver(element, e) {
      this.$emit('qMouseOver', element, e);
    },
    onMouseOut: function onMouseOut(element, e) {
      this.$emit('qMouseOut', element, e);
    }
  }
};

/* script */
var __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux"
  });
};

var __vue_staticRenderFns__$z = [];
/* style */

var __vue_inject_styles__$z = undefined;
/* scoped */

var __vue_scope_id__$z = undefined;
/* module identifier */

var __vue_module_identifier__$z = undefined;
/* functional template */

var __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

//
var script$A = {
  mixins: [__vue_component__$z, __vue_component__$y],
  name: 'QUX',
  props: {
    'app': {},
    'screen': {
      type: String
    },
    'selected': {
      type: String
    },
    'debug': {
      type: String
    },
    'value': {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    'executor': {
      type: Object
    },
    'config': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      server: 'https://quant-ux.com',
      model: null,
      mobileModel: null,
      tabletModel: null,
      desktoModel: null,
      selectedScreenId: null,
      overlayScreenIds: [],
      hash: false,
      msg: 'Loading...',
      mergedConfig: Config$1.getDefault()
    };
  },
  computed: {
    treeModel: function treeModel() {
      if (this.model) {
        var transformer = new ModelTransformer(this.model, this.mergedConfig, this.selected);
        var tree = transformer.transform();
        this.setGlobalCSS(tree, this.selected);
        return tree;
      }

      return {
        screens: []
      };
    },
    currentScreen: function currentScreen() {
      var _this = this;

      if (this.selectedScreenId) {
        var screen = this.treeModel.screens.find(function (screen) {
          return screen.id === _this.selectedScreenId;
        });

        if (screen) {
          return screen;
        }
      }

      return this.getDefaultScreen();
    },
    isComponentScreen: function isComponentScreen() {
      var s = this.currentScreen;
      return s ? s.isComponentScreen : false;
    },
    imagePrefix: function imagePrefix() {
      if (this.hash) {
        return "".concat(this.server, "/rest/images/").concat(this.hash, "/");
      }

      return this.mergedConfig.imageFolder;
    },
    hasOverlay: function hasOverlay() {
      return this.overlayScreenIds.length > 0;
    },
    currentOverlay: function currentOverlay() {
      var overlayId = this.overlayScreenIds[this.overlayScreenIds.length - 1];
      var overlay = this.treeModel.screens.find(function (screen) {
        return screen.id === overlayId;
      });
      return overlay;
    },
    isFixedOverlay: function isFixedOverlay() {
      var overlayId = this.overlayScreenIds[this.overlayScreenIds.length - 1];
      var overlay = this.treeModel.screens.find(function (screen) {
        return screen.id === overlayId;
      });

      if (overlay) {
        return overlay.style.fixed;
      }

      return false;
    },
    isBluredOverlay: function isBluredOverlay() {
      var overlayId = this.overlayScreenIds[this.overlayScreenIds.length - 1];
      var overlay = this.treeModel.screens.find(function (screen) {
        return screen.id === overlayId;
      });

      if (overlay) {
        return overlay.style.blur;
      }

      return false;
    }
  },
  methods: {
    setGlobalCSS: function setGlobalCSS(tree) {
      var compressed = new CSSOptimizer(this.mergedConfig).runTree(tree);
      var classes = new CSSFactory(this.mergedConfig, this.imagePrefix).generate(compressed);
      var css = [];
      css = Object.values(classes).flatMap(function (element) {
        return element.map(function (e) {
          return e.code;
        });
      });
      css = css.join('\n');
      CSSWriter$1.write(css, tree.id);
    },
    setApp: async function setApp(app) {
      if (app.substring) {
        var model = await this.loadAppByKey(app);
        this.model = model;
        this.hash = app;
      } else if (app.mobile || app.desktop) {
        Logger$1.log(1, 'QUX.setApp() > reponsive', app);

        if (app.mobile) {
          if (app.mobile.substring) {
            this.mobileModel = await this.loadAppByKey(app.mobile);
          } else {
            this.mobileModel = app.mobile;
          }
        }

        if (app.tablet) {
          if (app.tablet.substring) {
            this.tabletModel = await this.loadAppByKey(app.tablet);
          } else {
            this.tabletModel = app.tablet;
          }
        }

        if (app.desktop) {
          if (app.desktop.substring) {
            this.desktoModel = await this.loadAppByKey(app.desktop);
          } else {
            this.desktoModel = app.desktop;
          }
        }

        this.onResize();
      } else {
        this.model = app;
      }

      this.initViewModel();
    },
    loadAppByKey: async function loadAppByKey(key) {
      Logger$1.log(3, 'QUX.loadAppByKey() > enter', key);
      var url = "".concat(this.server, "/rest/invitation/").concat(key, "/app.json");
      var start = new Date().getTime();
      var response = await fetch(url);

      if (response.status === 200) {
        var app = await response.json();
        Logger$1.log(-1, 'QUX.loadAppByKey() > exit', new Date().getTime() - start);
        return app;
      } else {
        this.msg = 'The debug id is wrong!';
      }
    },
    setScreen: function setScreen(screenName) {
      Logger$1.log(2, 'QUX.setScreen() > ', screenName); // Update url, which will trigger watcher, which will call setScreenByRouter() which will call loadScreen()

      var prefix = '';

      if (this.config && this.config.router && this.config.router.prefix) {
        prefix = this.config.router.prefix + '/';
      }

      var url = "#/".concat(prefix).concat(screenName, ".html");
      location.hash = url;
    },
    loadScreen: function loadScreen(name) {
      Logger$1.log(2, 'QUX.loadScreen() >', name);
      this.closeAllOverlays();

      if (this.model) {
        /**
         * FIXME: Use here tree model
         */
        var screen = Object.values(this.model.screens).find(function (s) {
          return s.name === name;
        });

        if (screen) {
          // make here somethink like: use router? and updat ethe url as well?
          this.selectedScreenId = screen.id;
          this.onScreenLoaded(screen);
        } else {
          Logger$1.warn('QUX.loadScreen() > No screen with name', name);
          var startScreen = this.getDefaultScreen();

          if (startScreen) {
            this.selectedScreenId = startScreen.id;
            this.onScreenLoaded(startScreen);
          } else {
            this.msg = "404 - No Screen with name ".concat(this.msg);
          }
        }
      } else {
        Logger$1.warn('QUX.loadScreen() > No Model');
      }
    },
    getDefaultScreen: function getDefaultScreen() {
      Logger$1.log(2, 'QUX.getDefaultScreen() > enter');
      var screen = this.treeModel.screens.find(function (screen) {
        return screen.props.start === true;
      });

      if (!screen) {
        screen = this.treeModel.screens[0];
      }

      return screen;
    },
    setStartScreen: function setStartScreen() {
      Logger$1.log(5, 'QUX.setStartScreen() > enter ');
      var startScreen = this.getDefaultScreen();

      if (startScreen) {
        this.selectedScreenId = startScreen.id;
        this.onScreenLoaded(startScreen);
      } else {
        this.selectedScreenId = null;
      }
    },
    setScreenByRouter: function setScreenByRouter() {
      Logger$1.log(5, 'QUX.setScreenByRoute() > enter ', this.$route);
      var key = 'screenName';

      if (this.config && this.config.router && this.config.router.key) {
        key = this.config.router.key;
      }

      var screenName = this.$route.params[key];

      if (screenName) {
        Logger$1.log(-1, 'QUX.setScreenByRoute() > exit ', screenName, "(".concat(key, ")"));
        this.loadScreen(screenName);
      } else {
        Logger$1.log(-1, 'QUX.setScreenByRoute() > exit > set start');
        this.setStartScreen();
      }
    },
    setConfig: function setConfig(c) {
      this.mergedConfig = Config$1.merge(this.mergedConfig, c);
      this.initCustomComponents(this.mergedConfig.components);
      Logger$1.setLogLevel(this.mergedConfig.debug.logLevel);
      Logger$1.log(5, 'QUX.setConfig()', JSON.stringify(this.mergedConfig));
    },
    initCustomComponents: function initCustomComponents(components) {
      Logger$1.log(1, 'QUX.initCustomComponents()');

      for (var key in components) {
        var c = components[key];
        Vue__default['default'].component(key, c);
      }
    },
    initComponents: function initComponents() {
      Vue__default['default'].component('qHotSpot', __vue_component__$1);
      Vue__default['default'].component('qButton', __vue_component__$1);
      Vue__default['default'].component('qBox', __vue_component__$1);
      Vue__default['default'].component('qLabel', __vue_component__$2);
      Vue__default['default'].component('qContainer', __vue_component__$5);
      Vue__default['default'].component('qIcon', __vue_component__$3);
      Vue__default['default'].component('qTextBox', __vue_component__$4);
      Vue__default['default'].component('qPassword', __vue_component__$4);
      Vue__default['default'].component('qTextArea', __vue_component__$g);
      Vue__default['default'].component('qRepeater', __vue_component__$6);
      Vue__default['default'].component('qImage', __vue_component__$7);
      Vue__default['default'].component('qCheckBox', __vue_component__$8);
      Vue__default['default'].component('qRadioBox', __vue_component__$a);
      Vue__default['default'].component('qRadioBox2', __vue_component__$a);
      Vue__default['default'].component('qRadioGroup', __vue_component__$b);
      Vue__default['default'].component('qCheckBoxGroup', __vue_component__$9);
      Vue__default['default'].component('qToggleButton', __vue_component__$c);
      Vue__default['default'].component('qSwitch', __vue_component__$d);
      Vue__default['default'].component('qDropDown', __vue_component__$f);
      Vue__default['default'].component('qMobileDropDown', __vue_component__$f);
      Vue__default['default'].component('qStepper', __vue_component__$h);
      Vue__default['default'].component('qHSlider', __vue_component__$i);
      Vue__default['default'].component('qDate', __vue_component__$j);
      Vue__default['default'].component('qDateDropDown', __vue_component__$k);
      Vue__default['default'].component('qSegmentButton', __vue_component__$l);
      Vue__default['default'].component('qRating', __vue_component__$m);
      Vue__default['default'].component('qIconToggle', __vue_component__$n);
      Vue__default['default'].component('qLabeledIconToggle', __vue_component__$n);
      Vue__default['default'].component('qTypeAheadTextBox', __vue_component__$o);
      Vue__default['default'].component('qTable', __vue_component__$p);
      Vue__default['default'].component('qPaging', __vue_component__$q);
      Vue__default['default'].component('qBarChart', __vue_component__$r);
      Vue__default['default'].component('qPieChart', __vue_component__$r);
      Vue__default['default'].component('qMultiRingChart', __vue_component__$r);
      Vue__default['default'].component('qRingChart', __vue_component__$r);
      Vue__default['default'].component('qVector', __vue_component__$s);
      Vue__default['default'].component('qTimeline', __vue_component__$t);
      Vue__default['default'].component('qUpload', __vue_component__$u);
      Vue__default['default'].component('qCamera', __vue_component__$v);
      Vue__default['default'].component('qChildrenToggle', __vue_component__$x);
      Vue__default['default'].component('qUploadPreview', __vue_component__$w);
    },
    initViewModel: function initViewModel() {
      var _this2 = this;

      Logger$1.log(5, 'QUX.initViewModel > enter');

      if (this.value && this.model) {
        /**
         * Fix screen names
         */
        Object.values(this.model.screens).forEach(function (screen) {
          screen.name = getFileName(screen.name);
        });
        /**
         * Add default databinding if needed. This might have consequences on
         * reactiveness. In general it is not advided to do this.
         */

        var dataBindings = Object.values(this.model.widgets).flatMap(function (widget) {
          if (widget.props && widget.props.databinding) {
            return Object.values(widget.props.databinding);
          }

          return [];
        });
        dataBindings.sort(function (a, b) {
          return a.localeCompare(b);
        });
        var value = this.mergedConfig.databinding.default;
        dataBindings.forEach(function (databinding) {
          /**
           * At some point we should have default values in the model...
           *
           * FIXME: This should be more intelligent and add arrays and so if needed
           */
          var has = JSONPath$1.has(_this2.value, databinding);

          if (!has) {
            Logger$1.log(4, 'QUX.initViewModel > Missing data in view model', databinding);
            JSONPath$1.set(_this2.value, databinding, value);
          }
        });
      }
    },
    initReziseListener: function initReziseListener() {
      window.addEventListener("resize", this.onResize);
    },
    onResize: function onResize() {
      var w = window.outerWidth;
      var conf = this.mergedConfig.responsive;

      if (w < conf.mobile.max && this.mobileModel) {
        Logger$1.log(2, 'QUX.onResize > exit mobile', w);
        this.model = this.mobileModel;
        return;
      }

      if (w < conf.tablet.max && this.tabletModel) {
        Logger$1.log(2, 'QUX.onResize > exit tablet', w);
        this.model = this.tabletModel;
        return;
      }

      if (this.desktoModel) {
        Logger$1.log(2, 'QUX.onResize > exit desktop', w);
        this.model = this.desktoModel;
        return;
      }

      this.initViewModel();
    },
    getMethodExcutor: function getMethodExcutor() {
      Logger$1.log(3, 'QUX.getMethodExcutor() > ');

      if (this.executor) {
        return this.executor;
      }

      return this.$parent;
    }
  },
  watch: {
    '$route': function $route() {
      Logger$1.log(3, 'QUX.watch(router) > enter');
      this.setScreenByRouter();
    },
    'screen': function screen(v) {
      Logger$1.log(3, 'QUX.watch(screen) > enter');
      this.setScreen(v);
    },
    'value': function value(v) {
      Logger$1.log(3, 'QUX.watch(value) > enter', v);
      this.value = v;
      this.initViewModel();
    },
    'app': function app(v) {
      Logger$1.log(3, 'QUX.watch(app) > enter', v);
      this.app = v;
      this.setApp(this.app);
    }
  },
  mounted: async function mounted() {
    Logger$1.log(0, 'QUX.mounted()', this.value);
    this.initComponents();

    if (this.config) {
      this.setConfig(this.config);
    }

    if (this.app) {
      await this.setApp(this.app);
    }

    if (this.debug) {
      console.warn('QUX > debug property is decrecated. Use "app" instead.');
      await this.loadAppByKey(this.debug);
    }

    if (!this.selected) {
      if (this.screen) {
        this.loadScreen(this.screen);
      } else {
        this.setScreenByRouter();
      }
    } else {
      Logger$1.log(-1, 'QUX.mounted() > Selected:', this.selected, this.app);
    }

    this.initReziseListener();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};

/* script */
var __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux', {
      'qux-component-screen': _vm.isComponentScreen
    }]
  }, [_vm.currentScreen ? _c('qContainer', {
    class: ['qux-screen', {
      'qux-screen-blurred': _vm.isBluredOverlay
    }],
    attrs: {
      "element": _vm.currentScreen,
      "model": _vm.model,
      "config": _vm.mergedConfig
    },
    on: {
      "qCallback": _vm.onCallback,
      "qClick": _vm.onClick,
      "qChange": _vm.onChange,
      "qKeyPress": _vm.onKeyPress,
      "qFocus": _vm.onFocus,
      "qBlur": _vm.onBlur,
      "qMouseOver": _vm.onMouseOver,
      "qMouseOut": _vm.onMouseOut
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }) : _c('div', [_vm._v("\n        " + _vm._s(_vm.msg) + "\n    ")]), _vm._v(" "), _vm.hasOverlay ? _c('div', {
    ref: "overlayWrapper",
    class: ['qux-overlay-wrapper', {
      'qux-overlay-wrapper-fixed': _vm.isFixedOverlay
    }],
    on: {
      "mousedown": _vm.popOverlay
    }
  }, [_vm.currentOverlay ? _c('qContainer', {
    ref: "overlayCntr",
    class: 'qux-screen',
    attrs: {
      "element": _vm.currentOverlay,
      "model": _vm.model,
      "config": _vm.mergedConfig
    },
    on: {
      "qCallback": _vm.onCallback,
      "qClick": _vm.onClick,
      "qChange": _vm.onChange,
      "qKeyPress": _vm.onKeyPress,
      "qFocus": _vm.onFocus,
      "qBlur": _vm.onBlur,
      "qMouseOver": _vm.onMouseOver,
      "qMouseOut": _vm.onMouseOut
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }) : _vm._e()], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$A = [];
/* style */

var __vue_inject_styles__$A = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-bbb8084c_0", {
    source: ".qux{background:0 0;height:100%}.qux.qux-component-screen{height:auto;display:inline-block}.qux-screen{display:flex;flex-direction:column;min-height:100%;background-size:100%}.qux-action{cursor:pointer}.qux-valign-middle{position:relative}.qux-valign-middle .qux-common-label{width:100%;position:absolute;top:50%;left:0;transform:translateY(-50%)}.qux-valign-bottom{position:relative}.qux-valign-bottom .qux-common-label{width:100%;position:absolute;bottom:0;left:0}.qux-overlay-wrapper{width:100%;height:100%;position:absolute;top:0;left:0;z-index:99999}.qux-overlay-wrapper.qux-overlay-wrapper-fixed{position:fixed}.qux-screen-blurred{filter:blur(10px)}.qux-resize-left::before{content:\"\";width:3px;background:orange}.qux-resize-right::after{content:\"\";width:3px;background:orange}.qux-common-no-select{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.qux-common-valign-center{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$A = undefined;
/* module identifier */

var __vue_module_identifier__$A = undefined;
/* functional template */

var __vue_is_functional_template__$A = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, createInjector, undefined, undefined);

var FigmaService = /*#__PURE__*/function () {
  function FigmaService(key) {
    _classCallCheck(this, FigmaService);

    this.setAccessKey(key);
    this.baseURL = 'https://api.figma.com/v1/';
    this.vectorTypes = ['LINE', 'ELLIPSE', 'VECTOR'];
    this.buttonTypes = ['RECTANGLE', 'TEXT', 'FRAME', 'GROUP', 'INSTANCE', 'COMPONENT', 'VARIANT_COMPONENT', 'COMPONENT_SET'];
    this.ignoredTypes = []; // ['GROUP', 'INSTANCE']

    this.allAsVecor = false;
    this.max_ids = 50;
    this.pluginId = '858477504263032980';
    this.downloadVectors = true;
    this.imageScaleFactor = 1;
    /**
     * TODO: update with config
     */

    this.varientComponentHoverKey = 'hover';
    this.varientComponentFocusKey = 'focus';
  }

  _createClass(FigmaService, [{
    key: "setImageScaleFactor",
    value: function setImageScaleFactor(factor) {
      this.imageScaleFactor = factor;
      return this;
    }
  }, {
    key: "setAccessKey",
    value: function setAccessKey(key) {
      this.key = key;
      return this;
    }
  }, {
    key: "setDownloadVectors",
    value: function setDownloadVectors(value) {
      this.downloadVectors = value;
      return this;
    }
  }, {
    key: "setBackgroundImages",
    value: function setBackgroundImages(app) {
      var _this = this;

      Logger$1.log('FigmaService.setBackgroundImages()');
      Object.values(app.screens).forEach(function (screen) {
        return _this.setBackgroundImage(screen);
      });
      Object.values(app.widgets).forEach(function (widget) {
        return _this.setBackgroundImage(widget);
      });
      return app;
    }
  }, {
    key: "setBackgroundImage",
    value: function setBackgroundImage(element) {
      if (element.props.figmaImage) {
        element.style.backgroundImage = {
          url: element.props.figmaImage
        };
      }
    }
  }, {
    key: "_createDefaultHeader",
    value: function _createDefaultHeader() {
      var headers = new Headers({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Figma-Token': this.key
      });
      return headers;
    }
  }, {
    key: "get",
    value: async function get(key) {
      var _this2 = this;

      var importChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var allAsVecor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var setVariantsAsHover = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      this.allAsVecor = allAsVecor;
      return new Promise(function (resolve, reject) {
        var url = _this2.baseURL + 'files/' + key + '?geometry=paths&plugin_data=' + _this2.pluginId;
        fetch(url, {
          method: 'get',
          credentials: "same-origin",
          headers: _this2._createDefaultHeader()
        }).then(function (resp) {
          resp.json().then(function (json) {
            try {
              var app = _this2.parse(key, json, importChildren, setVariantsAsHover);

              resolve(app);
            } catch (e) {
              Logger$1.error('FigmaService.get() > Error', e);
              resolve(null);
            }
          });
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "getImages",
    value: function getImages(key, ids) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        /**
         * Get in double resolution
         */
        var url = _this3.baseURL + 'images/' + key + "?format=png&scale=".concat(_this3.imageScaleFactor, "&ids=") + ids;
        fetch(url, {
          method: 'get',
          credentials: "same-origin",
          headers: _this3._createDefaultHeader()
        }).then(function (resp) {
          resp.json().then(function (json) {
            try {
              resolve(json);
            } catch (err) {
              Logger$1.error('FigmaService.getImages() > Error', err);
              reject(err);
            }
          });
        }, function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "parse",
    value: async function parse(id, fModel, importChildren) {
      var _this4 = this;

      Logger$1.log(3, 'FigmaService.parse() > enter importChildren:' + importChildren, fModel);
      var model = this.createApp(id, fModel);
      var fDoc = fModel.document;
      fModel._elementsById = {};

      if (fDoc.children) {
        fDoc.children.forEach(function (page) {
          if (page.children) {
            page.children.forEach(function (screen) {
              _this4.parseScreen(screen, model, fModel, importChildren);
            });
          }
        });
      }
      /**
       * Set hover styles and mark the elements as DesignLets
       */


      this.setVarientComponents(model, fModel);
      /**
       * Fix the lines that are until now with figma ids
       */

      this.setLineTos(model, fModel);
      /**
       * Get download images for all
       */

      await this.addBackgroundImages(id, model, importChildren);
      /**
       * TODO Add groups?
       */

      return model;
    }
    /**
     * Set for each instance the id to the parent. Why??
     */

  }, {
    key: "setVarientComponents",
    value: function setVarientComponents(qModel) {
      var _this5 = this;

      // console.debug('setInstanceComponents')

      /**
       * Mark all elements of a variant as a component for the
       * design lets
       */
      var varientComponents = {};
      Object.values(qModel.widgets).forEach(function (widget) {
        var parent = qModel.widgets[widget.parentId];

        if (parent && parent.figmaType === 'COMPONENT_SET') {
          widget.props.isComponet = true;
          widget.props.isVaraint = true;
          widget.variant = _this5.parseVariant(widget.name);

          if (!varientComponents[widget.parentId]) {
            varientComponents[widget.parentId] = [];
          }

          varientComponents[widget.parentId].push(widget);
          /**
           * Give a better na,e other wise css will fail
           */

          widget.name = parent.name + '-' + Object.values(widget.variant).join('-');
        }
      });
      /**
       * 1) get all varient_components
       *
       * 2) check if they have a hover style
       *
       * 3) Set the .hover for all styles with the same config for the other props
       */

      Object.values(varientComponents).forEach(function (children) {
        // console.debug('varient', children)

        /**
         * Make this smarter in and check for a plugin flag
         */
        var hoverChildren = children.filter(function (c) {
          return c.name.toLowerCase().indexOf('=' + _this5.varientComponentHoverKey) > 0;
        });

        if (hoverChildren.length === 1) {
          var hoverChild = hoverChildren[0];
          /**
           * lets find out which key actually mactched hover.
           *
           * TODO: what if the pluginFlag was used?
           */

          var others = _this5.getOtherVarants(children, hoverChild, _this5.varientComponentHoverKey);

          console.debug(hoverChild.name, others);
        }
      });
      /**
       * 4) Go through all widget,s check if we have a component with the hover, and copy the hover over.
       */
    }
  }, {
    key: "getOtherVarants",
    value: function getOtherVarants(children, selected, valueToIgnore) {
      var variantToMatch = Object.entries(selected.variant).filter(function (e) {
        var value = e[1];

        if (value && value.toLowerCase) {
          value = value.toLowerCase();
        }

        return value !== valueToIgnore;
      });
      console.debug(variantToMatch);
    }
  }, {
    key: "parseVariant",
    value: function parseVariant(str) {
      var result = {};
      str.split(',').map(function (s) {
        return s.split('=');
      }).forEach(function (pair) {
        return result[pair[0].trim()] = pair[1].trim();
      });
      return result;
    }
  }, {
    key: "getParentVarientComponent",
    value: function getParentVarientComponent(widget, widgetsByFigmaID, qModel) {
      var parent = widgetsByFigmaID[widget.figmaComponentId];
      console.debug('...', parent ? parent.id + ' ' + parent.parentId : 'X');

      while (parent && parent.figmaType !== 'VARIANT_COMPONENT') {
        parent = qModel.widgets[parent.parentId];
      }

      return parent;
    }
  }, {
    key: "setLineTos",
    value: function setLineTos(model) {
      var widgetMapping = {};
      Object.values(model.widgets).forEach(function (w) {
        widgetMapping[w.figmaId] = w.id;
      });
      var screenMapping = {};
      Object.values(model.screens).forEach(function (s) {
        screenMapping[s.figmaId] = s.id;
      });
      Object.values(model.lines).forEach(function (line) {
        line.from = widgetMapping[line.figmaFrom];
        line.to = screenMapping[line.figmaTo];
      });
    }
  }, {
    key: "addBackgroundImages",
    value: async function addBackgroundImages(id, model, importChildren) {
      var _this6 = this;

      if (this.downloadVectors) {
        var vectorWidgets = this.getElementsWithBackgroundIMage(model, importChildren);

        if (vectorWidgets.length > 0) {
          Logger$1.log(-1, 'FigmaService.addBackgroundImages() > vectors', vectorWidgets.length);
          var batches = this.getChunks(vectorWidgets, this.max_ids);
          var promisses = batches.map(function (batch, i) {
            return _this6.addBackgroundImagesBatch(id, batch, i);
          });
          await Promise.all(promisses);
        }
      } else {
        Logger$1.log(3, 'FigmaService.addBackgroundImages() > Skip');
      }

      Logger$1.log(3, 'FigmaService.addBackgroundImages() > exit');
    }
  }, {
    key: "getElementsWithBackgroundIMage",
    value: function getElementsWithBackgroundIMage(model, importChildren) {
      if (importChildren) {
        return Object.values(model.widgets).filter(function (widget) {
          return widget.props.isVector || widget.hasBackgroundImage;
        });
      } else {
        return Object.values(model.screens);
      }
    }
  }, {
    key: "addBackgroundImagesBatch",
    value: async function addBackgroundImagesBatch(id, batch, i) {
      var _this7 = this;

      Logger$1.log(3, 'FigmaService.addBackgroundImagesBatch() > start', i);
      return new Promise(function (resolve, reject) {
        var vectorWidgetIds = batch.map(function (w) {
          return w.figmaId;
        }).join(',');

        _this7.getImages(id, vectorWidgetIds).then(function (imageResponse) {
          if (imageResponse.err === null) {
            Logger$1.log(3, 'FigmaService.addBackgroundImagesBatch () > end', i);
            var images = imageResponse.images;
            batch.forEach(function (w) {
              var image = images[w.figmaId];

              if (image) {
                w.props.figmaImage = image;
              }

              resolve(batch);
            });
          } else {
            Logger$1.error('FigmaService.addBackgroundImagesBatch () > Could not get images', imageResponse);
            reject(imageResponse.err);
          }
        }, function (err) {
          Logger$1.error('FigmaService.addBackgroundImagesBatch() > Could not get images', err);
          reject(err);
        });
      });
    }
  }, {
    key: "getChunks",
    value: function getChunks(array, size) {
      var result = [];

      for (var i = 0; i < array.length; i += size) {
        var chunk = array.slice(i, i + size);
        result.push(chunk);
      }

      return result;
    }
  }, {
    key: "parseScreen",
    value: function parseScreen(fScreen, model, fModel) {
      var _this8 = this;

      Logger$1.log(3, 'FigmaService.parseScreen()', fScreen.name);
      var pos = this.getPosition(fScreen);
      var qScreen = {
        id: 's' + this.getUUID(model),
        figmaId: fScreen.id,
        name: fScreen.name,
        type: 'Screen',
        x: pos.x,
        y: pos.y,
        w: pos.w,
        h: pos.h,
        props: {},
        children: [],
        style: this.getStyle(fScreen)
      };
      this.getPluginData(fScreen, qScreen, fModel);

      if (fScreen.children) {
        fScreen.children.forEach(function (child) {
          child._parent = fScreen;

          _this8.parseElement(child, qScreen, fScreen, model, fModel, qScreen.id);
        });
      }
      /**
       * Or check prototypeDevice
       */


      model.screenSize.w = model.screenSize.w === -1 ? pos.w : Math.max(model.screenSize.w, pos.w);
      model.screenSize.h = model.screenSize.h === -1 ? pos.h : Math.max(model.screenSize.h, pos.h);
      model.screens[qScreen.id] = qScreen;
      Logger$1.log(4, 'FigmaService.parseScreen() exit ', fScreen.name, qScreen.id);
      return qScreen;
    }
  }, {
    key: "parseElement",
    value: function parseElement(element, qScreen, fScreen, model, fModel, qParentId) {
      var _this9 = this;

      Logger$1.log(5, 'FigmaService.parseElement() > enter: ' + element.name, element.type);
      var widget = null;

      if (!this.isIgnored(element) && !this.isInsisible(element)) {
        var pos = this.getPosition(element);
        widget = {
          id: 'w' + this.getUUID(model),
          parentId: qParentId,
          name: this.getFigmaName(element),
          type: this.getType(element),
          figmaId: element.id,
          figmaType: element.type,
          figmaComponentId: this.getFigmaComponentId(element),
          x: pos.x,
          y: pos.y,
          w: pos.w,
          h: pos.h,
          z: this.getZ(element, model)
        };
        widget.style = this.getStyle(element, widget);
        widget.props = this.getProps(element, widget);
        widget.has = this.getHas(element, widget);
        widget = this.getPluginData(element, widget, fModel);
        fModel._elementsById[element.id] = element;
        model.widgets[widget.id] = widget;
        qScreen.children.push(widget.id);
        /**
         * Update the parent id, so we can have the correct hierachy
         */

        qParentId = widget.id;
      } else {
        Logger$1.log(4, 'FigmaService.parseElement() >Ignore: ' + element.name, element.type);
        /**
         * What if we have defined the callbacks and on a compomemt?
         */
      }
      /**
       * Go down recursive...
       */


      if (element.children) {
        /**
         * We do not go down on vector elemenets
         */
        if (!this.isVector(element)) {
          element.children.forEach(function (child) {
            if (child.visible !== false) {
              child._parent = element;
              Logger$1.log(3, 'FigmaService.parseElement() > go recursive', element);

              _this9.parseElement(child, qScreen, fScreen, model, fModel, qParentId);
            }
          });
        } else {
          Logger$1.log(6, 'FigmaService.parseElement() > No recursive: ' + element.name, element.type);
        }
      }

      this.addTempLine(element, model);
      return widget;
    }
  }, {
    key: "getFigmaComponentId",
    value: function getFigmaComponentId(fElement) {
      if (fElement.type === 'INSTANCE') {
        return fElement.componentId;
      }

      if (fElement.id.indexOf('I') === 0) {
        var parts = fElement.id.split(';');

        if (parts.length === 2) {
          return parts[1];
        }
      }
    }
  }, {
    key: "getFigmaName",
    value: function getFigmaName(element) {
      /**
       * FIXME: Check if teh name is tool long or has spaces or shit...
       */
      var name = element.name;
      return name.replace('#', '').replace('/', '-').replace('&', '');
    }
  }, {
    key: "addTempLine",
    value: function addTempLine(element, model) {
      Logger$1.log(4, 'FigmaService.addLine() > enter', element.name, 'transition :' + element.transitionNodeID, element);

      if (element.transitionNodeID) {
        var clickChild = this.getFirstNoIgnoredChild(element);
        Logger$1.log(6, 'addLine() >  : ', element.name, clickChild);
        var line = {
          id: 'l' + this.getUUID(model),
          from: null,
          to: null,
          figmaFrom: clickChild.id,
          figmaTo: element.transitionNodeID,
          points: [],
          event: "click",
          animation: "",
          duration: element.transitionDuration
        };
        model.lines[line.id] = line;
      }
    }
  }, {
    key: "getFirstNoIgnoredChild",
    value: function getFirstNoIgnoredChild(element) {
      /**
       * We do not render instance wrappers, so we take the first child.
       */
      if (this.isIgnored(element) && element.children.length > 0) {
        Logger$1.log(5, 'FigmaService.getFirstNoIgnoredChild() >  take child ', element.name);
        return this.getFirstNoIgnoredChild(element.children[0]);
      }

      return element;
    }
  }, {
    key: "getPluginData",
    value: function getPluginData(element, widget) {
      if (element.pluginData && element.pluginData[this.pluginId]) {
        var pluginData = element.pluginData[this.pluginId];

        if (pluginData.quxType) {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxType : ', pluginData.quxType, element.name);
          widget.type = pluginData.quxType;
          widget.props.placeholder = true;
          /**
           * SmartContainer has a subType
           */

          if (pluginData.quxType === 'SmartContainer' && pluginData.quxSmartContainerType) {
            Logger$1.log(2, 'FigmaService.getPluginData() > quxSmartContainerType : ', pluginData.quxSmartContainerType, element.name);
            widget.type = pluginData.quxSmartContainerType;
            widget.smartContainerType = pluginData.quxSmartContainerType;
          }
        }

        if (pluginData.quxTypeCustom) {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxTypeCustom: ', pluginData.quxOnChangeCallback, element.name);
          widget.props.customComponent = pluginData.quxTypeCustom;
        }

        if (pluginData.quxDataBindingDefault) {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxDataBindingDefault : ', pluginData.quxDataBindingDefault, element.name);

          if (!widget.props.databinding) {
            widget.props.databinding = {};
          }

          widget.props.databinding['default'] = pluginData.quxDataBindingDefault;
        }

        if (pluginData.quxDataBindingOutput) {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxDataBindingOutput : ', pluginData.quxDataBindingOutput, element.name);

          if (!widget.props.databinding) {
            widget.props.databinding = {};
          }

          widget.props.databinding['output'] = pluginData.quxDataBindingOutput;
        }

        if (pluginData.quxOnClickCallback) {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxOnClickCallback: ', pluginData.quxOnClickCallback, element.name);

          if (!widget.props.callbacks) {
            widget.props.callbacks = {};
          }

          widget.props.callbacks.click = pluginData.quxOnClickCallback;
        }

        if (pluginData.quxOnLoadCallback) {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxOnLoadCallback: ', pluginData.quxOnLoadCallback, element.name);

          if (!widget.props.callbacks) {
            widget.props.callbacks = {};
          }

          widget.props.callbacks.load = pluginData.quxOnLoadCallback;
        }

        if (pluginData.quxOnChangeCallback) {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxOnChangeCallback: ', pluginData.quxOnChangeCallback, element.name);

          if (!widget.props.callbacks) {
            widget.props.callbacks = {};
          }

          widget.props.callbacks.change = pluginData.quxOnChangeCallback;
        }
        /**
         * Hover
         */


        if (pluginData.quxStyleHoverBackground) {
          this.addDynamicStyle(widget, 'hover', 'background', pluginData.quxStyleHoverBackground);
        }

        if (pluginData.quxStyleHoverBorder) {
          this.addDynamicStyle(widget, 'hover', 'borderColor', pluginData.quxStyleHoverBorder);
        }

        if (pluginData.quxStyleHoverColor) {
          this.addDynamicStyle(widget, 'hover', 'color', pluginData.quxStyleHoverColor);
        }
        /**
         * Focus
         */


        if (pluginData.quxStyleFocusBackground) {
          this.addDynamicStyle(widget, 'focus', 'background', pluginData.quxStyleFocusBackground);
        }

        if (pluginData.quxStyleFocusBorder) {
          this.addDynamicStyle(widget, 'focus', 'borderColor', pluginData.quxStyleFocusBorder);
        }

        if (pluginData.quxStyleFocusColor) {
          this.addDynamicStyle(widget, 'focus', 'color', pluginData.quxStyleFocusColor);
        }
        /**
         * Style stuff
         */


        if (pluginData.quxFixedHorizontal === 'true') {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxFixedHorizontal: ', pluginData.quxFixedHorizontal, element.name);

          if (!widget.props.resize) {
            widget.props.resize = {};
          }

          widget.props.resize.fixedHorizontal = true;
        }

        if (pluginData.quxFixedVertical === 'true') {
          Logger$1.log(3, 'FigmaService.getPluginData() > quxFixedVertical: ', pluginData.quxFixedVertical, element.name);

          if (!widget.props.resize) {
            widget.props.resize = {};
          }

          widget.props.resize.fixedVertical = true;
        }
        /**
         * Screen stuff
         */


        if (pluginData.quxStartScreen === 'true') {
          Logger$1.log(1, 'FigmaService.getPluginData() > quxStartScreen: ', pluginData.quxStartScreen, element.name);
          widget.props.start = true;
        }

        if (pluginData.quxOverlayScreen === 'true') {
          Logger$1.log(4, 'FigmaService.getPluginData() > quxOverlayScreen: ', pluginData.quxOverlayScreen, element.name);
          widget.style.overlay = true;
        }

        if (pluginData.quxHasOverlayBackground === 'true') {
          Logger$1.log(4, 'FigmaService.getPluginData() > quxHasOverlayBackground: ', pluginData.quxHasOverlayBackground, element.name);
          widget.style.hasBackground = true;
        }
        /**
         * Breakpoints
         */


        if (pluginData.quxBreakpointMobile === 'true') {
          if (!widget.props.breakpoints) {
            widget.props.breakpoints = {};
          }

          Logger$1.log(4, 'FigmaService.getPluginData() > quxBreakpointMobile: ', pluginData.quxBreakpointMobile, element.name);
          widget.props.breakpoints.mobile = true;
        }

        if (pluginData.quxBreakpointTablet === 'true') {
          if (!widget.props.breakpoints) {
            widget.props.breakpoints = {};
          }

          Logger$1.log(4, 'FigmaService.getPluginData() > quxBreakpointTablet: ', pluginData.quxBreakpointTablet, element.name);
          widget.props.breakpoints.tablet = true;
        }

        if (pluginData.quxBreakpointDesktop === 'true') {
          if (!widget.props.breakpoints) {
            widget.props.breakpoints = {};
          }

          Logger$1.log(4, 'FigmaService.getPluginData() > quxBreakpointDesktop: ', pluginData.quxBreakpointDesktop, element.name);
          widget.props.breakpoints.desktop = true;
        }

        if (pluginData.quxStyleDisplay) {
          Logger$1.log(4, 'FigmaService.getPluginData() > quxStyleDisplay: ', pluginData.quxStyleDisplay, element.name);
          widget.style.display = pluginData.quxStyleDisplay;
        }

        if (pluginData.quxStyleCursor) {
          Logger$1.log(4, 'FigmaService.getPluginData() > quxStyleCursor: ', pluginData.quxStyleCursor, element.name);
          widget.style.cursor = pluginData.quxStyleCursor;
        }

        if (pluginData.quxStyleMaxWidth) {
          Logger$1.log(4, 'FigmaService.getPluginData() > quxStyleMaxWidth: ', pluginData.quxStyleMaxWidth, element.name);
          widget.style.maxWidth = pluginData.quxStyleMaxWidth;
        }

        if (pluginData.quxStyleMinWidth) {
          Logger$1.log(4, 'FigmaService.getPluginData() > quxStyleMinWidth: ', pluginData.quxStyleMinWidth, element.name);
          widget.style.minWidth = pluginData.quxStyleMinWidth;
        }
        /**
         * FIXME
            quxChildLayout: '',
         */

      }

      return widget;
    }
  }, {
    key: "addDynamicStyle",
    value: function addDynamicStyle(widget, type, key, value) {
      if (!widget[type]) {
        widget[type] = {};
      }

      widget[type][key] = value;
    }
  }, {
    key: "getProps",
    value: function getProps(element, widget) {
      var props = {};

      if (this.isVector(element)) {
        //console.debug('FigmaService.getProps() > make vector', element)
        props.paths = element.strokeGeometry;
        props.relativeTransform = element.relativeTransform;
        props.isVector = true;
      }

      if (widget.type === 'Label') {
        if (element.characters) {
          props.label = element.characters;
        } else {
          props.label = element.name;
        }
      }
      /**
       * Add here constraints
       */


      props.resize = {
        right: true,
        left: true,
        up: false,
        down: false,
        fixedHorizontal: false,
        fixedVertical: false
      };
      /**
       * FIXME: Should come only after plugin data...
       */

      this.setContraints(element, props);
      return props;
    }
  }, {
    key: "setContraints",
    value: function setContraints(element, props) {
      if (element.constraints) {
        var horizontal = element.constraints.horizontal;

        switch (horizontal) {
          case 'RIGHT':
            props.resize.left = false;
            props.resize.right = true;
            break;
        }
      }
    }
  }, {
    key: "isIgnored",
    value: function isIgnored(element) {
      // FIXME: check for empty frames
      return this.ignoredTypes.indexOf(element.type) >= 0;
    }
  }, {
    key: "isInsisible",
    value: function isInsisible(element) {
      if (element.visible === false) {
        Logger$1.log(5, 'FigmaService.isInsisible() > exit (visible): ' + element.name, element.type);
        return true;
      }

      if (element.opacity <= 0) {
        Logger$1.log(5, 'FigmaService.isInsisible() > exit (opacity): ' + element.name, element.type);
        return true;
      }

      return false;
    }
  }, {
    key: "isVector",
    value: function isVector(element) {
      return this.allAsVecor || !this.isButton(element);
    }
  }, {
    key: "isLabel",
    value: function isLabel(widget) {
      return widget && widget.type === 'Label';
    }
    /**
     * We map to a button / box iff it is not rectangle kind of
     * element (as defined in buttonTypes) and the style is not too
     * complex
     */

  }, {
    key: "isButton",
    value: function isButton(element) {
      if (this.buttonTypes.indexOf(element.type) >= 0) {
        return !this.isTooComplexStyle(element);
      }

      return false;
    }
  }, {
    key: "isVariantContainer",
    value: function isVariantContainer(fElement) {
      return fElement.type === 'VARIANT_COMPONENT';
    }
  }, {
    key: "isTooComplexStyle",
    value: function isTooComplexStyle(element) {
      if (element.fills && element.fills.length > 1) {
        return true;
      }

      if (element.fills && element.fills.length === 1) {
        /**
         * FIXME: Some times elements have iamge fills. They should be containers,
         * but for now there is a weird layout bug
         */
        var fill = element.fills[0];
        return fill.type !== 'SOLID' && fill.type !== 'GRADIENT_LINEAR' && fill.type !== 'GRADIENT_RADIAL'; // && fill.type !== 'IMAGE'
      }

      if (element.effects && element.effects.length > 1) {
        return true;
      }

      if (element.strokes && element.strokes.length > 1) {
        return true;
      }

      return false;
    }
  }, {
    key: "getHas",
    value: function getHas(element, widget) {
      if (widget.type === 'Label') {
        return {
          label: true,
          padding: true,
          advancedText: true
        };
      }

      if (widget.type === 'Button') {
        return {
          label: true,
          backgroundColor: true,
          border: true,
          onclick: true,
          padding: true
        };
      }

      return {};
    }
  }, {
    key: "getStyle",
    value: function getStyle(element, widget) {
      var _this10 = this;

      var style = {
        fontFamily: 'Helvetica Neue,Helvetica,Arial,sans-serif',
        borderBottomWidth: 0,
        borderTopWidth: 0,
        borderLeftWidth: 0,
        borderRightWidth: 0
      };
      /**
       * How is this rendered. Which has priority
       */

      if (element.backgroundColor) {
        style.backgroundColor = this.getColor(element.backgroundColor, element);
      }

      if (element.isFixed) {
        style.fixed = true;
        this.setAllChildrenFixed(element);
      }

      if (element.fills) {
        if (element.fills.length === 1) {
          var fill = element.fills[0];

          if (fill.type === 'SOLID') {
            if (this.isLabel(widget)) {
              style.color = this.getColor(fill.color, fill);
            } else {
              style.backgroundColor = this.getColor(fill.color, fill);
            }
          }

          if (fill.type === 'GRADIENT_LINEAR') {
            if (!this.isLabel(widget)) {
              style.background = this.getLinearGradient(fill);
            } else {
              Logger$1.log(1, 'getStyle() > gradients not supported fotr labels...');
            }
          }

          if (fill.type === 'GRADIENT_RADIAL') {
            if (!this.isLabel(widget)) {
              style.background = this.getRadialGradient(fill);
            } else {
              Logger$1.log(1, 'getStyle() > gradients not supported for labels...');
            }
          }

          if (fill.type === 'IMAGE') ;
        }
      }

      if (element.cornerRadius) {
        style.borderBottomLeftRadius = element.cornerRadius;
        style.borderTopLeftRadius = element.cornerRadius;
        style.borderBottomRightRadius = element.cornerRadius;
        style.borderTopRightRadius = element.cornerRadius;
      }

      if (element.rectangleCornerRadii) {
        style.borderTopLeftRadius = element.rectangleCornerRadii[0];
        style.borderTopRightRadius = element.rectangleCornerRadii[1];
        style.borderBottomRightRadius = element.rectangleCornerRadii[2];
        style.borderBottomLeftRadius = element.rectangleCornerRadii[3];
      }
      /**
       * The border stuff we just do for rects and text
       */


      if (!this.isVector(element)) {
        if (element.strokes && element.strokes.length > 0) {
          var stroke = element.strokes[0];
          style.borderBottomColor = this.getColor(stroke.color, element);
          style.borderTopColor = this.getColor(stroke.color, element);
          style.borderLeftColor = this.getColor(stroke.color, element);
          style.borderRightColor = this.getColor(stroke.color, element);

          if (element.strokeWeight) {
            style.borderBottomWidth = element.strokeWeight;
            style.borderTopWidth = element.strokeWeight;
            style.borderLeftWidth = element.strokeWeight;
            style.borderRightWidth = element.strokeWeight;
          }

          if (element.strokeAlign !== 'INSIDE' && element.strokeWeight) {
            widget.x -= element.strokeWeight;
            widget.w += element.strokeWeight * 2;
            widget.y -= element.strokeWeight;
            widget.h += element.strokeWeight * 2;
          }
        }

        if (element.effects) {
          element.effects.forEach(function (effect) {
            if (effect.type === 'DROP_SHADOW') {
              style.boxShadow = {
                v: effect.offset.y,
                h: effect.offset.x,
                b: effect.radius,
                s: 0,
                i: false,
                c: _this10.getColor(effect.color, element)
              };
            }

            if (effect.type === 'INNER_SHADOW') {
              style.boxShadow = {
                v: effect.offset.y,
                h: effect.offset.x,
                b: effect.radius,
                s: 0,
                i: true,
                c: _this10.getColor(effect.color, element)
              };
            }
          });
        }

        if (element.style) {
          var fStyle = element.style;
          style.fontSize = fStyle.fontSize;
          style.fontSize = fStyle.fontSize;
          style.fontWeight = fStyle.fontWeight;
          style.lineHeight = fStyle.lineHeightPercent / 100; // this has a different weird formular! https://help.figma.com/text/line-height

          style.letterSpacing = fStyle.letterSpacing;

          if (fStyle.textAlignHorizontal) {
            style.textAlign = fStyle.textAlignHorizontal.toLowerCase();
          }

          if (fStyle.textAlignVertical) {
            var textAlignVertical = fStyle.textAlignVertical;

            switch (textAlignVertical) {
              case 'CENTER':
                style.verticalAlign = 'middle';
                break;

              case 'TOP':
                style.verticalAlign = 'top';
                break;

              case 'BOTTOM':
                style.verticalAlign = 'bottom';
                break;
            }
          }
        }
      }
      /**
       * Labels with constraints can be vertical middle
       */


      if (this.isLabel(widget) && style.verticalAlign !== 'bottom') {
        if (element.constraints) {
          var constraints = element.constraints;

          if (constraints.vertical === 'TOP_BOTTOM') {
            style.verticalAlign = 'middle';
          }
        }
      }

      return style;
    }
  }, {
    key: "setAllChildrenFixed",
    value: function setAllChildrenFixed(element) {
      var _this11 = this;

      if (element.children) {
        element.children.forEach(function (c) {
          c.isFixed = true;

          _this11.setAllChildrenFixed(c);
        });
      }
    }
  }, {
    key: "getType",
    value: function getType(element) {
      if (this.isVector(element)) {
        return 'Vector';
      }

      if (element.type === 'TEXT') {
        return 'Label';
      }

      return 'Button';
    }
  }, {
    key: "getLinearGradient",
    value: function getLinearGradient(fill) {
      var _this12 = this;

      Logger$1.log(3, 'getLinearGradient() > enter', fill);
      var start = fill.gradientHandlePositions[0];
      var end = fill.gradientHandlePositions[1];
      var xDiff = start.x - end.x;
      var yDiff = start.y - end.y;
      var dir = Math.round(Math.atan2(yDiff, xDiff) * 180 / Math.PI + 270) % 360;
      var gradientStops = fill.gradientStops;
      var colors = gradientStops.map(function (stop) {
        return {
          c: _this12.getColor(stop.color),
          p: stop.position * 100
        };
      });
      return {
        direction: dir,
        colors: colors
      };
    }
  }, {
    key: "getRadialGradient",
    value: function getRadialGradient(fill) {
      var _this13 = this;

      Logger$1.log(3, 'getLinearGradient() > enter', fill);
      var gradientStops = fill.gradientStops;
      var colors = gradientStops.map(function (stop) {
        return {
          c: _this13.getColor(stop.color),
          p: stop.position * 100
        };
      });
      return {
        radial: true,
        colors: colors
      };
    }
  }, {
    key: "calculateAngle",
    value: function calculateAngle(startHandle, endHandle) {
      var radians = Math.atan(this.calculateGradient(startHandle, endHandle));
      return parseInt(this.radToDeg(radians).toFixed(1));
    }
  }, {
    key: "calculateGradient",
    value: function calculateGradient(startHandle, endHandle) {
      return (endHandle.y - startHandle.y) / (endHandle.x - startHandle.x) * -1;
    }
  }, {
    key: "radToDeg",
    value: function radToDeg(radian) {
      return 180 * radian / Math.PI;
    }
  }, {
    key: "getColor",
    value: function getColor(c, element) {
      if (element && element.visible === false) {
        return '';
      }

      var a = c.a;

      if (element && element.opacity < 1) {
        a = element.opacity;
      }

      return "rgba(".concat(Math.round(c.r * 255), ", ").concat(Math.round(c.g * 255), ", ").concat(Math.round(c.b * 255), ", ").concat(a, ")");
    }
  }, {
    key: "getPosition",
    value: function getPosition(element) {
      if (element.absoluteBoundingBox) {
        var pos = {
          x: Math.round(element.absoluteBoundingBox.x),
          y: Math.round(element.absoluteBoundingBox.y),
          w: Math.round(element.absoluteBoundingBox.width),
          h: Math.round(element.absoluteBoundingBox.height)
        };
        /**
         * We can ignore transformMatrix because absolutePositon gives the right values
         */

        return pos;
      }

      Logger$1.warn('FigmaService.getPosition() > No abs pos', element);
      return {};
    }
  }, {
    key: "getTransformParent",
    value: function getTransformParent(element) {
      if (element._parent) {
        if (element._parent.type === 'FRAME') {
          return element._parent;
        }
      }

      return;
    }
  }, {
    key: "getZ",
    value: function getZ(element, model) {
      model.lastZ++;
      return model.lastZ;
    }
  }, {
    key: "createApp",
    value: function createApp(id, data) {
      return {
        version: 2.1,
        figmaId: id,
        name: data.name,
        description: '',
        screenSize: {
          "w": -1,
          "h": -1
        },
        type: 'smartphone',
        screens: {},
        widgets: {},
        lines: {},
        groups: {},
        lastUUID: 10000,
        lastZ: 1,
        lastUpdate: 0,
        created: 0,
        startScreen: "",
        grid: {
          w: 8,
          h: 8,
          style: "line",
          color: "#cecece",
          visible: false,
          enabled: false
        }
      };
    }
  }, {
    key: "getUUID",
    value: function getUUID(model) {
      var uuid = model.lastUUID++ + "";
      return uuid;
    }
  }]);

  return FigmaService;
}();

//
var script$B = {
  name: 'Figma',
  mixins: [],
  props: {
    'figma': {},
    'screen': {
      type: String
    },
    'debug': {
      type: String
    },
    'selected': {
      type: String
    },
    'executor': {
      type: Object
    },
    'value': {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    'config': {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      app: null,
      mergedConfig: {
        figma: {
          varientComponentHoverKey: 'Mouse=Hover',
          varientComponentDefaultKey: 'Mouse=Default'
        },
        css: {
          grid: true,
          justifyContentInWrapper: false,
          pinnedLeft: false,
          pinnedRight: false,
          fixedHorizontal: false,
          attachLabels: false
        }
      }
    };
  },
  computed: {},
  components: {
    'QUX': __vue_component__$A
  },
  methods: {
    setFigma: async function setFigma(figma) {
      Logger$1.log(-1, 'Figma.setFigma()');

      if (figma.figmaFile && figma.figmaAccessKey) {
        var figmaService = new FigmaService(figma.figmaAccessKey, this.mergedConfig);
        var app = await figmaService.get(figma.figmaFile, true);
        app = figmaService.setBackgroundImages(app);
        this.app = app;
      } else if (figma.screens && figma.widgets) {
        this.app = figma;
      }
    },

    /**
     * Keep in sync with QUX
     */
    setConfig: function setConfig(c) {
      if (c.css) {
        this.mergedConfig.css = mixin(this.mergedConfig.css, c.css);
      }

      if (c.router) {
        this.mergedConfig.router = mixin(this.mergedConfig.router, c.router);
      }

      if (c.databinding) {
        this.mergedConfig.databinding = mixin(this.mergedConfig.databinding, c.databinding);
      }

      if (c.components) {
        this.mergedConfig.components = c.components;
      }

      if (c.imageFolder) {
        this.mergedConfig.imageFolder = c.imageFolder;
      }

      if (c.debug) {
        this.mergedConfig.debug = mixin(this.mergedConfig.debug, c.debug);
      }

      if (c.figma) {
        this.mergedConfig.figma = mixin(this.mergedConfig.figma, c.figma);
      }

      Logger$1.log(3, 'Figma.setConfig()', JSON.stringify(this.mergedConfig));
    },
    getMethodExcutor: function getMethodExcutor() {
      Logger$1.log(3, 'Figma.getMethodExcutor() > ');

      if (this.executor) {
        return this.executor;
      }

      return this.$parent;
    }
  },
  mounted: function mounted() {
    if (this.config) {
      this.setConfig(this.config);
    }

    if (this.figma) {
      this.setFigma(this.figma);
    }
  }
};

/* script */
var __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "qux-figma"
  }, [_vm.app ? _c('QUX', {
    ref: "qux",
    attrs: {
      "app": _vm.app,
      "config": _vm.mergedConfig,
      "showDebug": true,
      "executor": _vm.getMethodExcutor(),
      "selected": _vm.selected,
      "screen": _vm.screen
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$B = [];
/* style */

var __vue_inject_styles__$B = undefined;
/* scoped */

var __vue_scope_id__$B = undefined;
/* module identifier */

var __vue_module_identifier__$B = undefined;
/* functional template */

var __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

//
var script$C = {
  name: 'qComponentSet',
  mixins: [__vue_component__],
  data: function data() {
    return {
      checked: false,
      qErrorMessage: 'No varient matching!',
      debug: false
    };
  },
  computed: {
    isActive: function isActive() {
      if (this.isDesignSystemRoot) {
        /**
         * If no v-model is passed, we take the checked
         */
        if (this.value === undefined) {
          return this.checked;
        }

        return this.value;
      }

      if (this.element) {
        var input = this.dataBindingInput;
        return input === true;
      }

      return this.checked;
    },
    selectedChild: function selectedChild() {
      if (this.element && this.$parent) {
        var matches = this.getMatchesByVarient();
        Logger$1.log(2, 'qComponentSet.selectedChild() ', matches);

        if (isChildrenToggle(this.element) && this.element.children.length > 1) {
          if (matches.length == 2) {
            /**
             * FIXME: Herre the order matters!
             */
            if (this.isActive) {
              return matches[1];
            } else {
              return matches[0];
            }
          } else {
            Logger$1.error('qComponentSet.selectedChild() > More than 2 matches for toggle', matches);
          }
        } else {
          if (matches.length === 1) {
            return matches[0];
          } else {
            Logger$1.error('qComponentSet.selectedChild() > More than 1 macthes', matches);
          }
        }
      }

      return null;
    },
    justifyContent: function justifyContent() {
      if (isWrappedContainer(this.element) && this.config.css.justifyContentInWrapper) {
        return true;
      }

      return false;
    },
    wrapperPlaceHolders: function wrapperPlaceHolders() {
      return [1, 2, 3, 4, 5, 6, 7, 8];
    }
  },
  methods: {
    toggle: function toggle(e) {
      if (this.element) {
        var value = !this.isActive;
        this.onValueChange(value, 'default');
        Logger$1.log(4, 'qComponentSet.toggle(element) > ' + this.dataBindingInputPath, value);
        this.checked = value;
      } else {
        this.checked = !this.checked;
        this.$emit('change', this.checked);
        this.$emit('input', this.checked);
        Logger$1.log(5, 'qComponentSet.toggle() >' + this.checked);
      }
      /**
       * Also fire onClick
       */


      this.onClick(e);
    },
    getMatchesByVarient: function getMatchesByVarient() {
      var _this = this;

      var variantKeys = this.getPresentPropertyKeys();
      Logger$1.log(4, 'qComponentSet.toggle(element) > ' + this.element.name, variantKeys);
      var matches = this.element.children.filter(function (child) {
        if (child.variant) {
          var isMatch = true;
          variantKeys.forEach(function (key) {
            var value = child.variant[key];
            isMatch &= value === _this.$parent.$props[key];
          });
          return isMatch;
        }

        return false;
      });
      return matches;
    },
    getPresentPropertyKeys: function getPresentPropertyKeys() {
      var _this2 = this;

      if (this.element && this.element.children.length > 1) {
        /**
         * Assume the first child has all variants
         */
        var firstChild = this.element.children[0];

        if (firstChild.variant) {
          return Object.keys(firstChild.variant).filter(function (key) {
            var value = _this2.$parent.$props[key];
            return value !== undefined;
          });
        }
      }

      return [];
    },
    getMatchByProps: function getMatchByProps() {
      var _this3 = this;

      var matches = this.element.children.filter(function (child) {
        if (child.variant) {
          var isMatch = true;

          for (var key in child.variant) {
            var value = child.variant[key];
            isMatch &= value === _this3.$parent.$props[key];
          }

          return isMatch;
        }

        return false;
      });
      return matches;
    },
    getValue: function getValue() {
      return this.isActive;
    },
    forwardClick: function forwardClick(element, e, value) {
      this.$emit('qClick', element, e, value);
    },
    forwardChange: function forwardChange(element, e, value) {
      this.$emit('qChange', element, e, value);
    },
    forwardFocus: function forwardFocus(element, e, value) {
      this.$emit('qFocus', element, e, value);
    },
    forwardBlur: function forwardBlur(element, e, value) {
      this.$emit('qBlur', element, e, value);
    },
    forwardMouseOver: function forwardMouseOver(element, e, value) {
      this.$emit('qMouseOver', element, e, value);
    },
    forwardMouseOut: function forwardMouseOut(element, e, value) {
      this.$emit('qMouseOut', element, e, value);
    },
    forwardKeyPress: function forwardKeyPress(element, e, value) {
      this.$emit('qKeyPress', element, e, value);
    },
    forwardCallback: function forwardCallback(element, e, value) {
      this.$emit('qCallback', element, e, value);
    }
  },
  mounted: function mounted() {// console.debug('ComponentSet.mounted()', this.element.name, this.label, this.element)
  }
};

/* script */
var __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['qux-compoment-set', _vm.cssClass],
    on: {
      "click": _vm.toggle
    }
  }, [_vm.selectedChild ? [_c(_vm.selectedChild.qtype, {
    key: _vm.selectedChild.id,
    tag: "component",
    attrs: {
      "element": _vm.selectedChild,
      "model": _vm.model,
      "config": _vm.config
    },
    on: {
      "qDesignSystemCallback": _vm.forwardDesignSystemCallback,
      "qCallback": _vm.forwardCallback,
      "qClick": _vm.forwardClick,
      "qChange": _vm.forwardChange,
      "qKeyPress": _vm.forwardKeyPress,
      "qFocus": _vm.forwardFocus,
      "qBlur": _vm.forwardBlur,
      "qMouseOver": _vm.forwardMouseOver,
      "qMouseOut": _vm.forwardMouseOut
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })] : [_vm._v("\n        " + _vm._s(_vm.qErrorMessage) + "\n    ")]], 2);
};

var __vue_staticRenderFns__$C = [];
/* style */

var __vue_inject_styles__$C = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-06cc34ca_0", {
    source: ".qux-compoment-set{border-style:solid;border-width:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$C = undefined;
/* module identifier */

var __vue_module_identifier__$C = undefined;
/* functional template */

var __vue_is_functional_template__$C = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, createInjector, undefined, undefined);

var QUXDesignSystem = /*#__PURE__*/function () {
  function QUXDesignSystem() {
    _classCallCheck(this, QUXDesignSystem);

    this.server = 'https://quant-ux.com';
    this.components = {};
  }

  _createClass(QUXDesignSystem, [{
    key: "register",
    value: async function register(app) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var hasComponentSet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      Logger$1.log(2, "QUXDesignSystem.register()", app);

      if (app.substring) {
        config.imageFolder = "".concat(this.server, "/rest/images/").concat(app, "/");
        app = await this.loadAppByKey(app);
      }

      config.addDefaultDatabinding = false;
      this.onAppLoaded(app, Config$1.merge(Config$1.getDefault(), config), hasComponentSet);
    }
  }, {
    key: "onAppLoaded",
    value: function onAppLoaded(app, config, hasComponentSet) {
      var _this = this;

      Logger$1.log(3, "QUXDesignSystem.onAppLoaded() > enter", app, config);
      var start = new Date().getTime();
      var prefix = config.designletPrefix ? config.designletPrefix : '';
      /**
       * Build tree
       */

      var transformer = new ModelTransformer(app, config);
      var tree = transformer.transform();
      /**
       * Make nicer css. Also add here a parametert to convert
       * vertAlign to padding
       */

      tree = new CSSOptimizer(config).runTree(tree, true);
      /**
       * Register all qWidget to VUE. This oculd be still smarter...
       */

      this.initComponents();
      var cssFactory = new CSSFactory(config, config.imageFolder);
      /**
       * Take all first level screen children
       */

      tree.screens.forEach(function (screen) {
        screen.children.forEach(function (widget) {
          _this.registerElement(app, widget, config, cssFactory, hasComponentSet, prefix);
        });
      });
      /**
       * ToDO: Create all templates
       */

      var stop = new Date().getTime();
      Logger$1.log(-1, "DesignSystem.onAppLoaded() > exit", stop - start);
    }
  }, {
    key: "registerElement",
    value: function registerElement(app, element, config, cssFactory, hasComponentSet, prefix) {
      Logger$1.log(-1, "QUXDesignSystem.registerElement() > enter", "<".concat(prefix).concat(element.name, ">/"));
      var props = ['label', 'value', 'options', 'href'];

      if (hasComponentSet && isComponentSet(element)) {
        this.fixComponentSet(element, props);
      }

      this.components["".concat(prefix).concat(element.name)] = {
        name: "".concat(prefix).concat(element.name),
        element: element
      };
      /**
        * Set flag for special handling and reset the cssSelectors
        */

      element.isDesignSystemRoot = true;
      /**
       * Here we create dynamicaly the qWidget that is needed! we also map our internal
       * property names to nice onces, like 'lbl' => 'label'
       */

      Vue__default['default'].component(prefix + element.name, {
        props: props,
        data: function data() {
          return {
            count: 0
          };
        },
        render: function render(createElement) {
          return createElement(element.qtype, {
            props: {
              element: element,
              model: app,
              lbl: this.label,
              value: this.value,
              url: this.href,
              optionList: this.options
            }
          }, this.$slots.default);
        }
      });
      this.createCSS(app, element, config, cssFactory);
    }
  }, {
    key: "fixComponentSet",
    value: function fixComponentSet(element, props) {
      element.qtype = 'qComponentSet';
      element.type = 'ComponentSet';

      if (element.children && element.children.length > 0) {
        var child = element.children[0];

        if (child.variant) {
          Object.keys(child.variant).forEach(function (key) {
            if (props.indexOf(key) === -1) {
              props.push(key);
            }
          });
        }

        Logger$1.log(3, "QUXDesignSystem.fixComponentSet() > component set", "<".concat(element.name, " >/"), props);
      }
    }
  }, {
    key: "createCSS",
    value: function createCSS(app, element, config, cssFactory) {
      Logger$1.log(4, "QUXDesignSystem.createCSS() > register", element.name);
      /**
       * Reset all css selectord
       */

      setCSSClassNames(element, element.cssClass);
      element.cssSelector = '.' + element.cssClass;
      var classes = cssFactory.generateDesignSystemRoot(element);
      var css = [];
      css = Object.values(classes).flatMap(function (element) {
        return element.map(function (e) {
          return e.code;
        });
      });
      css = css.join('\n');
      CSSWriter$1.write(css, app.id + '-' + element.id);
    }
  }, {
    key: "loadAppByKey",
    value: async function loadAppByKey(key) {
      Logger$1.log(2, "QUXDesignSystem.loadAppByKey() > enter", key);
      var url = "".concat(this.server, "/rest/invitation/").concat(key, "/app.json");
      var start = new Date().getTime();
      var response = await fetch(url);

      if (response.status === 200) {
        var app = await response.json();
        Logger$1.log(-1, "QUXDesignSystem.loadAppByKey() > exit", new Date().getTime() - start);
        return app;
      } else {
        Logger$1.error("QUXDesignSystem.loadAppByKey() > Could not load");
      }
    }
  }, {
    key: "mergeConfig",
    value: function mergeConfig(conf) {
      if (!conf.imageFolder) {
        conf.imageFolder = '/img/';
      }

      return conf;
    }
  }, {
    key: "initComponents",
    value: function initComponents() {
      Vue__default['default'].component('qHotSpot', __vue_component__$1);
      Vue__default['default'].component('qButton', __vue_component__$1);
      Vue__default['default'].component('qBox', __vue_component__$1);
      Vue__default['default'].component('qLabel', __vue_component__$2);
      Vue__default['default'].component('qContainer', __vue_component__$5);
      Vue__default['default'].component('qIcon', __vue_component__$3);
      Vue__default['default'].component('qTextBox', __vue_component__$4);
      Vue__default['default'].component('qPassword', __vue_component__$4);
      Vue__default['default'].component('qTextArea', __vue_component__$g);
      Vue__default['default'].component('qRepeater', __vue_component__$6);
      Vue__default['default'].component('qImage', __vue_component__$7);
      Vue__default['default'].component('qCheckBox', __vue_component__$8);
      Vue__default['default'].component('qRadioBox', __vue_component__$a);
      Vue__default['default'].component('qRadioBox2', __vue_component__$a);
      Vue__default['default'].component('qRadioGroup', __vue_component__$b);
      Vue__default['default'].component('qCheckBoxGroup', __vue_component__$9);
      Vue__default['default'].component('qToggleButton', __vue_component__$c);
      Vue__default['default'].component('qSwitch', __vue_component__$d);
      Vue__default['default'].component('qDropDown', __vue_component__$f);
      Vue__default['default'].component('qMobileDropDown', __vue_component__$f);
      Vue__default['default'].component('qStepper', __vue_component__$h);
      Vue__default['default'].component('qHSlider', __vue_component__$i);
      Vue__default['default'].component('qDate', __vue_component__$j);
      Vue__default['default'].component('qDateDropDown', __vue_component__$k);
      Vue__default['default'].component('qSegmentButton', __vue_component__$l);
      Vue__default['default'].component('qRating', __vue_component__$m);
      Vue__default['default'].component('qIconToggle', __vue_component__$n);
      Vue__default['default'].component('qLabeledIconToggle', __vue_component__$n);
      Vue__default['default'].component('qTypeAheadTextBox', __vue_component__$o);
      Vue__default['default'].component('qTable', __vue_component__$p);
      Vue__default['default'].component('qPaging', __vue_component__$q);
      Vue__default['default'].component('qBarChart', __vue_component__$r);
      Vue__default['default'].component('qPieChart', __vue_component__$r);
      Vue__default['default'].component('qMultiRingChart', __vue_component__$r);
      Vue__default['default'].component('qRingChart', __vue_component__$r);
      Vue__default['default'].component('qVector', __vue_component__$s);
      Vue__default['default'].component('qTimeline', __vue_component__$t);
      Vue__default['default'].component('qUpload', __vue_component__$u);
      Vue__default['default'].component('qCamera', __vue_component__$v);
      Vue__default['default'].component('qChildrenToggle', __vue_component__$x);
      Vue__default['default'].component('qUploadPreview', __vue_component__$w);
      Vue__default['default'].component('qComponentSet', __vue_component__$C);
    }
  }]);

  return QUXDesignSystem;
}();

var QUXDesignSystem$1 = new QUXDesignSystem();

var FigmaDesignSystem = /*#__PURE__*/function () {
  function FigmaDesignSystem() {
    _classCallCheck(this, FigmaDesignSystem);
  }

  _createClass(FigmaDesignSystem, [{
    key: "register",
    value: async function register(figmaFile, figmaAccessKey, config) {
      Logger$1.log(-1, "DesignSystem.register()", figmaFile);
      var app = figmaFile;

      if (figmaFile && figmaAccessKey) {
        var figmaService = new FigmaService(figmaAccessKey);
        app = await figmaService.get(figmaFile, true);
        app = figmaService.setBackgroundImages(app);
      }
      /**
       * Pass here also the hasComponentSet = true!
       */


      return QUXDesignSystem$1.register(app, config, true);
    }
  }]);

  return FigmaDesignSystem;
}();

var FigmaDesignSystem$1 = new FigmaDesignSystem();

var index = {
  install: function install(Vue) {
    Vue.component("QUX", __vue_component__$A);
    Vue.component("Figma", __vue_component__$B);
  }
};
function createFigmaService(key) {
  return new FigmaService(key);
}
function setLogLevel(level) {
  Logger$1.setLogLevel(level);
}
async function createFigmaDesignlets(figmaFile, figmaAcessKey, config) {
  return FigmaDesignSystem$1.register(figmaFile, figmaAcessKey, config);
}
async function createFigmaDesignSystem(figmaFile, figmaAcessKey, config) {
  return FigmaDesignSystem$1.register(figmaFile, figmaAcessKey, config);
}
async function createQUXDesignlets(app, config) {
  return QUXDesignSystem$1.register(app, config);
}
async function createQUXDesignSystem(app, config) {
  return QUXDesignSystem$1.register(app, config);
}
function getDesignSystem() {
  return QUXDesignSystem$1;
}

exports.createFigmaDesignSystem = createFigmaDesignSystem;
exports.createFigmaDesignlets = createFigmaDesignlets;
exports.createFigmaService = createFigmaService;
exports.createQUXDesignSystem = createQUXDesignSystem;
exports.createQUXDesignlets = createQUXDesignlets;
exports.default = index;
exports.getDesignSystem = getDesignSystem;
exports.setLogLevel = setLogLevel;
